
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("cDpdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eRn3r = parcelRequire("eRn3r");


const $2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("9YWvS")));
const $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $2a3e0a8082e0a83e$export$5057fa778edd8de9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props, config)=>{
    const $ = (0, $bDgLe.c)(11);
    const shouldMergeAdditionalPlugins = props?.shouldMergeAdditionalPlugins ?? false;
    let t0;
    if ($[0] !== config || $[1] !== shouldMergeAdditionalPlugins) {
        t0 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config,
                shouldMergeAdditionalPlugins: shouldMergeAdditionalPlugins
            });
        $[0] = config;
        $[1] = shouldMergeAdditionalPlugins;
        $[2] = t0;
    } else t0 = $[2];
    const WrapperComponent = t0;
    let t1;
    if ($[3] !== props) {
        t1 = props ?? {};
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    let linkPickerProps;
    if ($[5] !== t1) {
        const { shouldMergeAdditionalPlugins: _shouldMergeAdditionalPlugins, ...t2 } = t1;
        linkPickerProps = t2;
        $[5] = t1;
        $[6] = linkPickerProps;
    } else linkPickerProps = $[6];
    const t2 = shouldMergeAdditionalPlugins && props?.plugins?.length ? props.plugins : $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS;
    let t3;
    if ($[7] !== WrapperComponent || $[8] !== linkPickerProps || $[9] !== t2) {
        t3 = {
            ...linkPickerProps,
            plugins: t2,
            component: WrapperComponent
        };
        $[7] = WrapperComponent;
        $[8] = linkPickerProps;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (props, config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const shouldMergeAdditionalPlugins = props?.shouldMergeAdditionalPlugins ?? false;
    const WrapperComponent = (0, $cozmU.useMemo)(()=>(props_0)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config,
                shouldMergeAdditionalPlugins: shouldMergeAdditionalPlugins
            });
        }, [
        config,
        shouldMergeAdditionalPlugins
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const { shouldMergeAdditionalPlugins: _shouldMergeAdditionalPlugins, ...linkPickerProps } = props ?? {};
        return {
            ...linkPickerProps,
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: shouldMergeAdditionalPlugins && props?.plugins?.length ? props.plugins : $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props,
        shouldMergeAdditionalPlugins
    ]);
};
module.exports["useLinkPickerEditorProps"] = $2a3e0a8082e0a83e$export$5057fa778edd8de9;

});

parcelRegister("9YWvS", function(module, exports) {

let $74471b25620b8095$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $74471b25620b8095$var$load("hS8gF"),
    $74471b25620b8095$var$load("6wr18"),
    $74471b25620b8095$var$load("g8A75"),
    $74471b25620b8095$var$load("4AElS"),
    $74471b25620b8095$var$load("ffEVr"),
    $74471b25620b8095$var$load("kUh5E"),
    $74471b25620b8095$var$load("h3I4k"),
    $74471b25620b8095$var$load("fmCjo")
]).then(()=>parcelRequire('et6nL'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("40ukF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $bI2nS = parcelRequire("bI2nS");


var $jGK9e = parcelRequire("jGK9e");


var $k3XQC = parcelRequire("k3XQC");


var $ao034 = parcelRequire("ao034");


var $2WEO5 = parcelRequire("2WEO5");


var $cMyWi = parcelRequire("cMyWi");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $mW7G5 = parcelRequire("mW7G5");


var $azoPw = parcelRequire("azoPw");


var $8Dx7s = parcelRequire("8Dx7s");




const $dc39c5d622176d3d$export$f664dd11022c8749 = ()=>{
    const blockCardNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $azoPw.blockCardWithLocalId) : (0, $azoPw.blockCard);
    return {
        ...blockCardNode,
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap',
                ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};


/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $dtmRZ = parcelRequire("dtmRZ");





var $7Y8M5 = parcelRequire("7Y8M5");




// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $75ce2aa51e74c7ef$var$LINE_LENGTH = 760;
const $75ce2aa51e74c7ef$export$f8faabd3267a007e = ()=>{
    const embedCardNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $dtmRZ.embedCardWithLocalId) : (0, $dtmRZ.embedCard);
    return {
        ...embedCardNode,
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $8Dx7s.convertToInlineCss)({
                    margin: $75ce2aa51e74c7ef$var$calcMargin(layout),
                    width: `${Math.ceil($75ce2aa51e74c7ef$var$calcPxFromPct(width / 100, $75ce2aa51e74c7ef$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $75ce2aa51e74c7ef$var$float(layout)
                }),
                ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};



var $dYkuB = parcelRequire("dYkuB");







const $7e11113c0b6b9b64$export$290edac762b9f37c = ()=>{
    const inlineCardNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $dYkuB.inlineCardWithLocalId) : (0, $dYkuB.inlineCard);
    return {
        ...inlineCardNode,
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $8Dx7s.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-radius-small, 4px)",
                    color: "var(--ds-link, #1868DB)",
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                }),
                ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};



var $kCECX = parcelRequire("kCECX");

const $ab0973bc4ada0879$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('cardPlugin');


const $28eb8ceae9a9c979$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1), action);
};
const $28eb8ceae9a9c979$export$2b7045d36e3e01d4 = (url)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $28eb8ceae9a9c979$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $28eb8ceae9a9c979$export$af5afab36c1f83f6 = (info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $28eb8ceae9a9c979$export$3301f76e6efaf85e = (info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $28eb8ceae9a9c979$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $28eb8ceae9a9c979$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $28eb8ceae9a9c979$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $28eb8ceae9a9c979$export$63a1bdeb24c4dd9f = (url, attributes)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_RESOLVED_TOOLBAR_ATTRIBUTES',
            url: url,
            attributes: attributes
        });
const $28eb8ceae9a9c979$export$c9a25858ed46807c = (layout)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $28eb8ceae9a9c979$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $28eb8ceae9a9c979$export$83c364d103479f90 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $28eb8ceae9a9c979$export$bd1cd60a9b31da5e = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $28eb8ceae9a9c979$export$2c79f54b873d04be = (modalType)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $28eb8ceae9a9c979$export$e545bc176b552938 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $28eb8ceae9a9c979$export$a2922c2e95ff48f7 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $28eb8ceae9a9c979$export$53e36aa41bbce673 = (tr, datasourceStash)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $28eb8ceae9a9c979$export$4b1fde77584594b5 = (tr, url)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });



var $3u5lg = parcelRequire("3u5lg");


var $73a6g = parcelRequire("73a6g");


var $krYZG = parcelRequire("krYZG");

var $gjFO5 = parcelRequire("gjFO5");

var $eaCAt = parcelRequire("eaCAt");


var $2HZqG = parcelRequire("2HZqG");


var $9bUBT = parcelRequire("9bUBT");


var $fRYCB = parcelRequire("fRYCB");

var $4wRTw = parcelRequire("4wRTw");

var $6SJ6d = parcelRequire("6SJ6d");

var $5Qi6J = parcelRequire("5Qi6J");








var $2Ldzs = parcelRequire("2Ldzs");


var $jkcNT = parcelRequire("jkcNT");




var $hXiLX = parcelRequire("hXiLX");


var $h6b2D = parcelRequire("h6b2D");

function $0462314fb21236fe$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $hXiLX.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $hXiLX.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $hXiLX.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}



var $aPdNQ = parcelRequire("aPdNQ");





var $k92Y1 = parcelRequire("k92Y1");








var $b1qV0 = parcelRequire("b1qV0");


const $50d9c959a343ad0a$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $50d9c959a343ad0a$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $kCECX.NodeSelection)) return $50d9c959a343ad0a$export$71376de76fa352d1(state.selection.node.type);
};
const $50d9c959a343ad0a$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $50d9c959a343ad0a$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $50d9c959a343ad0a$export$a6fcef6250c64f76 = (node, info)=>$50d9c959a343ad0a$export$fe497395c317d106($50d9c959a343ad0a$export$15bc29504ff06986(node), info);
const $50d9c959a343ad0a$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $50d9c959a343ad0a$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $50d9c959a343ad0a$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$50d9c959a343ad0a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $50d9c959a343ad0a$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$50d9c959a343ad0a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $50d9c959a343ad0a$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $k92Y1.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $50d9c959a343ad0a$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $50d9c959a343ad0a$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $50d9c959a343ad0a$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $50d9c959a343ad0a$export$48ba7bd006cffb5e(node.attrs);
};
const $50d9c959a343ad0a$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $50d9c959a343ad0a$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $50d9c959a343ad0a$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $50d9c959a343ad0a$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $kCECX.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};


/**
 * Attempt to replace the link into the respective card.
 */ function $ff2860869594b73b$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $73a6g.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $0462314fb21236fe$export$f85e921f66e987fa)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)($head);
    if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
        // Add the annotation mark on to the inlineCard node and the trailing space node.
        tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
    });
    return $pos.node($pos.depth - 1).type.name;
}
const $ff2860869594b73b$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>(editorState, dispatch)=>{
        const state = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        let cardAdf = null;
        // If an embed card transformer is provided and the resolved card is an embedCard,
        // attempt to transform it into an alternative node representation first.
        if (cardData.type === 'embedCard' && embedCardNodeTransformer && (0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience')) {
            const transformResult = embedCardNodeTransformer(schema, cardData.attrs);
            // The transformer may return a Promise for async transformations (e.g. short-link expansion).
            // When async, we snapshot the current requests and positions now (before any dispatch),
            // then insert the resolved node and clean up the queue in one transaction once the
            // Promise settles. This avoids the stale-editorState problem: rather than re-running
            // replaceQueuedUrlWithCard with an outdated state snapshot, we capture what we need
            // immediately and apply a targeted insert when ready.
            if (transformResult instanceof Promise) {
                // Snapshot requests now, while the queue still contains this URL.
                const pendingRequests = [
                    ...requests
                ];
                transformResult.then((resolvedNode)=>{
                    if (!dispatch) return;
                    // Build a fresh transaction (editorState is the snapshot at call-time; positions
                    // are mapped through it). For the async case we fall back to cardData if the
                    // transform returned nothing, mirroring what the sync path would do.
                    const asyncCardAdf = resolvedNode ? resolvedNode : (0, $5Qi6J.processRawValue)(schema, cardData) ?? null;
                    const asyncTr = editorState.tr;
                    if (asyncCardAdf) pendingRequests.forEach((request)=>$ff2860869594b73b$var$replaceLinksToCards(asyncTr, asyncCardAdf, schema, request));
                    dispatch((0, $28eb8ceae9a9c979$export$2b7045d36e3e01d4)(url)((0, $2Ldzs.closeHistory)(asyncTr)));
                });
                return true;
            }
            cardAdf = transformResult ?? null;
        }
        if (!cardAdf) cardAdf = (0, $5Qi6J.processRawValue)(schema, cardData) ?? null;
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$ff2860869594b73b$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $4wRTw.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $2HZqG.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $28eb8ceae9a9c979$export$2b7045d36e3e01d4)(url)((0, $2Ldzs.closeHistory)(tr)));
        return true;
    };
const $ff2860869594b73b$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $krYZG.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $4wRTw.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $28eb8ceae9a9c979$export$2b7045d36e3e01d4)(request.url)(tr));
        return true;
    };
/**
 * Per-node walker shared by `queueCardsFromChangedTr` and
 * `queueCardsFromRange`. Pushes a smart-link resolution request for every
 * text node carrying a qualifying `link` mark.
 *
 * Returning `true`/`false` follows the ProseMirror `nodesBetween`/
 * `nodesBetweenChanged` walker contract: `true` to descend into children,
 * `false` to skip subtree.
 */ const $ff2860869594b73b$var$collectLinkRequest = (requests, node, pos, options)=>{
    if (!node.isText) return true;
    const linkMark = node.marks.find((mark)=>mark.type === options.linkMarkType);
    if (linkMark) {
        if (!(0, $0462314fb21236fe$export$f85e921f66e987fa)(node, options.normalizeLinkText)) return false;
        requests.push({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: options.appearance,
            compareLinkText: options.normalizeLinkText,
            source: options.source,
            analyticsAction: options.analyticsAction,
            sourceEvent: options.sourceEvent
        });
    }
    return false;
};
const $ff2860869594b73b$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    (0, $6SJ6d.nodesBetweenChanged)(tr, (node, pos)=>$ff2860869594b73b$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(tr);
};
const $ff2860869594b73b$export$86b4b08ffadfa0a6 = (state, tr, from, to, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    const clampedFrom = Math.max(0, from);
    const clampedTo = Math.min(tr.doc.content.size, to);
    if (clampedFrom < clampedTo) tr.doc.nodesBetween(clampedFrom, clampedTo, (node, pos)=>$ff2860869594b73b$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(tr);
};
const $ff2860869594b73b$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $6SJ6d.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $0462314fb21236fe$export$f85e921f66e987fa)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(tr);
};
const $ff2860869594b73b$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $krYZG.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
        const activeLinkMark = (0, $9bUBT.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $2HZqG.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $krYZG.ACTION).CHANGED_TYPE
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(state.tr);
};
const $ff2860869594b73b$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos !== undefined) tr = $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href);
        $ff2860869594b73b$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $gjFO5.SMART_LINK_TYPE).URL,
                    previousType: (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $ff2860869594b73b$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos !== undefined) tr = $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.setMeta('addToHistory', false));
        return true;
    };
const $ff2860869594b73b$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $50d9c959a343ad0a$export$a5ff7aecd33e6813)(state);
        const tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, href, href);
        $ff2860869594b73b$export$717aabd99c4fc685(state, tr, (0, $krYZG.INPUT_METHOD).MANUAL, (0, $krYZG.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $ff2860869594b73b$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                action: (0, $krYZG.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.unlinkPayload)((0, $krYZG.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $ff2860869594b73b$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $ff2860869594b73b$export$c8301558911030d4(state, (0, $krYZG.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                    action: (0, $krYZG.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = $ff2860869594b73b$export$85bb3e53350e35b8(appearance, selectedNode, state.selection.$from.parent.type.name === 'bodiedSyncBlock');
        const { from: from, to: to } = state.selection;
        const nodeType = $ff2860869594b73b$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        // If switching to embed appearance, attempt to use a registered transform command
        // to create an alternative node representation (e.g. a native embed).
        if (appearance === 'embed' && (selectedNode.attrs.url || selectedNode.attrs.data?.url)) {
            const cardState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
            const createEmbedCardTransformCommand = cardState?.embedCardTransformers?.createEmbedCardTransformCommand;
            if (createEmbedCardTransformCommand) {
                const transformCommand = createEmbedCardTransformCommand({
                    editorAnalyticsApi: editorAnalyticsApi,
                    augmentTransaction: (augmentTr)=>{
                        $ff2860869594b73b$var$updateDatasourceStash(augmentTr, selectedNode);
                        editorAnalyticsApi?.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).CHANGED_TYPE,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            attributes: {
                                newType: appearance,
                                previousType: (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type)
                            }
                        })(augmentTr);
                        (0, $2HZqG.addLinkMetadata)(state.selection, augmentTr, {
                            action: (0, $krYZG.ACTION).CHANGED_TYPE
                        });
                    }
                });
                if (transformCommand(state, dispatch)) return true;
            }
        }
        $ff2860869594b73b$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).CHANGED_TYPE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type)
            }
        })(tr);
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            action: (0, $krYZG.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $ff2860869594b73b$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $ff2860869594b73b$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: (0, $krYZG.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $28eb8ceae9a9c979$export$4b1fde77584594b5)(tr, node.attrs.url);
    } else (0, $28eb8ceae9a9c979$export$e545bc176b552938)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $ff2860869594b73b$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $28eb8ceae9a9c979$export$e545bc176b552938)(tr);
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: (0, $krYZG.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $ff2860869594b73b$export$85bb3e53350e35b8 = (appearance, selectedNode, isInsideBodiedSyncBlock = false)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center',
        ...isInsideBodiedSyncBlock ? // For editor, width is not required to render the embed card, but it's required in renderer
        // Because sync block has nested renderer in editor, we need width to be defined even in editor so embed in reference sync block can be rendered properly
        {
            width: selectedNode.attrs.width ?? 100
        } : {}
    };
    if ((0, $50d9c959a343ad0a$export$962cfe99b8da8614)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $ff2860869594b73b$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $50d9c959a343ad0a$export$962cfe99b8da8614)(selectedNode) && !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $28eb8ceae9a9c979$export$53e36aa41bbce673)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};



var $8dxef = parcelRequire("8dxef");


var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");





var $bjg0G = parcelRequire("bjg0G");

const $1ddf8f052569320c$var$lookupPixel = 10;
const $1ddf8f052569320c$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $bjg0G.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $1ddf8f052569320c$var$lookupPixel : coord.bottom + $1ddf8f052569320c$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $bjg0G.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $1ddf8f052569320c$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $1ddf8f052569320c$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $kCECX.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $1ddf8f052569320c$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    const browser = (0, $8dxef.getBrowserInfo)();
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if (browser.chrome && browser.chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveUp).common, $1ddf8f052569320c$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $1ddf8f052569320c$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $44cyU.keymap)(list);
}



var $LQnOI = parcelRequire("LQnOI");


var $4iudd = parcelRequire("4iudd");


var $3k3tn = parcelRequire("3k3tn");


var $kpCD8 = parcelRequire("kpCD8");

const $64861730f5bb867e$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $64861730f5bb867e$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';









var $bwuOg = parcelRequire("bwuOg");











var $03RpJ = parcelRequire("03RpJ");





var $Igylv = parcelRequire("Igylv");


var $1jz5K = parcelRequire("1jz5K");

var $KTiWz = parcelRequire("KTiWz");





var $iIYTj = parcelRequire("iIYTj");


var $l8wPz = parcelRequire("l8wPz");


var $QXwxo = parcelRequire("QXwxo");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $6U5OC = parcelRequire("6U5OC");


var $3F4bj = parcelRequire("3F4bj");


var $h9Lux = parcelRequire("h9Lux");


var $aK1EY = parcelRequire("aK1EY");


var $f7XUl = parcelRequire("f7XUl");


var $10uVA = parcelRequire("10uVA");







/* eslint-disable @repo/internal/react/no-class-components */ 









var $fbHl6 = parcelRequire("fbHl6");


class $2a1fa379fa79b714$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $73a6g.isSafeUrl)(url)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fbHl6.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error,
                children: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('inline', undefined)(view.state, view.dispatch)
            });
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(UnsupportedComponent, {}) : null;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fbHl6.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error,
                    children: unsupportedComponent
                });
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isError: false,
            error: null
        };
    }
}





parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $6pnwK = parcelRequire("6pnwK");


const $82719199149a05f4$export$f05434c51e3762e = (editorState)=>(0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
const $82719199149a05f4$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            })),
        resolvedInlineSmartLinks: pluginState.resolvedInlineSmartLinks?.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $82719199149a05f4$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$82719199149a05f4$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $82719199149a05f4$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;


const $82bb9aba23fa33e9$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $82719199149a05f4$export$f05434c51e3762e)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: analyticsData,
        children: children
    });
};


const $22640694ffeeb016$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $22640694ffeeb016$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $22640694ffeeb016$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $10uVA.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $82bb9aba23fa33e9$export$b49e513cc101a4b6), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f7XUl.EditorSmartCardProvider), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aK1EY.DatasourceTableViewWithWrappers), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                onWrappedColumnsChange: (0, $iDrrr.fg)('platform_lp_sllv_table_settings_menu') ? this.handleWrappedColumnsChange : undefined,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
    constructor(props){
        super(props);
        this.getDatasource = ()=>this.props.node.attrs.datasource;
        this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        };
        this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        };
        this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        };
        this.handleWrappedColumnsChange = (wrappedColumnKeys)=>{
            const { columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
}
class $22640694ffeeb016$export$9dd55813d0ee0514 extends (0, $Igylv.default) {
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $6U5OC.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2a1fa379fa79b714$export$76664c71b9b1a689), {
            unsupportedComponent: (0, $3F4bj.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $64861730f5bb867e$export$32f80df830e375f6),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $h9Lux.calcBreakoutWidth)(attrs.layout || (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($22640694ffeeb016$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.tableWidth = void 0;
        this.isNodeNested = void 0;
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
}







parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");







function $59ddef7452a84f28$export$d59258481d10b16b({ smartCardContext: smartCardContext, children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)()) return children;
    if (!intl || !smartCardContext) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
        value: intl,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cMyWi.SmartCardContext).Provider, {
            value: smartCardContext,
            children: children
        })
    });
}















var $3k5Tv = parcelRequire("3k5Tv");





var $i1t43 = parcelRequire("i1t43");







parcelRequire("cozmU");


var $9f1Yt = parcelRequire("9f1Yt");

const $83d2b8785968bed7$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children(cardContext)
    });
};


const $537b6f07c48b0136$var$fatalErrorPositionMap = new Map();
const $537b6f07c48b0136$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children })=>{
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>{
        return {
            mode: states.editorViewModeState?.mode
        };
    });
    const onClick = (0, $cozmU.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children({
            onClick: allowNavigation ? undefined : onClick
        })
    });
};
function $537b6f07c48b0136$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $50d9c959a343ad0a$export$15bc29504ff06986)(this.props.node);
            if (url && !(0, $73a6g.isSafeUrl)(url)) return /*#__PURE__*/ (0, $8aG6j.jsx)(UnsupportedComponent, {});
            if (this.state.isError) {
                if (url) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                    href: url,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                });
                else return /*#__PURE__*/ (0, $8aG6j.jsx)(UnsupportedComponent, {});
            }
            const editorAppearance = (0, $82719199149a05f4$export$f05434c51e3762e)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($537b6f07c48b0136$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    children: ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $83d2b8785968bed7$export$722ea04dd4ef208e), {
                            children: (cardContext)=>/*#__PURE__*/ (0, $8aG6j.jsx)(SmartCardComponent, {
                                    cardContext: cardContext,
                                    ...this.props,
                                    onClick: onClick
                                }, url)
                        })
                })
            });
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $50d9c959a343ad0a$export$15bc29504ff06986)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                const pos = getPos();
                /**
         * We cache fatal errors by position to avoid retrying the same errors
         * on the same links at the same position.
         */ if (url && pos && $537b6f07c48b0136$var$fatalErrorPositionMap.get(url) === pos) return null;
                (0, $ff2860869594b73b$export$56a04318a610dc7c)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                if (url && pos) $537b6f07c48b0136$var$fatalErrorPositionMap.set(url, pos);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isError: false
            };
        }
    };
}


class $6ee1e0f18b66d961$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $28eb8ceae9a9c979$export$3301f76e6efaf85e)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = isPageSSRed ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QXwxo.CardSSR), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt,
                    hideIconLoadingSkeleton: true
                }, url),
                this.gapCursorSpan()
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt
                }, url),
                this.gapCursorSpan()
            ]
        });
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).BLOCK,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                children: cardContext && cardContext.value ? /*#__PURE__*/ (0, $8aG6j.jsx)(cardContext.Provider, {
                    value: cardContext.value,
                    children: cardInner
                }) : data ? cardInner : null
            })
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $LQnOI.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $28eb8ceae9a9c979$export$af5afab36c1f83f6)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
        };
        this.removeCardDispatched = false;
        this.gapCursorSpan = ()=>{
            const browser = (0, $8dxef.getBrowserInfo)();
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if (browser.ie && browser.ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                contentEditable: true
            });
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.scrollContainer = (0, $1jz5K.findOverflowScrollParent)(props.view.dom) || undefined;
    }
}
const $6ee1e0f18b66d961$var$WrappedBlockCard = (0, $537b6f07c48b0136$export$60332b2344f7fe41)($6ee1e0f18b66d961$export$780882fb750d3c8d, (0, $KTiWz.default));
class $6ee1e0f18b66d961$export$d18ccd25c0d2c6b0 extends (0, $Igylv.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $50d9c959a343ad0a$export$962cfe99b8da8614)(currentNode);
        const isNewNodeDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59ddef7452a84f28$export$d59258481d10b16b), {
            intl: intl,
            smartCardContext: smartCardContext,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($6ee1e0f18b66d961$var$WrappedBlockCard, {
                node: this.node,
                view: this.view,
                getPos: this.getPos,
                actionOptions: actionOptions,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                id: this.id,
                CompetitorPrompt: CompetitorPrompt,
                isPageSSRed: isPageSSRed,
                provider: provider
            })
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, $03RpJ.default)();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $6ee1e0f18b66d961$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: intl,
            smartCardContext: smartCardContext
        };
        const isDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $k3XQC.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $22640694ffeeb016$export$9dd55813d0ee0514)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $6ee1e0f18b66d961$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };















var $1A89X = parcelRequire("1A89X");


var $8kONW = parcelRequire("8kONW");










var $aHoC6 = parcelRequire("aHoC6");




var $4Qu9h = parcelRequire("4Qu9h");


var $4mCw6 = parcelRequire("4mCw6");

var $jsWW5 = parcelRequire("jsWW5");











var $8m50u = parcelRequire("8m50u");




var $11zX6 = parcelRequire("11zX6");





var $anBbz = parcelRequire("anBbz");





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $89gPK = parcelRequire("89gPK");

var $b8ZJI = parcelRequire("b8ZJI");

var $76kDm = parcelRequire("76kDm");

var $e3qgT = parcelRequire("e3qgT");

var $bfl0n = parcelRequire("bfl0n");

var $fb9eF = parcelRequire("fb9eF");

var $3GQSw = parcelRequire("3GQSw");

var $h5qPS = parcelRequire("h5qPS");

var $34CLe = parcelRequire("34CLe");
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $hNvnn = parcelRequire("hNvnn");

const $5cc79e9089d815ff$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("&>div{", (0, $hNvnn.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");


















var $ieeJu = parcelRequire("ieeJu");

// Layouts where the left handle is the only resize handle today.
// These must keep the left handle.
// Remove during 'platform_editor_lovability_resize_dividers_panels' cleanup
const $a88eb3a81715ccd0$var$leftHandleOnlyLayouts = [
    'wrap-right',
    'align-end'
];
class $a88eb3a81715ccd0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $34CLe.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $34CLe.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $7Y8M5.breakoutWideScaleRatio));
        else return 0, $7Y8M5.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $e3qgT.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $e3qgT.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $7Y8M5.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $11zX6.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $7Y8M5.akEditorMediaResizeHandlerPadding)
        };
        const isLeftResizeHandleDisabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
        const enable = {};
        (0, $bfl0n.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && !$a88eb3a81715ccd0$var$leftHandleOnlyLayouts.includes(layout)) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $fb9eF.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $5cc79e9089d815ff$export$c4d4f06a25de97f)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3GQSw.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            onResizeStart: this.handleResizeStart,
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args);
        this.state = {
            offsetLeft: this.calcOffsetLeft()
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $76kDm.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $89gPK.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.wrapper = void 0;
        this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $b8ZJI.calcMediaPxWidth)({
                origWidth: (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.handleResizeStart = ()=>{
            const { view: view, getPos: getPos } = this.props;
            if (typeof getPos === 'function') {
                const pos = getPos();
                if (typeof pos === 'number') {
                    const tr = view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, pos));
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                }
            }
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $h5qPS.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, bodiedSyncBlock: bodiedSyncBlock } = this.props.view.state.schema.nodes;
            // Hide resizing guideline when embed is nested
            if (this.$pos && !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                bodiedSyncBlock
            ])) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $89gPK.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}
$a88eb3a81715ccd0$export$2e2bcd8739ae039.defaultProps = {
    aspectRatio: (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT)
};





const $dc083a8e67906b16$export$d79f14ec3c108fc0 = (url)=>{
    if (url && (0, $8kONW.isConfluenceSlideUrl)(url) && !(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true)) // Slides have a 16:9 canvas
    return 16 / 9;
    return undefined;
};
const $dc083a8e67906b16$var$selector = (states)=>{
    return {
        widthStateLineLength: states.widthState?.lineLength || 0,
        widthStateWidth: states.widthState?.width || 0,
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $dc083a8e67906b16$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth, editorDisabled: editorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ], $dc083a8e67906b16$var$selector);
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $jsWW5.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aHoC6.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth,
            children: smartCard
        });
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a88eb3a81715ccd0$export$2e2bcd8739ae039), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabled,
        children: smartCard
    });
};
class $dc083a8e67906b16$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $28eb8ceae9a9c979$export$3301f76e6efaf85e)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = isPageSSRed ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QXwxo.CardSSR), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt,
            hideIconLoadingSkeleton: true
        }, url) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        }, url);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).EMBED,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $11zX6.EmbedResizeMessageListener), {
                embedIframeRef: this.embedIframeRef,
                onHeightUpdate: this.onHeightUpdate,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($dc083a8e67906b16$var$CardInner, {
                    pluginInjectionApi: pluginInjectionApi,
                    smartCard: smartCard,
                    hasPreview: hasPreview,
                    getPosSafely: this.getPosSafely,
                    view: view,
                    getLineLength: this.getLineLength,
                    eventDispatcher: this.props.eventDispatcher,
                    updateSize: this.updateSize,
                    getPos: getPos,
                    aspectRatio: aspectRatio,
                    allowResizing: allowResizing,
                    heightAlone: heightAlone,
                    cardProps: cardProps,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                })
            })
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = void 0;
        this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch  {
            // Can blow up in rare cases, when node has been removed.
            }
        };
        this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: resolvedAspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            const aspectRatio = $dc083a8e67906b16$export$d79f14ec3c108fc0(url) ?? resolvedAspectRatio;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT), (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $LQnOI.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $28eb8ceae9a9c979$export$af5afab36c1f83f6)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                const cardContext = this.props.cardContext?.value ? this.props.cardContext?.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch  {}
        };
        this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        };
        /**
     * Defers line-length measurement until the embed card DOM has fully rendered.
     *
     * When put embed in the expand, reload the page and open that expand, the embed was collapsed.
     * Because the `.rich-media-item` can temporarily report `offsetWidth = 1`, as proportional width styles have not been applied yet.
     * Measuring at that moment would cache the bogus width and break resize calculations.
     * Scheduling a measurement on the next animation frame ensures layout has
     * settled. We then force the node view to re-render so `getLineLength`
     * re-runs and captures the correct width.
     */ this.scheduleLineLengthRemeasureRaf = (0, $LQnOI.default)((view)=>{
            if (view) this.forceUpdate();
        });
        this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $jsWW5.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $4mCw6.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) {
                    const measuredWidth = domNode.offsetWidth;
                    if (measuredWidth <= 1) {
                        this.scheduleLineLengthRemeasureRaf(view);
                        return originalLineLength;
                    }
                    return measuredWidth;
                }
            }
            return originalLineLength;
        };
        /**
     * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
     * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
     * we will show embed window of appropriate size and avoid unnecessary content jumping.
     */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $LQnOI.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        };
        this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.removeCardDispatched = false;
        this.scrollContainer = (0, $1jz5K.findOverflowScrollParent)(props.view.dom) || undefined;
        this.state = {
            hasPreview: true
        };
    }
}
const $dc083a8e67906b16$export$a2e44368c194a658 = (props)=>{
    const width = (0, $4Qu9h.useSharedPluginStateSelector)(props.pluginInjectionApi, 'width.width');
    const viewAsBlockCard = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ee1e0f18b66d961$export$780882fb750d3c8d), {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)($dc083a8e67906b16$export$61b2782f78272a37, {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    });
};
const $dc083a8e67906b16$var$WrappedEmbedCardWithCondition = (0, $8m50u.componentWithCondition)(()=>(0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $dc083a8e67906b16$export$a2e44368c194a658, $dc083a8e67906b16$export$61b2782f78272a37);
const $dc083a8e67906b16$var$WrappedEmbedCard = (0, $537b6f07c48b0136$export$60332b2344f7fe41)($dc083a8e67906b16$var$WrappedEmbedCardWithCondition, (0, $KTiWz.default));
class $dc083a8e67906b16$export$6789d7ecdc77631b extends (0, $Igylv.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59ddef7452a84f28$export$d59258481d10b16b), {
            intl: intl,
            smartCardContext: smartCardContext,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($dc083a8e67906b16$var$WrappedEmbedCard, {
                node: this.node,
                view: this.view,
                eventDispatcher: eventDispatcher,
                getPos: this.getPos,
                allowResizing: allowResizing,
                fullWidthMode: fullWidthMode,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                id: this.id,
                CompetitorPrompt: CompetitorPrompt,
                isPageSSRed: isPageSSRed,
                provider: provider
            })
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, $03RpJ.default)();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $dc083a8e67906b16$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: intl,
            smartCardContext: smartCardContext
        };
        return new $dc083a8e67906b16$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps).init();
    };

































var $b2XFx = parcelRequire("b2XFx");





var $8OcYi = parcelRequire("8OcYi");


var $esGL2 = parcelRequire("esGL2");


var $4aNe4 = parcelRequire("4aNe4");

var $7jfHQ = parcelRequire("7jfHQ");

var $i4lJP = parcelRequire("i4lJP");


var $f21H2 = parcelRequire("f21H2");






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 













var $f9XbP = parcelRequire("f9XbP");

const $215d271c3bef94e8$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $215d271c3bef94e8$export$4521957a9ae858f5 = 'discovered';
const $215d271c3bef94e8$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $215d271c3bef94e8$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $215d271c3bef94e8$export$2cf27d95188f1c13 = 86400000;
const $215d271c3bef94e8$var$storageClient = new (0, $f9XbP.StorageClient)($215d271c3bef94e8$export$c0fd7e3ed450d078);
const $215d271c3bef94e8$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $215d271c3bef94e8$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $215d271c3bef94e8$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $215d271c3bef94e8$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $215d271c3bef94e8$var$storageClient.setItemWithExpiry(key, $215d271c3bef94e8$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};


const $699123311af2c8a1$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $cozmU.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $cozmU.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $cozmU.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $cozmU.useMemo)(()=>isPulseEnabled && !(0, $215d271c3bef94e8$export$f029a1bf9ca298da)((0, $215d271c3bef94e8$export$b1ab83c904a5352e)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $699123311af2c8a1$export$2e2bcd8739ae039 = $699123311af2c8a1$var$useLinkUpgradeDiscoverability;










var $9DHhW = parcelRequire("9DHhW");

/* Pulse.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");




const $c8934d820601fbf2$var$pulseKeyframes = null;
const $c8934d820601fbf2$var$pulseStyles = null;
const $c8934d820601fbf2$var$commonStyles = null;
const $c8934d820601fbf2$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $cozmU.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $hekY6.default)([
            "_3iDTPbS8kF",
            pulseStarted.current && "",
            pulseStarted.current && "_0bjKvDzXzM _2OUyjtJ2Jm _1gBibyTOhH _0nFVCGiKXs _43vdfT87jn _03m2ny7LI7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onAnimationIteration: stopPropagation,
        onAnimationStart: stopPropagation
    }, children));
};



const $61088fb587c1a22d$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $215d271c3bef94e8$export$f029a1bf9ca298da)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $cozmU.useCallback)(()=>{
        if (!discovered) (0, $215d271c3bef94e8$export$6b9d1ae5ec92c88e)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c8934d820601fbf2$export$927d63e2511364c0), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline,
        children: children
    });
};


function $030ee9b1d7c0f9ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $030ee9b1d7c0f9ec$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $030ee9b1d7c0f9ec$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, url: url, appearance: appearance })=>{
    const linkPosition = (0, $cozmU.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $699123311af2c8a1$export$2e2bcd8739ae039)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $215d271c3bef94e8$export$f029a1bf9ca298da)((0, $215d271c3bef94e8$export$b1ab83c904a5352e))) (0, $215d271c3bef94e8$export$6b9d1ae5ec92c88e)((0, $215d271c3bef94e8$export$613f4cbb1d6327d6));
    (0, $cozmU.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: shouldShowLinkPulse && $030ee9b1d7c0f9ec$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gBjHb.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                attributes: (0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $61088fb587c1a22d$export$1f5748a1623673d7), {
            localStorageKey: (0, $215d271c3bef94e8$export$613f4cbb1d6327d6),
            localStorageKeyExpirationInMs: (0, $215d271c3bef94e8$export$2cf27d95188f1c13),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, children))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        children,
        isInline,
        placeholderUniqId
    ]);
};









var $gybyF = parcelRequire("gybyF");

const $92832cf5d4953875$export$a43fddf3dfb4c066 = ({ url: url, appearance: appearance, children: children })=>{
    const actions = (0, $gybyF.useSmartLinkActions)({
        url: url,
        appearance: appearance
    });
    const preview = (0, $cozmU.useMemo)(()=>actions.find((action)=>action.id === 'preview-content'), [
        actions
    ]);
    const invokePreview = (0, $cozmU.useCallback)(()=>{
        try {
            preview?.invoke();
        } catch  {}
    }, [
        preview
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children({
            canPreview: !!preview,
            invokePreview: invokePreview
        })
    });
};




































parcelRequire("cozmU");










var $jU5kz = parcelRequire("jU5kz");

var $gjTdl = parcelRequire("gjTdl");





var $83k8i = parcelRequire("83k8i");



var $2xhuI = parcelRequire("2xhuI");

var $91WyP = parcelRequire("91WyP");

var $iEFx5 = parcelRequire("iEFx5");


var $l3s1y = parcelRequire("l3s1y");


var $g6uqx = parcelRequire("g6uqx");





var $jaFVy = parcelRequire("jaFVy");











var $eDtFr = parcelRequire("eDtFr");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $8y86q = parcelRequire("8y86q");


var $V3JOP = parcelRequire("V3JOP");


var $11OF7 = parcelRequire("11OF7");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $4hfky = parcelRequire("4hfky");








var $gbf0M = parcelRequire("gbf0M");


var $bI14T = parcelRequire("bI14T");


var $4ez2K = parcelRequire("4ez2K");






parcelRequire("cozmU");


var $3PHGt = parcelRequire("3PHGt");


var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");

const $ca4324df41e9ccf2$var$wrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $ca4324df41e9ccf2$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kA6Zo.Flex), {
        xcss: $ca4324df41e9ccf2$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3PHGt))), {
            label: props?.label
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


const $7ee17a04603997de$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $cozmU.useState)(undefined);
    const [parameters, setParameters] = (0, $cozmU.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $cozmU.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};


function $fee70d3190aaad52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fee70d3190aaad52$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $fee70d3190aaad52$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $cozmU.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
        const newAdf = (0, $gbf0M.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $ff2860869594b73b$export$113cdaf1b279f308)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $k3XQC.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
        css: $fee70d3190aaad52$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ca4324df41e9ccf2$export$8819453811a57211), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button',
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
};
const $fee70d3190aaad52$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)($fee70d3190aaad52$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};

















var $3FyXx = parcelRequire("3FyXx");





var $2VYYv = parcelRequire("2VYYv");







function $49f259ed34811056$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3FyXx.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $49f259ed34811056$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $28eb8ceae9a9c979$export$bd1cd60a9b31da5e)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)($49f259ed34811056$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $28eb8ceae9a9c979$export$bd1cd60a9b31da5e)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $iEFx5.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $49f259ed34811056$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $kCECX.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $28eb8ceae9a9c979$export$83c364d103479f90)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $49f259ed34811056$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $50d9c959a343ad0a$export$a6fcef6250c64f76)(node, (0, $50d9c959a343ad0a$export$f3f2332ef0853029)(view.state));
            return /*#__PURE__*/ (0, $8aG6j.jsx)($49f259ed34811056$export$3d21e16152ee408f, {
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $krYZG.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $ff2860869594b73b$export$884fcee347ca969b)(newHref, analytic)(view.state, view.dispatch);
                }
            }, idx);
        }
    };
};
const $49f259ed34811056$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker, linkPickerOptions)=>{
    if (!showLinkingToolbar) return {};
    return {
        height: linkPickerOptions?.popupHeight ?? (lpLinkPicker ? (0, $2VYYv.LINKPICKER_HEIGHT_IN_PX) : (0, $2VYYv.RECENT_SEARCH_HEIGHT_IN_PX)),
        width: linkPickerOptions?.popupWidth ?? (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX),
        // forcePlacement is always true to prevent the popup from rendering off-screen
        forcePlacement: true
    };
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
















var $huoxr = parcelRequire("huoxr");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $7sJoX = parcelRequire("7sJoX");





var $9d7Pd = parcelRequire("9d7Pd");












var $4EZEs = parcelRequire("4EZEs");


const $e5629c0e58eb7677$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $4EZEs.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $3u1Hp = parcelRequire("3u1Hp");

const $a8f1460a9920d336$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $cozmU.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $3u1Hp.useDatasourceClientExtension)();
    (0, $cozmU.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $3u1Hp.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





































const $57525b57aab09e0a$var$dropdownExpandContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $57525b57aab09e0a$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $cozmU.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $e5629c0e58eb7677$export$687401cc190b9ec3)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        label: ""
    }) : undefined;
    const tooltipContent = areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon,
                ariaLabel: areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink) : undefined,
                tooltipContent: tooltipContent,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editLink)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editDatasourceStandalone)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                        css: $57525b57aab09e0a$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: intl.formatMessage((0, $bI2nS.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownTriggerTitle)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $57525b57aab09e0a$export$2e2bcd8739ae039 = $57525b57aab09e0a$var$EditToolbarButtonPresentation;


const $f6409fd8f1fd2ba8$var$dropdownExpandContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, ...response } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $cozmU.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $cozmU.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $e5629c0e58eb7677$export$687401cc190b9ec3)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-link",
                onClick: onEditLink,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editLink)), !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editDatasourceStandalone)), !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                        css: $f6409fd8f1fd2ba8$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: intl.formatMessage((0, $bI2nS.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownTriggerTitle)), !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $cozmU.useMemo)(()=>{
        if (!datasourceId || !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $57525b57aab09e0a$export$2e2bcd8739ae039), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const fetchData = (0, $cozmU.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $a8f1460a9920d336$export$25222ec28f4cbba5)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $cozmU.useMemo)(()=>{
        if (!datasourceId || !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $57525b57aab09e0a$export$2e2bcd8739ae039), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $f6409fd8f1fd2ba8$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};




































var $gxKDp = parcelRequire("gxKDp");

const $fff22d9fe7ec96c7$export$9de0d67eaa25f178 = (intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon } = (0, $gxKDp.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    };
};

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");





var $7joZr = parcelRequire("7joZr");




function $a737b0b67ea1264f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $a737b0b67ea1264f$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $a737b0b67ea1264f$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $a737b0b67ea1264f$var$DisallowedWrapper = ({ disabled: disabled, children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: disabled ? $a737b0b67ea1264f$var$disallowedWrapperStyle : $a737b0b67ea1264f$var$defaultWrapperStyle
    }, children);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $a737b0b67ea1264f$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $a737b0b67ea1264f$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $a737b0b67ea1264f$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7joZr.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $lOiVq.jsx)($a737b0b67ea1264f$var$DisallowedWrapper, {
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            css: disabled ? $a737b0b67ea1264f$var$buttonStyleNoneEvent : $a737b0b67ea1264f$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious"
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    }));
};








var $iso5o = parcelRequire("iso5o");










class $311c13dda34631e5$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83d2b8785968bed7$export$722ea04dd4ef208e), {
            children: (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value)
        });
    }
    constructor(...args){
        super(...args);
        this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $bI2nS.messages).embed),
                onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $311c13dda34631e5$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $bI2nS.messages).block),
                onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $311c13dda34631e5$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $bI2nS.messages).url),
                    onClick: (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $krYZG.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $bI2nS.messages).inline),
                    onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a737b0b67ea1264f$export$41ba5f90e13b0c51), {
                options: options.map((option)=>(0, $fff22d9fe7ec96c7$export$9de0d67eaa25f178)(intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, {
                        ...option,
                        onClick: (0, $gjTdl.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            }, "link-toolbar-button-group");
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $cc2f82b3700a9ffb$export$ddeab6943680f5be)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url || '', currentAppearance || null, cardContext?.store);
                return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    },
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $61088fb587c1a22d$export$1f5748a1623673d7), {
                        localStorageKey: (0, $215d271c3bef94e8$export$b1ab83c904a5352e),
                        testId: "toolbar-discovery-pulse",
                        children: LinkToolbarButtons
                    })
                }));
            }
            return LinkToolbarButtons;
        };
    }
}
const $311c13dda34631e5$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $2xhuI.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $bI2nS.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        return intl.formatMessage((0, $bI2nS.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $2xhuI.default).defaultBlockNode)
        });
    }
};


function $61781900f6775ac5$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $cozmU.useState)(new Map());
    const cardProvider = (0, $cozmU.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $cozmU.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $311c13dda34631e5$export$2a8c6fb42753b13e), {
                url: url,
                intl: intl,
                editorView: editorView,
                editorState: editorState,
                allowEmbeds: cardOptions?.allowEmbeds,
                allowBlockCards: cardOptions?.allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, "link-appearance"),
            cardOptions?.allowDatasource && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fee70d3190aaad52$export$76de8066d79563a4), {
                intl: intl,
                url: url,
                editorState: editorState,
                editorView: editorView,
                editorAnalyticsApi: editorAnalyticsApi,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        ]
    });
}

































parcelRequire("cozmU");











parcelRequire("cozmU");




const $4047da273e09ef71$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip, description: description })=>{
    const { title: title, icon: Icon } = (0, $gxKDp.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? '',
        description: description
    };
};




















var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");








parcelRequire("cozmU");






















const $ced5d6f40b3ce51c$export$12f82ee4a2a1a1c9 = {
    title: (0, $bI2nS.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt)))
};
const $ced5d6f40b3ce51c$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
        const newAdf = (0, $gbf0M.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $ff2860869594b73b$export$113cdaf1b279f308)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt)))({
            label: intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle)
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected,
        children: intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle)
    }, intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle));
};



const $8f28eb0ccb03280c$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && cardContext.value?.extractors.getPreview(url, 'web');
    const defaultCommand = ()=>false;
    if (url) {
        const urlState = cardContext.value?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $bI2nS.messages).embed),
        onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $311c13dda34631e5$export$74e77d31eb18de27)(editorState, intl),
        description: (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? intl.formatMessage((0, $bI2nS.messages).embedToBlockCardWarning) : undefined
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $bI2nS.messages).block),
        onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $311c13dda34631e5$export$74e77d31eb18de27)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $bI2nS.messages).url),
            onClick: (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $krYZG.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $bI2nS.messages).inline),
            onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $4047da273e09ef71$export$1405b80fcb4301ca)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $gjTdl.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $6IL1T.default), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
                children: [
                    finalOptions.map((option)=>{
                        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
                            iconBefore: option.icon,
                            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onClick: ()=>option.onClick(),
                            isSelected: option.selected,
                            description: option.description,
                            shouldDescriptionWrap: true,
                            children: option.title
                        }, option.title);
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ced5d6f40b3ce51c$export$b08a863b9d82986d), {
                        allowDatasource: allowDatasource,
                        intl: intl,
                        url: url ?? '',
                        selected: Boolean(isDatasourceView),
                        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                        dispatchCommand: dispatchCommand
                    })
                ]
            }),
            'href' in settingsConfig && settingsConfig.href && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
                    iconBefore: Icon && /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                        label: "Settings"
                    }),
                    href: settingsConfig.href,
                    target: 'target' in settingsConfig ? settingsConfig.target : undefined,
                    children: intl.formatMessage((0, $iEFx5.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $8f28eb0ccb03280c$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)($8f28eb0ccb03280c$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $ced5d6f40b3ce51c$export$12f82ee4a2a1a1c9) : (0, $gxKDp.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};


const $f03f24584f0ca413$var$CustomHyperlinkDropdown = (props)=>{
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $cozmU.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const cardProvider = (0, $cozmU.useRef)(undefined);
    const containerRef = (0, $cozmU.useRef)(undefined);
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            // eslint-disable-line no-unused-vars
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $cozmU.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch, editorView);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $gxKDp.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            spacing: "compact",
            size: "small"
        }),
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: title
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        ref: containerRef,
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
                mountTo: containerRef.current,
                isOpen: isOpen,
                handleClickOutside: close,
                handleEscapeKeydown: close,
                trigger: trigger,
                scrollableElement: containerRef.current,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                arrowKeyNavigationProviderOptions: {
                    type: (0, $9RT19.ArrowKeyNavigationType).MENU
                },
                fitHeight: 400,
                fitWidth: 200,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8f28eb0ccb03280c$export$6ce0ca681c51cdfb), {
                    url: url,
                    intl: intl,
                    currentAppearance: undefined,
                    editorState: editorView.state,
                    allowEmbeds: cardOptions?.allowEmbeds,
                    allowBlockCards: cardOptions?.allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    isDatasourceView: isDatasourceView,
                    allowDatasource: allowDatasource,
                    dispatchCommand: dispatchCommand,
                    settingsConfig: settingsConfig,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                })
            }),
            !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar)) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar))
            })
        ]
    });
};
const $f03f24584f0ca413$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($f03f24584f0ca413$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};



















const $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b = ({ url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorView: editorView, onClick: onClick, title: title })=>{
    const destinationUrl = (0, $f21H2.useSmartLinkDestinationUrl)(url);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onClick(editorView.state, editorView.dispatch);
    }, [
        editorView,
        onClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "hyperlink-open-link",
        title: title,
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: ""
        }),
        href: destinationUrl,
        target: "_blank",
        onClick: handleClick,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};





parcelRequire("cozmU");











var $gDx2k = parcelRequire("gDx2k");








var $iMnC5 = parcelRequire("iMnC5");



var $1l0kj = parcelRequire("1l0kj");













var $1f3d721a90b66bdf$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $1f3d721a90b66bdf$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});


function $735ee273a357b497$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $735ee273a357b497$export$26ada819291bd8df = (node)=>{
    if ($735ee273a357b497$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $50d9c959a343ad0a$export$71376de76fa352d1)(node.type)) return true;
    return $735ee273a357b497$var$hasLinkMark(node);
};
function $735ee273a357b497$export$d3d4c2526aede29a(node) {
    if ($735ee273a357b497$export$962cfe99b8da8614(node)) return (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE;
    if ($735ee273a357b497$export$26ada819291bd8df(node)) return (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK;
    return null;
}
function $735ee273a357b497$export$599e1b655555ab1d(node) {
    const appearance = (0, $50d9c959a343ad0a$export$71376de76fa352d1)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $735ee273a357b497$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $735ee273a357b497$var$hasLinkMark = (node)=>{
    return !!$735ee273a357b497$var$getLinkMark(node);
};
function $735ee273a357b497$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $735ee273a357b497$var$getLinkMark(node)?.attrs?.href;
}
const $735ee273a357b497$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $735ee273a357b497$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $735ee273a357b497$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $735ee273a357b497$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $735ee273a357b497$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $735ee273a357b497$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($735ee273a357b497$export$94df0e59ebebf4a7(a.node) !== $735ee273a357b497$export$94df0e59ebebf4a7(b.node) || $735ee273a357b497$export$599e1b655555ab1d(a.node) !== $735ee273a357b497$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};


const $d66c3a4348634727$export$9ed3225219cdbbe9 = ({ node: node, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView })=>{
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $bI14T.useSmartLinkContext)();
    const url = node.attrs.url;
    const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
    const cardState = store?.getState()[url];
    if (cardState) {
        const ari = (0, $4aNe4.getObjectAri)(cardState.details);
        const name = (0, $i4lJP.getObjectName)(cardState.details);
        const iconUrl = (0, $7jfHQ.getObjectIconUrl)(cardState.details);
        const isPanelAvailable = ari && isPreviewPanelAvailable?.({
            ari: ari
        });
        const handleOpenGlancePanelClick = ()=>{
            if (openPreviewPanel && isPanelAvailable) openPreviewPanel({
                url: url,
                ari: ari,
                name: name || '',
                iconUrl: iconUrl,
                panelData: {
                    embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                }
            });
            editorAnalyticsApi?.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TOOLBAR_PREVIEW,
                attributes: {
                    previewType: 'panel',
                    ...(0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url, display, store)
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            });
        };
        const title = intl.formatMessage((0, $91WyP.linkMessages).openPreviewPanel);
        const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
            label: "",
            spacing: "spacious"
        }) : // This is a hack required for Jira until areToolbarFlagsEnabled are enabled to ensure the icon has padding
        // Padding is removed when areToolbarFlagsEnabled for a button with icon only in platform/packages/editor/editor-common/src/ui/FloatingToolbar/Button.tsx
        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            as: "span",
            space: "space.050",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
                    label: "",
                    spacing: "spacious"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                })
            ]
        });
        if (openPreviewPanel && isPanelAvailable) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            gap: "space.050",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
                testId: "open-preview-panel-floating-toolbar-button",
                onClick: handleOpenGlancePanelClick,
                icon: icon,
                title: title,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        });
    }
    return null;
};


















const $32749362d6e128b7$var$areResolvedAttributesEqual = (current, next)=>current?.displayCategory === next?.displayCategory && current?.extensionKey === next?.extensionKey && current?.status === next?.status && current?.statusDetails === next?.statusDetails;
/**
 * Handles firing the toolbar viewed event
 */ const $32749362d6e128b7$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext, editorView: editorView })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $cozmU.useEffect)(()=>{
        const resolvedAttributes = (0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url, display, store);
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...resolvedAttributes,
                display: display
            }
        }).fire('media');
        if (!editorView) return;
        const currentResolvedAttributes = (0, $82719199149a05f4$export$f05434c51e3762e)(editorView.state)?.resolvedToolbarAttributesByUrl[url];
        if ($32749362d6e128b7$var$areResolvedAttributesEqual(currentResolvedAttributes, resolvedAttributes)) return;
        editorView.dispatch((0, $28eb8ceae9a9c979$export$63a1bdeb24c4dd9f)(url, resolvedAttributes)(editorView.state.tr));
    }, [
        createAnalyticsEvent,
        display,
        editorView,
        url,
        store
    ]);
    return null;
};
const $32749362d6e128b7$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82bb9aba23fa33e9$export$b49e513cc101a4b6), {
        editorView: editorView,
        children: url ? /*#__PURE__*/ (0, $8aG6j.jsx)($32749362d6e128b7$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext,
            editorView: editorView
        }) : null
    });
};


const $cc2f82b3700a9ffb$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $gjTdl.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                displayMode: type
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $bjg0G.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $krYZG.ACTION).DELETED
    });
const $cc2f82b3700a9ffb$export$7ee76be08aa43a42 = (editorAnalyticsApi, inputMethod, resolvedAttributes)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildVisitedNonHyperLinkPayload)(type.name, inputMethod, resolvedAttributes))(tr);
            dispatch(tr);
        }
        return true;
    };
const $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics = (editorAnalyticsApi, inputMethod, resolvedAttributes = {})=>(state, dispatch)=>{
        const linkAnalyticsRecorded = $cc2f82b3700a9ffb$export$7ee76be08aa43a42(editorAnalyticsApi, inputMethod, resolvedAttributes)(state, dispatch);
        if (!linkAnalyticsRecorded) return false;
        editorAnalyticsApi?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).OPEN_LINK,
            attributes: {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
        return true;
    };
const $cc2f82b3700a9ffb$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $cc2f82b3700a9ffb$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $64861730f5bb867e$export$863ae87a9d233606) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $bI2nS.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const richMediaElement = element.querySelector(`.${(0, $l3s1y.richMediaClassName)}`);
                    if (!(0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                        exposure: true
                    })) return richMediaElement;
                    if (richMediaElement) return richMediaElement;
                }
                return element;
            },
            items: $cc2f82b3700a9ffb$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $49f259ed34811056$export$acaefd190fd8ff4d)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled, linkPickerOptions)
        };
    };
};
const $cc2f82b3700a9ffb$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $50d9c959a343ad0a$export$a6fcef6250c64f76)(node, (0, $50d9c959a343ad0a$export$f3f2332ef0853029)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$23c9e012c8c1ce24)(text, editorAnalyticsApi), {
        action: (0, $krYZG.ACTION).UNLINK
    });
    return ()=>false;
};
const $cc2f82b3700a9ffb$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions, areAnyNewToolbarFlagsEnabled)=>{
    if (areAnyNewToolbarFlagsEnabled) return (0, $jU5kz.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    return (0, $jU5kz.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
};
const $cc2f82b3700a9ffb$var$withToolbarMetadata = (command)=>(0, $gjTdl.commandWithMetadata)(command, {
        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
    });
const $cc2f82b3700a9ffb$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $32749362d6e128b7$export$998ac2a59a1547dd), {
                    url: url,
                    display: display,
                    editorView: editorView
                }, "edit.link.menu.viewed")
        }
    ];
};
const $cc2f82b3700a9ffb$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $50d9c959a343ad0a$export$15bc29504ff06986)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $73a6g.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $50d9c959a343ad0a$export$a6fcef6250c64f76)(node, (0, $50d9c959a343ad0a$export$f3f2332ef0853029)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
        const currentAppearance = (0, $50d9c959a343ad0a$export$71376de76fa352d1)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(node);
        const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
        const annotationApiState = pluginInjectionApi?.annotation?.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationApiState?.annotations[mark.attrs.id] === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            if (!pluginInjectionApi?.annotation || !isCommentEnabled) return false;
            pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $k3XQC.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $49f259ed34811056$export$dec3901e38d4e7ff)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $cc2f82b3700a9ffb$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                    title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                    showTitle: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: (0, $jaFVy.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode)
                },
                {
                    type: 'separator'
                }
            ] : [];
            const openLinkInputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
            const editButtonItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true)
                }
            ];
            const openPreviewPanelItems = [
                {
                    type: 'custom',
                    fallback: [],
                    render: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d66c3a4348634727$export$9ed3225219cdbbe9), {
                            node: node,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ];
            const resolvedToolbarAttributes = url ? pluginState?.resolvedToolbarAttributesByUrl[url] ?? {} : {};
            const openLinkToolbarItemFallback = {
                id: 'editor.link.openLink',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                metadata: metadata,
                className: 'hyperlink-open-link',
                title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                href: url,
                target: '_blank'
            };
            const openLinkToolbarItem = {
                type: 'custom',
                fallback: [
                    openLinkToolbarItemFallback
                ],
                render: (editorView)=>editorView && url ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b), {
                        url: url,
                        title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                        editorView: editorView,
                        onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }) : null
            };
            const toolbarItems = areAllNewToolbarFlagsDisabled ? [
                ...editItems,
                ...commentItems,
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                {
                    type: 'separator'
                },
                ...$cc2f82b3700a9ffb$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $2xhuI.default).remove),
                    onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                ...editButtonItems,
                ...$cc2f82b3700a9ffb$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'separator',
                    fullHeight: true
                },
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $cc2f82b3700a9ffb$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions, !areAllNewToolbarFlagsDisabled);
                if (alignmentOptions.length && areAllNewToolbarFlagsDisabled) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$cc2f82b3700a9ffb$var$getToolbarViewedItem(url, currentAppearance), areAllNewToolbarFlagsDisabled ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $311c13dda34631e5$export$2a8c6fb42753b13e), {
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability,
                            areAnyNewToolbarFlagsEnabled: false
                        }, "link-appearance")
                } : (0, $8f28eb0ccb03280c$export$1faf5b64d0bbe935)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }), ...showDatasourceAppearance && areAllNewToolbarFlagsDisabled ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fee70d3190aaad52$export$76de8066d79563a4), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                            })
                    }
                ] : [], ...!areAllNewToolbarFlagsDisabled ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if (!areAllNewToolbarFlagsDisabled) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration?.(nodeType, true, className),
                        onMouseLeave: hoverDecoration?.(nodeType, false, className),
                        onFocus: hoverDecoration?.(nodeType, true, className),
                        onBlur: hoverDecoration?.(nodeType, false, className)
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const testId = 'card-overflow-dropdown-trigger';
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        testId: testId,
                        options: [
                            {
                                title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                                onClick: ()=>{
                                    pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                                    label: intl.formatMessage((0, $2xhuI.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $7Y8M5.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $2xhuI.default).delete),
                                onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                                    label: intl.formatMessage((0, $2xhuI.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $cc2f82b3700a9ffb$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi, areAnyNewToolbarFlagsEnabled)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q))),
            onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...areAnyNewToolbarFlagsEnabled ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $cc2f82b3700a9ffb$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
        title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).settingsLink),
        onClick: $cc2f82b3700a9ffb$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $9bUBT.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $cc2f82b3700a9ffb$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    const toolbarItems = [];
    toolbarItems.push(...$cc2f82b3700a9ffb$var$getToolbarViewedItem(node?.attrs?.url, currentAppearance ?? 'url'));
    const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $311c13dda34631e5$export$2a8c6fb42753b13e), {
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true,
                    areAnyNewToolbarFlagsEnabled: false
                }, "link-appearance");
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fee70d3190aaad52$export$76de8066d79563a4), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $8f28eb0ccb03280c$export$1faf5b64d0bbe935)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true,
            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
        }), {
            type: 'separator'
        });
    }
    const openLinkInputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
    const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                datasourceId: datasourceId,
                node: node,
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, false),
                currentAppearance: "datasource",
                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
            }, "edit-toolbar-item")
    });
    if (node?.attrs?.url) {
        const openLinkToolbarItemFallback = {
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
            onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, pluginState?.resolvedToolbarAttributesByUrl[node.attrs.url] ?? {}),
            href: node.attrs.url,
            target: '_blank'
        };
        toolbarItems.push({
            type: 'custom',
            fallback: [
                openLinkToolbarItemFallback
            ],
            render: (editorView)=>editorView ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b), {
                    url: node.attrs.url,
                    title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                    editorView: editorView,
                    onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, pluginState?.resolvedToolbarAttributesByUrl[node.attrs.url] ?? {}),
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }) : null
        });
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'separator'
        });
    }
    if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $2xhuI.default).remove),
        onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'datasource-overflow-dropdown-trigger';
        // When canShowAppearanceSwitch is true, and platform_editor_controls is on, the link appearance dropdown shows, which includes a link preference button
        // So only add the link appearance button when canShowAppearanceSwitch is false
        if (!canShowAppearanceSwitch()) {
            const linkPreferenceButton = $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink);
            toolbarItems.push({
                type: 'separator',
                fullHeight: true
            }, linkPreferenceButton, {
                type: 'separator',
                fullHeight: true
            });
        } else toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                        onClick: ()=>{
                            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        onMouseEnter: hoverDecoration?.(node.type, true, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration?.(node.type, false, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration?.(node.type, true, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration?.(node.type, false, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                            label: intl.formatMessage((0, $2xhuI.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $2xhuI.default).delete),
                        onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                            label: intl.formatMessage((0, $2xhuI.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $cc2f82b3700a9ffb$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $cc2f82b3700a9ffb$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, _state)=>{
        const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url",
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }, "edit-toolbar-button");
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                showTitle: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if (!areAllNewToolbarFlagsDisabled) {
            const hyperlinkAppearance = [
                (0, $f03f24584f0ca413$export$5b48c4cfa5ad82e1)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api?.analytics?.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $32749362d6e128b7$export$998ac2a59a1547dd), {
                            url: link,
                            display: "url",
                            editorView: editorView
                        }, "edit.link.menu.viewed")
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $32749362d6e128b7$export$998ac2a59a1547dd), {
                        url: link,
                        display: "url",
                        editorView: editorView
                    }, "edit.link.menu.viewed")
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $61781900f6775ac5$export$33d351e602b13f5c), {
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    }, "link-appearance");
                }
            },
            ...editLinkItem
        ];
    };
};
const $cc2f82b3700a9ffb$export$d5ca70670b9f6b9 = (options, api)=>(intl, _link)=>{
        /**
   * Require either provider to be supplied (controls link preferences)
   * Or explicit user preferences config in order to enable button
   */ if ((options.provider || options.userPreferencesLink) && !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) return [
            {
                type: 'separator'
            },
            $cc2f82b3700a9ffb$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
        ];
        return [];
    };


const $197bf7f94b28aafe$export$aff6291803939b05 = /*#__PURE__*/ (0, $cozmU.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: propsOnClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed, pluginInjectionApi: pluginInjectionApi, disablePreviewPanel: disablePreviewPanel })=>{
    const { url: url, data: data } = node.attrs;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const refId = (0, $cozmU.useRef)((0, $03RpJ.default)());
    const removeCardDispatched = (0, $cozmU.useRef)(false);
    const { getState: getSmartlinkState } = cardContext?.value?.store || {};
    const cardState = getSmartlinkState?.()[url || ''];
    (0, $cozmU.useEffect)(()=>{
        const id = refId.current;
        removeCardDispatched.current = false;
        return ()=>{
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_inline_card_dispatch_guard') && removeCardDispatched.current) return;
            removeCardDispatched.current = true;
            const { tr: tr } = view.state;
            (0, $28eb8ceae9a9c979$export$3301f76e6efaf85e)({
                id: id
            })(tr);
            view.dispatch(tr);
        };
    }, [
        getPos,
        view
    ]);
    const scrollContainer = (0, $cozmU.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ()=>(0, $1jz5K.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $cozmU.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $LQnOI.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $28eb8ceae9a9c979$export$af5afab36c1f83f6)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $cozmU.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const handleOnClick = (0, $cozmU.useCallback)((event, data)=>{
        if (event.metaKey || event.ctrlKey) {
            const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
            (0, $cc2f82b3700a9ffb$export$7ee76be08aa43a42)(editorAnalyticsApi, (0, $krYZG.INPUT_METHOD).META_CLICK)(view.state, view.dispatch);
            window.open(data?.destinationUrl ?? url, '_blank');
        } else // only trigger the provided onClick callback if the meta key or ctrl key is not pressed
        propsOnClick?.(event);
    }, [
        propsOnClick,
        url,
        view,
        pluginInjectionApi
    ]);
    const onClick = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? handleOnClick : propsOnClick;
    const card = (0, $cozmU.useMemo)(()=>{
        if ((isPageSSRed || cardState) && url) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QXwxo.CardSSR), {
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel,
            hideIconLoadingSkeleton: true
        }, url);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel
        }, url);
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed,
        disablePreviewPanel,
        cardState
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, $8aG6j.jsx)(cardContext.Provider, {
        value: cardContext.value,
        children: card
    }) : data ? card : null;
});


const $83775087cda75ea7$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode,
        selection: states.selectionState?.selection
    };
};
const $83775087cda75ea7$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $cozmU.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, provider: provider, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isInserted, setIsInserted] = (0, $cozmU.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $cozmU.useState)(false);
    const editorAppearance = pluginInjectionApi?.card.sharedState.currentState()?.editorAppearance;
    const destinationUrl = (0, $f21H2.useSmartLinkDestinationUrl)(node.attrs.url);
    const onResolve = (0, $cozmU.useCallback)((tr, title)=>{
        const metadata = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
        if (metadata && metadata.type === 'REGISTER') (0, $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9)(()=>setIsInserted(false), metadata.info)(tr);
        else (0, $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $cozmU.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $cozmU.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { mode: mode, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ], $83775087cda75ea7$var$selector);
    const floatingToolbarNode = selection instanceof (0, $kCECX.NodeSelection) && selection.node;
    // This is a prop to show Hover card, Hover card should be shown only in Live View and Classic Renderer (note when only Editor controls enabled we don't show in Live view)
    const showHoverPreview = floatingToolbarNode !== node;
    const innerCardWithOpenButtonOverlay = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $b2XFx.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            destinationUrl: destinationUrl,
            compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
            editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
            view: view,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered,
                isPageSSRed: isPageSSRed,
                provider: provider,
                pluginInjectionApi: pluginInjectionApi,
                disablePreviewPanel: true
            })
        }), [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed,
        provider,
        pluginInjectionApi,
        destinationUrl
    ]);
    const innerCardOriginal = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            provider: provider,
            pluginInjectionApi: pluginInjectionApi,
            showHoverPreview: false
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const shouldShowOpenButtonOverlay = (0, $cozmU.useMemo)(()=>{
        const shouldShowOpenButtonOverlayInChomeless = editorAppearance === 'chromeless';
        return mode === 'edit' || editorAppearance === 'comment' || shouldShowOpenButtonOverlayInChomeless;
    }, [
        mode,
        editorAppearance
    ]);
    let innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    if (mode === 'view') {
        const url = node.attrs.url;
        const cardState = cardContext?.value?.store?.getState()[url];
        if (cardState) {
            const ari = (0, $4aNe4.getObjectAri)(cardState.details);
            const name = (0, $i4lJP.getObjectName)(cardState.details);
            const iconUrl = (0, $7jfHQ.getObjectIconUrl)(cardState.details);
            const isPanelAvailable = ari && cardContext?.value?.isPreviewPanelAvailable?.({
                ari: ari
            });
            const openPreviewPanel = cardContext?.value?.openPreviewPanel;
            const isPreviewPanelAvailable = Boolean(openPreviewPanel && isPanelAvailable);
            const firePreviewPanelClickEvent = ({ previewType: previewType })=>{
                const store = cardContext?.value?.store;
                const urlState = store?.getState()[url || ''];
                if (pluginInjectionApi?.analytics?.actions) pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CLICKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).HOVER_LABEL,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        previewType: previewType,
                        destinationProduct: urlState?.details?.meta?.product ?? null,
                        destinationSubproduct: urlState?.details?.meta?.subproduct ?? null
                    }
                });
            };
            const innerCardWithPanelButtonOverlay = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $92832cf5d4953875$export$a43fddf3dfb4c066), {
                url: url,
                appearance: "inline",
                children: ({ canPreview: canPreview, invokePreview: invokePreview })=>{
                    const isPreviewModalAvailable = Boolean(canPreview && invokePreview);
                    // In view mode we show HoverLinkOverlay only with if preview mode or panel is available
                    // otherwise a use can click on smartlink itself to open the link in a new tab.
                    const isPreviewAvailable = isPreviewPanelAvailable || isPreviewModalAvailable;
                    // When inside preview panel iframe, hide the overlay button
                    const isInPreviewPanel = (0, $esGL2.isWithinPreviewPanelIFrame)();
                    const showPanelButton = isInPreviewPanel ? isPreviewPanelAvailable : isPreviewAvailable;
                    if (isPreviewAvailable) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b2XFx.default), {
                        isVisible: isResolvedViewRendered,
                        url: url,
                        destinationUrl: destinationUrl,
                        compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
                        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
                        view: view,
                        showPanelButton: showPanelButton,
                        showPanelButtonIcon: isPreviewAvailable && isPreviewPanelAvailable ? 'panel' : 'modal',
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: (event)=>{
                            if (isPreviewPanelAvailable) {
                                event.preventDefault();
                                openPreviewPanel?.({
                                    url: url,
                                    ari: ari || '',
                                    name: name || '',
                                    iconUrl: iconUrl,
                                    panelData: {
                                        embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                                    }
                                });
                                firePreviewPanelClickEvent({
                                    previewType: 'panel'
                                });
                            } else if (isPreviewModalAvailable) {
                                event.preventDefault();
                                invokePreview?.();
                                firePreviewPanelClickEvent({
                                    previewType: 'modal'
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
                            node: node,
                            view: view,
                            getPos: getPos,
                            useAlternativePreloader: useAlternativePreloader,
                            actionOptions: actionOptions,
                            onResolve: onResolve,
                            onClick: onClick,
                            cardContext: cardContext,
                            isHovered: isHovered,
                            isPageSSRed: isPageSSRed,
                            provider: provider,
                            pluginInjectionApi: pluginInjectionApi,
                            showHoverPreview: mode === 'view' && showHoverPreview,
                            disablePreviewPanel: true
                        })
                    });
                    else return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
                        node: node,
                        view: view,
                        getPos: getPos,
                        useAlternativePreloader: useAlternativePreloader,
                        actionOptions: actionOptions,
                        onResolve: onResolve,
                        onClick: onClick,
                        cardContext: cardContext,
                        isHovered: isHovered,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        pluginInjectionApi: pluginInjectionApi,
                        showHoverPreview: mode === 'view' && showHoverPreview
                    });
                }
            });
            innerCard = innerCardWithPanelButtonOverlay;
        }
    }
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = getPosFunction?.() || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $030ee9b1d7c0f9ec$export$cc11bcf19366e14b), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance,
        children: innerCard
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`,
        children: innerCard
    });
});


const $04040245a0d353eb$var$WrappedInlineCardWithAwareness = (0, $537b6f07c48b0136$export$60332b2344f7fe41)((0, $83775087cda75ea7$export$2b341c5236b55a2), (0, $3F4bj.default));
const $04040245a0d353eb$var$selectorWithCard = (states)=>({
        mode: states.editorViewModeState?.mode,
        resolvedInlineSmartLinks: states.cardState?.resolvedInlineSmartLinks
    });
function $04040245a0d353eb$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, intl: intl, smartCardContext: smartCardContext } = props;
    const { mode: mode, resolvedInlineSmartLinks: resolvedInlineSmartLinks } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode',
        'card'
    ], $04040245a0d353eb$var$selectorWithCard);
    const url = node.attrs.url;
    const CompetitorPromptComponent = CompetitorPrompt && url ? /*#__PURE__*/ (0, $8aG6j.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    (0, $cozmU.useEffect)(()=>{
        provider?.then((providerInstance)=>{
            providerInstance.refreshCache?.(props.node);
        });
    }, [
        provider,
        props.node
    ]);
    const linkPosition = (0, $cozmU.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const isChangeboardTarget = linkPosition !== undefined && resolvedInlineSmartLinks?.[0]?.pos === linkPosition;
    const inlineCardContent = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($04040245a0d353eb$var$WrappedInlineCardWithAwareness, {
                node: node,
                view: view,
                getPos: getPos,
                actionOptions: actionOptions,
                useAlternativePreloader: useAlternativePreloader,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                appearance: "inline",
                ...enableInlineUpgradeFeatures && (0, $50d9c959a343ad0a$export$ea8b03e32bcc0b2d)(view.state, getPos, allowEmbeds, allowBlockCards, mode === 'view')
            }),
            CompetitorPromptComponent
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59ddef7452a84f28$export$d59258481d10b16b), {
        intl: intl,
        smartCardContext: smartCardContext,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).INLINE,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR,
            isChangeboardTarget: isChangeboardTarget,
            children: inlineCardContent
        })
    });
}
const $04040245a0d353eb$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };



const $5a0a9ec159d3141a$export$cd3f6a9b84ab8435 = (props)=>{
    return (0, $04040245a0d353eb$export$ebfb9e1798b8aa0e)(props);
};



var $73Kv0 = parcelRequire("73Kv0");


var $kVd8s = parcelRequire("kVd8s");





var $brzQy = parcelRequire("brzQy");


var $gWBVp = parcelRequire("gWBVp");

var $2w79Z = parcelRequire("2w79Z");


var $eOaGc = parcelRequire("eOaGc");





const $0689742eae39d3a4$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $0689742eae39d3a4$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $0689742eae39d3a4$var$isTransactionResolveReplace(tr);
    const isAutoConvert = $0689742eae39d3a4$var$isAutoConvertTr(tr);
    // History
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    const isUndo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $0689742eae39d3a4$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $eOaGc.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $gWBVp.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $735ee273a357b497$export$c63a892fcfc539bc)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $eOaGc.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $gWBVp.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $735ee273a357b497$export$c63a892fcfc539bc)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $735ee273a357b497$export$dbc52ec0d340ce50)(before, oldStart, oldEnd, (node)=>!!(0, $735ee273a357b497$export$d3d4c2526aede29a)(node)));
            // Inserted
            insertedInRange.push(...(0, $735ee273a357b497$export$dbc52ec0d340ce50)(after, newStart, newEnd, (node)=>!!(0, $735ee273a357b497$export$d3d4c2526aede29a)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $0689742eae39d3a4$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet.
		 * Also skip when the transaction is an auto-convert
		 * (e.g. a pasted link being converted to a native embed extension),
		 * because the link is being converted, not deleted by the user.
		 */ if (!isResolveReplace && !isAutoConvert) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $0689742eae39d3a4$var$getResolvePositions(tr, state);
        inserted.push(...(0, $735ee273a357b497$export$7ea2145b3909e5c6)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $brzQy.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $735ee273a357b497$export$1f3592a520a7960d)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $0689742eae39d3a4$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(removed[i].node);
            const currentSubject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(inserted[i].node);
            if ($0689742eae39d3a4$var$isDatasourceUpgrade(previousSubject, currentSubject) || $0689742eae39d3a4$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $0689742eae39d3a4$var$UPDATE_ACTIONS = [
    (0, $krYZG.ACTION).CHANGED_TYPE,
    (0, $krYZG.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $0689742eae39d3a4$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $0689742eae39d3a4$var$UPDATE_ACTIONS.includes(action);
    });
};
const $0689742eae39d3a4$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $0689742eae39d3a4$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    return $0689742eae39d3a4$var$isMetadataQueue(pluginMeta);
};
const $0689742eae39d3a4$var$isMetadataQueue = (metaData)=>{
    return $0689742eae39d3a4$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $0689742eae39d3a4$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    return $0689742eae39d3a4$var$isMetadataResolve(pluginMeta);
};
/**
 * Checks if the transaction is an auto-convert action
 * (e.g. a pasted link being converted to a native embed extension node).
 * In this case the link removal should not be tracked as a deletion.
 */ const $0689742eae39d3a4$var$isAutoConvertTr = (tr)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return false;
        return step.getMetadata().cardAction === 'AUTO_CONVERT';
    });
};
const $0689742eae39d3a4$var$isMetadataResolve = (metaData)=>{
    return $0689742eae39d3a4$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $0689742eae39d3a4$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $0689742eae39d3a4$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    if (!$0689742eae39d3a4$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $0689742eae39d3a4$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $82719199149a05f4$export$f05434c51e3762e)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    if (!$0689742eae39d3a4$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $0689742eae39d3a4$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $82719199149a05f4$export$f05434c51e3762e)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $0689742eae39d3a4$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE && currentSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK;
const $0689742eae39d3a4$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK && currentSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE;
function $0689742eae39d3a4$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $kVd8s.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
        const isUndo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $brzQy.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $0689742eae39d3a4$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $735ee273a357b497$export$599e1b655555ab1d)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).DELETED);
        pushEvents(inserted, (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}






const $763d543a43740aab$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];


const $d456c0380d476625$export$32844f9f273856e4 = (editorView)=>{
    if (editorView) {
        const { selection: selection, schema: schema } = editorView.state;
        const { blockCard: blockCard } = schema.nodes;
        const findResult = (0, $bjg0G.findSelectedNodeOfType)([
            blockCard
        ])(selection);
        if (findResult && (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(findResult.node)) return {
            ...findResult,
            node: findResult.node
        };
    }
    return {
        node: undefined,
        pos: undefined
    };
};
const $d456c0380d476625$export$8467cbb601c13bfc = (layout)=>{
    return (0, $763d543a43740aab$export$3f155c85880510c8).some((l)=>l === layout);
};





const $9a3e82568f11edf8$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $9a3e82568f11edf8$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $9a3e82568f11edf8$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $9a3e82568f11edf8$var$removeCard = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.id !== action.info.id)
    };
};
const $9a3e82568f11edf8$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $9a3e82568f11edf8$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $9a3e82568f11edf8$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $9a3e82568f11edf8$var$setResolvedToolbarAttributes = (state, action)=>{
    return {
        ...state,
        resolvedToolbarAttributesByUrl: {
            ...state.resolvedToolbarAttributesByUrl,
            [action.url]: action.attributes
        }
    };
};
const $9a3e82568f11edf8$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $9a3e82568f11edf8$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $9a3e82568f11edf8$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $9a3e82568f11edf8$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $9a3e82568f11edf8$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $9a3e82568f11edf8$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $9a3e82568f11edf8$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>card.pos !== action.info?.pos).concat(action.info) : state.cards,
        removeOverlay: action.callback
    };
};
const $9a3e82568f11edf8$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $9a3e82568f11edf8$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $9a3e82568f11edf8$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $9a3e82568f11edf8$var$queue(state, action);
        case 'SET_PROVIDER':
            return $9a3e82568f11edf8$var$setProvider(state, action);
        case 'RESOLVE':
            return $9a3e82568f11edf8$var$resolve(state, action);
        case 'REGISTER':
            return $9a3e82568f11edf8$var$register(state, action);
        case 'REMOVE_CARD':
            return $9a3e82568f11edf8$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $9a3e82568f11edf8$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $9a3e82568f11edf8$var$setDatasourceTableRef(state, action);
        case 'SET_RESOLVED_TOOLBAR_ATTRIBUTES':
            return $9a3e82568f11edf8$var$setResolvedToolbarAttributes(state, action);
        case 'SET_CARD_LAYOUT':
            return $9a3e82568f11edf8$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $9a3e82568f11edf8$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $9a3e82568f11edf8$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $9a3e82568f11edf8$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $9a3e82568f11edf8$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $9a3e82568f11edf8$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $9a3e82568f11edf8$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $9a3e82568f11edf8$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $9a3e82568f11edf8$var$removeDatasourceStash(state, action);
    }
};









const $1552bb88269ab2b0$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $2w79Z.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $1552bb88269ab2b0$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>{
    const isEmbedFriendlyLocation = $1552bb88269ab2b0$var$isFreshlyPastedOnNewLine(view);
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($1552bb88269ab2b0$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer), $1552bb88269ab2b0$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $1552bb88269ab2b0$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $k3XQC.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $1552bb88269ab2b0$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer)=>(resolvedCard)=>{
        $1552bb88269ab2b0$var$updateCardType(resolvedCard, options);
        (0, $ff2860869594b73b$export$78f5a0da64579d3e)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)(view.state, view.dispatch);
        return resolvedCard;
    };
const $1552bb88269ab2b0$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $ff2860869594b73b$export$2bb01cc4a12e0b44)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $1552bb88269ab2b0$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $28eb8ceae9a9c979$export$1572b3eade6662f9)(cardProvider)(state.tr));
    });
};




const $ce69229594a80c43$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
// Only the first resolved inline smart link is needed for PO spotlight targeting
const $ce69229594a80c43$var$MAX_RESOLVED_INLINE_SMART_LINKS = 1;
const $ce69229594a80c43$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $82719199149a05f4$export$f05434c51e3762e)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $28eb8ceae9a9c979$export$a2922c2e95ff48f7)(tr);
        view.dispatch(tr);
    }
};
const $ce69229594a80c43$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, smartCardContext: smartCardContext, embedCardTransformers: embedCardTransformers } = options;
        const intl = pmPluginFactoryParams.getIntl();
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $3k3tn.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $04040245a0d353eb$export$2626b4e17577ac62),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                CompetitorPrompt: (0, $4iudd.isSSR)() ? undefined : CompetitorPrompt,
                intl: intl,
                smartCardContext: smartCardContext
            }
        });
        return new (0, $kpCD8.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        resolvedToolbarAttributesByUrl: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        embedCardTransformers: embedCardTransformers,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $82719199149a05f4$export$be237c815d2927d4)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
                    if (cardPluginEvents) {
                        const events = (0, $0689742eae39d3a4$export$c985b35883eaea59)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $kCECX.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    const newState = (0, $9a3e82568f11edf8$export$2e2bcd8739ae039)(pluginStateWithUpdatedPos, meta);
                    // Track the first resolved inline smart link for PO spotlight DOM targeting
                    if (meta.type === 'RESOLVE' && pluginState?.requests?.length) {
                        const resolvedRequest = pluginState.requests.find((req)=>req.url === meta.url);
                        if (resolvedRequest?.appearance === 'inline') {
                            if ((newState.resolvedInlineSmartLinks?.length ?? 0) < $ce69229594a80c43$var$MAX_RESOLVED_INLINE_SMART_LINKS) newState.resolvedInlineSmartLinks = [
                                ...newState.resolvedInlineSmartLinks ?? [],
                                {
                                    pos: resolvedRequest.pos,
                                    url: resolvedRequest.url,
                                    source: resolvedRequest.source
                                }
                            ];
                        }
                    }
                    if (!enableInlineUpgradeFeatures) return newState;
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $215d271c3bef94e8$export$f029a1bf9ca298da)($ce69229594a80c43$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $50d9c959a343ad0a$export$290208dc31723a19)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $50d9c959a343ad0a$export$b31d21baab1bb9f)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $1552bb88269ab2b0$export$96766f42428c9e7f)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $82719199149a05f4$export$f05434c51e3762e)(view.state);
                        const oldState = (0, $82719199149a05f4$export$f05434c51e3762e)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $kCECX.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (0, $bjg0G.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $64861730f5bb867e$export$32f80df830e375f6)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $d456c0380d476625$export$8467cbb601c13bfc)(node.attrs.layout) ? node.attrs.layout : (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $28eb8ceae9a9c979$export$dd3435a1df9b2a3f)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $28eb8ceae9a9c979$export$f9c5be16586d220a)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $82719199149a05f4$export$cd9326e2f6dc42c0)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $LQnOI.default)(()=>(0, $1552bb88269ab2b0$export$2007d0af08977743)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined, currentState?.embedCardTransformers?.embedCardNodeTransformer));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $5a0a9ec159d3141a$export$cd3f6a9b84ab8435)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $6ee1e0f18b66d961$export$8c11099266e71f4)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $4iudd.isSSR)() ? undefined : options.CompetitorPrompt,
                        intl: intl,
                        smartCardContext: smartCardContext
                    }),
                    embedCard: (0, $dc083a8e67906b16$export$86904605fa83de6c)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $4iudd.isSSR)() ? undefined : options.CompetitorPrompt,
                        intl: intl,
                        smartCardContext: smartCardContext
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $ce69229594a80c43$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $ce69229594a80c43$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1)
        });
    };




const $e998f3a2cd995bba$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};















var $joG9X = parcelRequire("joG9X");





var $kkIPZ = parcelRequire("kkIPZ");





var $lMCnP = parcelRequire("lMCnP");




















const $9d9da0fd42d14aef$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $9d9da0fd42d14aef$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $cozmU.useCallback)(()=>{
        dispatch((0, $28eb8ceae9a9c979$export$e545bc176b552938)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $9d9da0fd42d14aef$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $9d9da0fd42d14aef$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $9d9da0fd42d14aef$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $cozmU.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $ff2860869594b73b$export$113cdaf1b279f308)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $ff2860869594b73b$export$7f7b236478a618df)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $9d9da0fd42d14aef$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $9d9da0fd42d14aef$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};


const $0b5999f9a6963362$var$selector = (states)=>{
    return {
        showDatasourceModal: states.cardState?.showDatasourceModal,
        datasourceModalType: states.cardState?.datasourceModalType
    };
};
const $0b5999f9a6963362$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $0b5999f9a6963362$var$selector);
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $0b5999f9a6963362$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2a1fa379fa79b714$export$76664c71b9b1a689), {
        view: editorView,
        datasourceModalType: datasourceModalType,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d9da0fd42d14aef$export$95702e90d329951a), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })
    });
};
const $0b5999f9a6963362$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10uVA.EditorSmartCardProviderValueGuard), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b5999f9a6963362$var$ModalWithState, {
            api: api,
            editorView: editorView
        })
    });
});
const $0b5999f9a6963362$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $lMCnP.JiraIssuesConfigModalWithWrappers),
        datasourceId: (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $kkIPZ.ConfluenceSearchConfigModalWithWrappers),
        datasourceId: (0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $joG9X.AssetsConfigModalWithWrappers),
        datasourceId: (0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $0b5999f9a6963362$export$2e2bcd8739ae039 = $0b5999f9a6963362$var$SafeModalWithState;



















var $dgpXm = parcelRequire("dgpXm");








var $2iGHk = parcelRequire("2iGHk");





var $6PfjN = parcelRequire("6PfjN");


var $liM9D = parcelRequire("liM9D");


var $lqRBm = parcelRequire("lqRBm");


const $d6a5e4838fef7689$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $3u1Hp.useDatasourceClientExtension)();
    return (0, $cozmU.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $lqRBm.runWhenIdle)(()=>{
                        (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $lqRBm.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("ju0ww"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};









/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $46b2e73c10a9bafa$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $46b2e73c10a9bafa$export$8793fab959da70d1 = $46b2e73c10a9bafa$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $krYZG.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $krYZG.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $krYZG.INPUT_METHOD).AUTO_DETECT:
        case (0, $krYZG.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $krYZG.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $krYZG.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $krYZG.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $46b2e73c10a9bafa$export$df2aa842dc5172b0 = $46b2e73c10a9bafa$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $krYZG.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $krYZG.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $46b2e73c10a9bafa$export$1cf3d8365b174bde = $46b2e73c10a9bafa$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $krYZG.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $46b2e73c10a9bafa$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $dgpXm.default) ? metadata.sourceEvent : null;
};


function $60ed0d15f281c988$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $60ed0d15f281c988$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $60ed0d15f281c988$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $dgpXm.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $60ed0d15f281c988$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $60ed0d15f281c988$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $dgpXm.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $60ed0d15f281c988$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $60ed0d15f281c988$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $60ed0d15f281c988$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $d6a5e4838fef7689$export$c82e48d9fd97c55b)();
    const eventHandlers = (0, $cozmU.useMemo)(()=>{
        return {
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
   * Subscribe to datasource events
   */ (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};






var $8hDyr = parcelRequire("8hDyr");




/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $5981dd7300ead08c$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $5981dd7300ead08c$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
   * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
   * to defer any heavy operations involving network
   *
   * The callbacks themselves should not be deferred, they should be called syncronously the moment
   * the events take place.
   */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $8hDyr.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $cozmU.useMemo)(()=>{
        return {
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $735ee273a357b497$export$94df0e59ebebf4a7)(node);
                if (!url) return;
                const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const creationMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $735ee273a357b497$export$94df0e59ebebf4a7)(node);
                if (!url) return;
                const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const updateMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                const updateType = (0, $46b2e73c10a9bafa$export$df2aa842dc5172b0)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $735ee273a357b497$export$94df0e59ebebf4a7)(node);
                if (!url) return;
                const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const deleteMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                const deleteType = (0, $46b2e73c10a9bafa$export$1cf3d8365b174bde)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
   * Subscribe to link events
   */ (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};


class $2b23ce52995f75a4$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        if (!this.props.editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f7XUl.EditorSmartCardProvider), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10uVA.EditorSmartCardProviderValueGuard), {
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $82bb9aba23fa33e9$export$b49e513cc101a4b6), {
                    editorView: this.props.editorView,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5981dd7300ead08c$export$aa142efb89c75ed5), {
                            ...this.props
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $60ed0d15f281c988$export$bddcbec746c26287), {
                            ...this.props
                        })
                    ]
                })
            })
        });
    }
}






var $19KQj = parcelRequire("19KQj");


const $9643dc942ac34a79$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $19KQj.useSmartLinkEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (!events || !editorView) return;
        editorView.dispatch((0, $28eb8ceae9a9c979$export$55288255874724a1)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 












var $7XIuB = parcelRequire("7XIuB");


var $ldbHR = parcelRequire("ldbHR");


var $keRDK = parcelRequire("keRDK");

var $3LJVu = parcelRequire("3LJVu");


var $dLFT2 = parcelRequire("dLFT2");


var $99F21 = parcelRequire("99F21");







const $b4dc197bbbd70ac9$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    background: `${"var(--ds-background-neutral, #0515240F)"}`,
    color: `${"var(--ds-icon, #292A2E)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, #292A2E)"} !important`
    }
});
const $b4dc197bbbd70ac9$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $keRDK.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $cozmU.useMemo)(()=>{
        return formatMessage((0, $3LJVu.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        testId: testId,
        css: $b4dc197bbbd70ac9$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
            label: title
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
            label: title
        })
    }));
};
const $b4dc197bbbd70ac9$var$selector = (states)=>{
    return {
        layout: states.cardState?.layout,
        datasourceTableRef: states.cardState?.datasourceTableRef
    };
};
const $b4dc197bbbd70ac9$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { node: node, pos: pos } = (0, $d456c0380d476625$export$32844f9f273856e4)(editorView);
    const { layout: layout = node?.attrs?.layout || undefined, datasourceTableRef: datasourceTableRef } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $b4dc197bbbd70ac9$var$selector);
    const isDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(node);
    if (!isDatasource) return null;
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $d456c0380d476625$export$32844f9f273856e4)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $28eb8ceae9a9c979$export$c9a25858ed46807c)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)($b4dc197bbbd70ac9$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $d456c0380d476625$export$8467cbb601c13bfc)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
const $b4dc197bbbd70ac9$var$_default_1 = (0, $kSwu1.injectIntl)($b4dc197bbbd70ac9$var$LayoutButtonWrapper);
var $b4dc197bbbd70ac9$export$2e2bcd8739ae039 = $b4dc197bbbd70ac9$var$_default_1;


/* PasteDisplayAsMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $w6R6I = parcelRequire("w6R6I");











var $3nacY = parcelRequire("3nacY");

var $bFSJa = parcelRequire("bFSJa");











var $jgJIe = parcelRequire("jgJIe");

var $lslMH = parcelRequire("lslMH");

var $kwf4Z = parcelRequire("kwf4Z");


var $hade9 = parcelRequire("hade9");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");









var $hBYtq = parcelRequire("hBYtq");





const $b980ccc002387570$var$getUrlFromTextLinkNode = (node)=>{
    if (!node.isText || node.marks.length !== 1 || node.marks[0].type.name !== 'link') return undefined;
    const href = node.marks[0].attrs?.href;
    return typeof href === 'string' && node.text === href ? href : undefined;
};
const $b980ccc002387570$var$getUrlFromCardNode = (node)=>{
    if (node.type.name !== 'inlineCard' && node.type.name !== 'blockCard' && node.type.name !== 'embedCard') return undefined;
    const url = node.attrs?.url ?? node.attrs?.data?.url;
    return typeof url === 'string' ? url : undefined;
};
const $b980ccc002387570$var$significantChildren = (fragment)=>{
    const children = [];
    fragment.forEach((child)=>{
        if (child.isText && child.text?.trim() === '') return;
        children.push(child);
    });
    return children;
};
const $b980ccc002387570$export$6f4c320e305ef7dc = (slice)=>{
    if (!slice || slice.content.childCount !== 1) return undefined;
    const topNode = slice.content.child(0);
    const topNodeUrl = $b980ccc002387570$var$getUrlFromTextLinkNode(topNode) ?? $b980ccc002387570$var$getUrlFromCardNode(topNode);
    if (topNodeUrl) return topNodeUrl;
    if (topNode.type.name !== 'paragraph') return undefined;
    const children = $b980ccc002387570$var$significantChildren(topNode.content);
    if (children.length !== 1) return undefined;
    return $b980ccc002387570$var$getUrlFromTextLinkNode(children[0]) ?? $b980ccc002387570$var$getUrlFromCardNode(children[0]);
};









var $2sp5n = parcelRequire("2sp5n");

const $e7a83f0b8653a414$export$a990e9e9e93229aa = (node)=>node?.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && typeof node.attrs?.extensionKey === 'string' && node.attrs.extensionKey.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY));
const $e7a83f0b8653a414$export$98ee8d0cf866fa75 = (node)=>{
    const parameters = node.attrs?.parameters;
    const macroParamUrl = parameters?.macroParams?.url;
    const url = (macroParamUrl && typeof macroParamUrl === 'object' && 'value' in macroParamUrl ? macroParamUrl.value : macroParamUrl) ?? parameters?.macroMetadata?.url;
    return typeof url === 'string' ? url : undefined;
};
const $e7a83f0b8653a414$var$canReplaceNodeWith = (view, pos, nodeType)=>{
    if (!nodeType) return false;
    try {
        const $pos = view.state.doc.resolve(pos);
        const index = $pos.index();
        return $pos.parent.canReplaceWith(index, index + 1, nodeType);
    } catch  {
        return false;
    }
};
const $e7a83f0b8653a414$export$36c7c06292ba7472 = ({ editorView: editorView, pos: pos, appearance: appearance })=>{
    const { paragraph: paragraph, inlineCard: inlineCard, blockCard: blockCard } = editorView.state.schema.nodes;
    if (appearance === 'block') return $e7a83f0b8653a414$var$canReplaceNodeWith(editorView, pos, blockCard);
    if (appearance === 'inline' && !inlineCard) return false;
    if (appearance === 'url' && !editorView.state.schema.marks.link) return false;
    return $e7a83f0b8653a414$var$canReplaceNodeWith(editorView, pos, paragraph);
};
const $e7a83f0b8653a414$export$127d7a4a58bf6ed2 = ({ editorView: editorView, pos: pos, node: node, appearance: appearance, url: url, editorAnalyticsApi: editorAnalyticsApi })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { paragraph: paragraph, inlineCard: inlineCard, blockCard: blockCard } = state.schema.nodes;
    const { link: link } = state.schema.marks;
    if (!(0, $73a6g.isSafeUrl)(url)) return false;
    let content;
    if (appearance === 'url' && link && paragraph) content = paragraph.create(null, state.schema.text(url, [
        link.create({
            href: url
        })
    ]));
    else if (appearance === 'inline' && inlineCard && paragraph) content = paragraph.create(null, inlineCard.create({
        url: url
    }));
    else if (appearance === 'block' && blockCard) content = blockCard.create({
        url: url
    });
    if (!content) return false;
    try {
        const tr = state.tr.replaceWith(pos, pos + node.nodeSize, content).scrollIntoView();
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).CHANGED_TYPE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: 'nativeEmbed'
            }
        })(tr);
        dispatch(tr);
        return true;
    } catch  {
        return false;
    }
};



const $ec88e53192e5c284$export$96b638002b74480f = [
    'url',
    'inline',
    'block',
    'embed'
];
const $ec88e53192e5c284$var$cardAtPos = (node, pos)=>{
    switch(node?.type.name){
        case 'inlineCard':
            return {
                appearance: 'inline',
                pos: pos
            };
        case 'blockCard':
            return {
                appearance: 'block',
                pos: pos
            };
        case 'embedCard':
            return {
                appearance: 'embed',
                pos: pos
            };
        default:
            return (0, $e7a83f0b8653a414$export$a990e9e9e93229aa)(node) ? {
                appearance: 'embed',
                isNativeEmbed: true,
                pos: pos
            } : undefined;
    }
};
const $ec88e53192e5c284$var$getNodeUrl = (node)=>{
    if ((0, $e7a83f0b8653a414$export$a990e9e9e93229aa)(node)) return (0, $e7a83f0b8653a414$export$98ee8d0cf866fa75)(node);
    const attrs = node.attrs;
    const url = attrs?.url ?? attrs?.data?.url;
    return typeof url === 'string' ? url : undefined;
};
const $ec88e53192e5c284$export$bfdec0913b4999e8 = (state, pasteStartPos, pasteEndPos, pastedUrl)=>{
    const docContentSize = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, docContentSize));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, docContentSize));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    try {
        const candidateAt = (pos)=>{
            if (pos < 0 || pos >= docContentSize) return undefined;
            const node = state.doc.nodeAt(pos);
            const card = $ec88e53192e5c284$var$cardAtPos(node, pos);
            return node && card ? {
                card: card,
                url: $ec88e53192e5c284$var$getNodeUrl(node)
            } : undefined;
        };
        const adjacent = [
            candidateAt(from - 1),
            candidateAt(from)
        ].filter((candidate)=>Boolean(candidate));
        const inRange = [];
        state.doc.nodesBetween(from, to, (node, pos)=>{
            const card = $ec88e53192e5c284$var$cardAtPos(node, pos);
            if (card) {
                inRange.push({
                    card: card,
                    url: $ec88e53192e5c284$var$getNodeUrl(node)
                });
                return false;
            }
            return true;
        });
        if (pastedUrl) {
            const match = [
                ...adjacent,
                ...inRange
            ].find((candidate)=>candidate.url === pastedUrl);
            if (match) return match.card;
        }
        if (from === to) {
            const [firstAdjacent] = adjacent;
            if (firstAdjacent) return firstAdjacent.card;
        }
        return inRange[inRange.length - 1]?.card;
    } catch  {
        return undefined;
    }
};


const $7e51d18aba717b05$export$3360e99680efcdd8 = 'smart-link-display-as-paste-menu-section';
const $7e51d18aba717b05$var$styles = {
    appearanceBox: "_0bjKvDKTcp _0KLXrunmFW _3138422ADO _0adFHs2ADO _1DCdHi2ADO _2XsHFM2ADO _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    iconWrapper: "_3iDTPbgBM8 _2iEGP2UfmU _39xV02N91d",
    iconButton: "_0bjKvDKTcp _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _1UtDYzy7kJ _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02N91d _0KLXru66of _1eOmH6o126 _3gzVzLN4oS",
    iconButtonSelected: "_0bjKvDKTcp _3vBAKHrzt2 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _0KLXruY9q9 _1UtDYzy7kJ _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02N91d _1eOmH6sumd _3gzVzLXsxn",
    iconButtonDisabled: "_0bjKvDKTcp _3vBAKHhQC5 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _0KLXruVrZW _1UtDYzot27 _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02N91d"
};
const $7e51d18aba717b05$var$AppearanceOptionIconButton = ({ appearance: appearance, currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, Icon: Icon, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $7e51d18aba717b05$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: label,
            position: "bottom",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                xcss: (0, $w6R6I.cx)($7e51d18aba717b05$var$styles.iconButton, isDisabled && $7e51d18aba717b05$var$styles.iconButtonDisabled, !isDisabled && currentAppearance === appearance && $7e51d18aba717b05$var$styles.iconButtonSelected),
                "aria-label": label,
                "aria-pressed": currentAppearance === appearance,
                isDisabled: isDisabled,
                onClick: onClick,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                    label: label
                })
            })
        })
    });
};
const $7e51d18aba717b05$var$InlineAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "inline",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$BlockAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "block",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$EmbedAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "embed",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$getCurrentPastedSlice = (api)=>{
    const apiWithPaste = api;
    const pasteState = apiWithPaste?.paste?.sharedState.currentState();
    const slice = pasteState?.lastContentPasted?.pastedSlice;
    return slice;
};
const $7e51d18aba717b05$var$getCardUrlAtPasteRange = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos })=>{
    const cardAtPasteRange = (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(editorView.state, pasteStartPos, pasteEndPos);
    if (!cardAtPasteRange) return undefined;
    const node = editorView.state.doc.nodeAt(cardAtPasteRange.pos);
    if (!node) return undefined;
    if (cardAtPasteRange.isNativeEmbed) return (0, $e7a83f0b8653a414$export$98ee8d0cf866fa75)(node);
    const maybeAttrs = node.attrs;
    const maybeUrl = maybeAttrs?.url ?? maybeAttrs?.data?.url;
    return typeof maybeUrl === 'string' ? maybeUrl : undefined;
};
const $7e51d18aba717b05$export$790142d87e85490c = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, targetPos: targetPos })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const maxPos = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, maxPos));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, maxPos));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    const isTargetPosInBounds = targetPos !== undefined && targetPos >= 0 && targetPos <= state.doc.content.size;
    try {
        const nextSelection = isTargetPosInBounds && targetPos !== undefined ? (0, $kCECX.NodeSelection).create(state.doc, targetPos) : (0, $kCECX.TextSelection).create(state.doc, from, to);
        const tr = state.tr.setSelection(nextSelection);
        dispatch(tr);
        return true;
    } catch  {
        return false;
    }
};
const $7e51d18aba717b05$export$1c4f761565a0a1c6 = (editorView)=>{
    const { state: state } = editorView;
    const linkMarkType = state.schema.marks.link;
    if (!linkMarkType) return;
    let firstLinkRange;
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        if (firstLinkRange || !node.isText) return;
        if (linkMarkType.isInSet(node.marks)) firstLinkRange = {
            from: pos,
            to: pos + node.nodeSize
        };
    });
    return firstLinkRange;
};
const $7e51d18aba717b05$export$50ed46eb055a4a90 = ({ editorView: editorView, targetPos: targetPos })=>{
    if (targetPos !== undefined || (0, $9bUBT.getActiveLinkMark)(editorView.state)) return;
    const firstLinkRange = $7e51d18aba717b05$export$1c4f761565a0a1c6(editorView);
    if (!firstLinkRange) return;
    const linkRangeSelectionTr = editorView.state.tr.setSelection((0, $kCECX.TextSelection).create(editorView.state.doc, firstLinkRange.from, firstLinkRange.to));
    editorView.dispatch(linkRangeSelectionTr);
};
const $7e51d18aba717b05$var$PasteDisplayAsMenuHorizontalView = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const toolbarDropdownMenu = (0, $kwf4Z.useToolbarDropdownMenu)();
    const smartCardContext = (0, $9f1Yt.useSmartCardContext)();
    const frameRef = (0, $cozmU.useRef)(null);
    const isApplyingRef = (0, $cozmU.useRef)(false);
    const apiWithPasteOptionsToolbar = api;
    const pasteRange = (0, $3k5Tv.useSharedPluginStateWithSelector)(apiWithPasteOptionsToolbar, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return pluginState ? {
            pasteEndPos: pluginState.pasteEndPos,
            pasteStartPos: pluginState.pasteStartPos
        } : undefined;
    }); // Subscribe to card state so the menu re-renders when resolved card metadata updates.
    (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], (states)=>{
        return states.cardState;
    });
    const pastedLinkUrlFromSlice = (0, $b980ccc002387570$export$6f4c320e305ef7dc)($7e51d18aba717b05$var$getCurrentPastedSlice(api));
    const pastedLinkUrlFromCard = editorView && pasteRange ? $7e51d18aba717b05$var$getCardUrlAtPasteRange({
        editorView: editorView,
        pasteStartPos: pasteRange.pasteStartPos,
        pasteEndPos: pasteRange.pasteEndPos
    }) : undefined;
    const pastedLinkUrl = pastedLinkUrlFromSlice ?? pastedLinkUrlFromCard;
    const pastedLinkUrlState = pastedLinkUrl ? smartCardContext.value?.store?.getState()?.[pastedLinkUrl] : undefined;
    const hasResolvedSmartLinkData = Boolean(pastedLinkUrlState?.details);
    const cardAtPasteRange = editorView && pasteRange ? (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(editorView.state, pasteRange.pasteStartPos, pasteRange.pasteEndPos, pastedLinkUrl) : undefined;
    const currentAppearance = editorView && pasteRange ? cardAtPasteRange?.appearance ?? 'url' : undefined; // A 1P link that resolves to an embed is inserted as a native embed, not an embedCard.
    // It displays as an embed, but the card commands cannot change its appearance.
    const isNativeEmbedPaste = Boolean(cardAtPasteRange?.isNativeEmbed);
    const handleClick = (0, $cozmU.useCallback)((appearance)=>()=>{
            if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance || isApplyingRef.current) return;
            isApplyingRef.current = true;
            const { state: state, dispatch: dispatch } = editorView;
            const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = pasteRange;
            const cardAtRange = (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(state, pasteStartPos, pasteEndPos, pastedLinkUrl);
            if (cardAtRange?.isNativeEmbed) {
                const nativeEmbedNode = state.doc.nodeAt(cardAtRange.pos); // 'embed' is what a native embed already displays as, so there is nothing to apply.
                if (nativeEmbedNode && appearance !== 'embed') (0, $e7a83f0b8653a414$export$127d7a4a58bf6ed2)({
                    editorView: editorView,
                    pos: cardAtRange.pos,
                    node: nativeEmbedNode,
                    appearance: appearance,
                    url: pastedLinkUrl,
                    editorAnalyticsApi: api?.analytics?.actions
                });
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            if (appearance === 'url') {
                if (cardAtRange) (0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(pastedLinkUrl, pastedLinkUrl, true, state.doc.nodeAt(cardAtRange.pos) ?? undefined, cardAtRange.pos, api?.analytics?.actions)(state, dispatch, editorView);
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            const targetPos = cardAtRange?.pos;
            const targetNodeAttrs = targetPos === undefined ? undefined : state.doc.nodeAt(targetPos)?.attrs;
            const targetNodeUrl = targetNodeAttrs?.url ?? targetNodeAttrs?.data?.url;
            const isRecoveredAdjacentPastedCard = (0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true) && targetPos === pasteStartPos - 1 && pasteStartPos === pasteEndPos && targetNodeUrl === pastedLinkUrl;
            if (targetPos !== undefined && targetPos < pasteStartPos && !isRecoveredAdjacentPastedCard) {
                isApplyingRef.current = false;
                return;
            }
            const didApplySelection = $7e51d18aba717b05$export$790142d87e85490c({
                editorView: editorView,
                pasteStartPos: pasteStartPos,
                pasteEndPos: pasteEndPos,
                targetPos: targetPos
            });
            if (!didApplySelection) {
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            $7e51d18aba717b05$export$50ed46eb055a4a90({
                editorView: editorView,
                targetPos: targetPos
            });
            frameRef.current = requestAnimationFrame(()=>{
                frameRef.current = null;
                (0, $ff2860869594b73b$export$a188ef61ddbb94f)(appearance, api?.analytics?.actions)(editorView.state, editorView.dispatch, editorView);
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
            });
        }, [
        api,
        currentAppearance,
        editorView,
        pasteRange,
        pastedLinkUrl,
        toolbarDropdownMenu
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
            isApplyingRef.current = false;
        };
    }, []);
    if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance) return null;
    const preview = allowEmbeds && pastedLinkUrl && smartCardContext.value?.extractors.getPreview(pastedLinkUrl, 'web');
    const blockCardNodeType = editorView.state.schema.nodes.blockCard;
    const embedCardNodeType = editorView.state.schema.nodes.embedCard;
    const isBlockSupportedFromAppearanceContext = allowBlockCards && blockCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(blockCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isEmbedSupportedFromAppearanceContext = allowEmbeds && preview && embedCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(embedCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isSmartLinkConvertible = hasResolvedSmartLinkData;
    const isBlockSupportedFromSelection = allowBlockCards && blockCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(blockCardNodeType.createChecked({})), undefined);
    const isEmbedSupportedFromSelection = allowEmbeds && preview && embedCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(embedCardNodeType.createChecked({})), undefined); // A native embed is replaced in place, so support depends on what its own position
    // accepts rather than on the current selection or on an embed preview being available.
    const nativeEmbedPos = isNativeEmbedPaste ? cardAtPasteRange?.pos : undefined;
    const isSupportedForNativeEmbed = (appearance)=>nativeEmbedPos !== undefined && (0, $e7a83f0b8653a414$export$36c7c06292ba7472)({
            editorView: editorView,
            pos: nativeEmbedPos,
            appearance: appearance
        });
    const isInlineSupported = isNativeEmbedPaste ? isSupportedForNativeEmbed('inline') : true;
    const isBlockSupported = isNativeEmbedPaste ? allowBlockCards && isSupportedForNativeEmbed('block') : Boolean(isBlockSupportedFromAppearanceContext || isBlockSupportedFromSelection);
    const isEmbedSupported = // Whatever was pasted already displays this way, so the option must stay selectable.
    currentAppearance === 'embed' || Boolean(isEmbedSupportedFromAppearanceContext || isEmbedSupportedFromSelection);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        xcss: $7e51d18aba717b05$var$styles.appearanceBox,
        gap: "space.050",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
                appearance: "url",
                currentAppearance: currentAppearance,
                isDisabled: isNativeEmbedPaste && !isSupportedForNativeEmbed('url'),
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).url.title),
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9))),
                onClick: handleClick('url')
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$InlineAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: isNativeEmbedPaste ? !isInlineSupported : !isSmartLinkConvertible,
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).inline.title),
                onClick: handleClick('inline')
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$BlockAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: !isBlockSupported || !isNativeEmbedPaste && !isSmartLinkConvertible,
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).block.title),
                onClick: handleClick('block')
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$EmbedAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: !isEmbedSupported,
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).embed.title),
                onClick: handleClick('embed')
            })
        ]
    });
};
const $7e51d18aba717b05$var$PasteDisplayAsMenuSection = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        title: intl.formatMessage({
            defaultMessage: "Display as",
            id: "fabric.editor.pasteDisplayAsMenu.displayAs"
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$PasteDisplayAsMenuHorizontalView, {
            api: api,
            allowBlockCards: allowBlockCards,
            allowEmbeds: allowEmbeds
        })
    });
};
const $7e51d18aba717b05$export$996593790cad4497 = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, getEditorView: getEditorView, smartCardClientRef: smartCardClientRef })=>{
    const smartlinkAsyncHidden = async (context)=>{
        const { pastedUrl: pastedUrl } = context;
        if (!pastedUrl) return false;
        const isEnabled = (0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true);
        const smartCardClient = smartCardClientRef?.current;
        if (!isEnabled || !smartCardClient) return true;
        try {
            const response = await smartCardClient.fetchData(pastedUrl);
            return response.meta?.access !== 'granted';
        } catch  {
            // Network / auth errors → hide
            return true;
        }
    };
    return [
        {
            type: 'menu-section',
            key: $7e51d18aba717b05$export$3360e99680efcdd8,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU).type,
                    key: (0, $3nacY.PASTE_MENU).key,
                    rank: 60
                }
            ],
            isAsyncHidden: smartlinkAsyncHidden,
            isHidden: ()=>{
                if (!(0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true)) return true;
                const apiWithPasteOptionsToolbar = api;
                const pasteRange = apiWithPasteOptionsToolbar?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                const editorView = getEditorView();
                if (!editorView || !pasteRange) return true;
                 // Slice-shape check — delegated to the toolbar plugin's shared
                // `notSingleLinkRule` via the structural cast (see note above).
                const rules = apiWithPasteOptionsToolbar?.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules();
                if (!rules || rules.notSingleLinkRule()) return true;
                const urlFromSlice = (0, $b980ccc002387570$export$6f4c320e305ef7dc)($7e51d18aba717b05$var$getCurrentPastedSlice(api));
                if (urlFromSlice) return false;
                 // Fallback: plain-text URL paste that the card plugin already resolved into a card node in the doc.
                const urlFromCard = $7e51d18aba717b05$var$getCardUrlAtPasteRange({
                    editorView: editorView,
                    pasteStartPos: pasteRange.pasteStartPos,
                    pasteEndPos: pasteRange.pasteEndPos
                });
                return !urlFromCard;
            },
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$PasteDisplayAsMenuSection, {
                    api: api,
                    allowBlockCards: allowBlockCards,
                    allowEmbeds: allowEmbeds
                })
        }
    ];
};





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");



























var $I2MTF = parcelRequire("I2MTF");


var $9wgTc = parcelRequire("9wgTc");


var $437ur = parcelRequire("437ur");


var $ds2zu = parcelRequire("ds2zu");


var $f1iv3 = parcelRequire("f1iv3");





const $0298a869cdc628ef$export$19175c221bcdac39 = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const isJira = type === 'jira';
    const isConfluenceSearch = type === 'confluence-search';
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert(undefined);
        (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)(type)(tr);
        return tr;
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: isJira ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            label: ""
        }) : isConfluenceSearch ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ds2zu))), {
            label: ""
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($437ur))), {
            label: ""
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        title: formatMessage(isJira ? (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssue : isConfluenceSearch ? (0, $bI2nS.messages).datasourceConfluenceSearch : (0, $bI2nS.messages).datasourceAssetsObjectsGeneralAvailability)
    });
};


const $321aa0c1b5706dd4$export$7da4affb2ef3577f = ({ api: api, options: options })=>{
    if (!options.allowDatasource) return [];
    const components = [
        {
            key: (0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).key,
            type: (0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.DATA_AND_CHARTS_SECTION).key,
                    type: (0, $dCkbP.DATA_AND_CHARTS_SECTION).type,
                    rank: (0, $dXqu3.DATA_AND_CHARTS_SECTION_RANK)[(0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssueDescription),
                    keywords: [
                        'jira'
                    ],
                    title: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssue)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0298a869cdc628ef$export$19175c221bcdac39), {
                    api: api,
                    type: "jira"
                })
        }
    ];
    if ((0, $k3XQC.canRenderDatasource)((0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) components.push({
        key: (0, $dCkbP.ASSETS_MENU_ITEM).key,
        type: (0, $dCkbP.ASSETS_MENU_ITEM).type,
        parents: [
            {
                key: (0, $dCkbP.DATA_AND_CHARTS_SECTION).key,
                type: (0, $dCkbP.DATA_AND_CHARTS_SECTION).type,
                rank: (0, $dXqu3.DATA_AND_CHARTS_SECTION_RANK)[(0, $dCkbP.ASSETS_MENU_ITEM).key]
            }
        ],
        match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                description: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsDescription),
                keywords: [
                    'assets'
                ],
                title: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsGeneralAvailability)
            })),
        component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0298a869cdc628ef$export$19175c221bcdac39), {
                api: api,
                type: "assets"
            })
    });
    if ((0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)((0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID))) components.push({
        key: (0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).key,
        type: (0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).type,
        parents: [
            {
                key: (0, $dCkbP.DATA_AND_CHARTS_SECTION).key,
                type: (0, $dCkbP.DATA_AND_CHARTS_SECTION).type,
                rank: (0, $dXqu3.DATA_AND_CHARTS_SECTION_RANK)[(0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).key]
            }
        ],
        match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                description: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearchDescription),
                keywords: [
                    'confluence'
                ],
                title: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearch)
            })),
        component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0298a869cdc628ef$export$19175c221bcdac39), {
                api: api,
                type: "confluence-search"
            })
    });
    return components;
};



const $d58cf3f7a16e5010$var$PasteMenuSmartCardClientSync = ({ clientRef: clientRef })=>{
    const smartCardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    (0, $cozmU.useEffect)(()=>{
        clientRef.current = smartCardContext?.connections?.client;
    }, [
        clientRef,
        smartCardContext?.connections?.client
    ]);
    return null;
};
const $d58cf3f7a16e5010$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $e998f3a2cd995bba$export$5115a388c364848d)();
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    let instanceEmbedCardTransformers = options.embedCardTransformers;
    let editorViewForPasteMenu;
    const pasteMenuSmartCardClientRef = {
        current: undefined
    };
    const pasteMenuVariant = (0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
    const shouldRegisterPasteDisplayAsMenu = options.enablePasteDisplayAsMenu && [
        'hasSpellingAndGrammar',
        'hasAltAiActions'
    ].includes(pasteMenuVariant);
    if (shouldRegisterPasteDisplayAsMenu) api?.uiControlRegistry?.actions.register((0, $7e51d18aba717b05$export$996593790cad4497)({
        api: api,
        allowBlockCards: options.onlyInlineCards ? false : options.allowBlockCards ?? true,
        allowEmbeds: options.onlyInlineCards ? false : options.allowEmbeds,
        getEditorView: ()=>editorViewForPasteMenu,
        smartCardClientRef: pasteMenuSmartCardClientRef
    }));
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $321aa0c1b5706dd4$export$7da4affb2ef3577f)({
        api: api,
        options: options
    }));
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $7e11113c0b6b9b64$export$290edac762b9f37c)()
                }
            ];
            // `onlyInlineCards` is a hard gate: when set, blockCard/embedCard
            // stay out of the schema regardless of allowBlockCards/allowEmbeds.
            if (options.onlyInlineCards) return nodes;
            nodes.push({
                name: 'blockCard',
                node: (0, $dc39c5d622176d3d$export$f664dd11022c8749)()
            });
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $75ce2aa51e74c7ef$export$f8faabd3267a007e)()
            });
            return nodes;
        },
        pmPlugins () {
            // onlyInlineCards forces block/embed off regardless of caller-passed flags,
            // keeping the schema gate (in nodes()) and the runtime gate in sync.
            const allowBlockCards = options.onlyInlineCards ? false : options.allowBlockCards ?? true;
            const allowEmbeds = options.onlyInlineCards ? false : options.allowEmbeds;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $ce69229594a80c43$export$ae829ec7b2625219)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowEmbeds: allowEmbeds,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        embedCardTransformers: instanceEmbedCardTransformers,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $1ddf8f052569320c$export$fc7a7a088775f35d)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            editorViewForPasteMenu = editorView;
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    shouldRegisterPasteDisplayAsMenu && /*#__PURE__*/ (0, $8aG6j.jsx)($d58cf3f7a16e5010$var$PasteMenuSmartCardClientSync, {
                        clientRef: pasteMenuSmartCardClientRef
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9643dc942ac34a79$export$e7d7ea2bc9a806d9), {
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2b23ce52995f75a4$export$c083a9ed3df8f5ac), {
                        cardPluginEvents: cardPluginEvents,
                        editorView: editorView
                    }),
                    breakoutEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4dc197bbbd70ac9$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        scrollableElement: popupsScrollableElement,
                        boundariesElement: popupsBoundariesElement
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b5999f9a6963362$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView
                    })
                ]
            });
        },
        commands: {
            queueCardsFromRange: (from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)=>({ tr: tr })=>(0, $ff2860869594b73b$export$86b4b08ffadfa0a6)(// Synthesise the minimal EditorState shape the impl actually reads.
                    {
                        schema: tr.doc.type.schema,
                        selection: tr.selection
                    }, tr, from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $28eb8ceae9a9c979$export$1572b3eade6662f9)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $28eb8ceae9a9c979$export$bd1cd60a9b31da5e,
            queueCardsFromChangedTr: $ff2860869594b73b$export$f17c48478174211e,
            queueCardsFromRange: $ff2860869594b73b$export$86b4b08ffadfa0a6,
            registerEmbedCardTransformer: (transformers)=>{
                instanceEmbedCardTransformers = transformers;
            },
            resolveShortLinkUrl: async (url)=>{
                if (!options.provider) return undefined;
                try {
                    const provider = await options.provider;
                    // EditorCardProvider holds a CardClient instance internally. We access it
                    // directly to call fetchData, which gives us the raw ORS JSON-LD response
                    // including the canonical url field — something provider.resolve() does not
                    // surface. This is intentionally a structural cast rather than a typed
                    // dependency on EditorCardProvider's private API.
                    const clientHolder = provider;
                    const client = clientHolder.cardClient;
                    if (!client) return undefined;
                    const response = await client.fetchData(url);
                    // ORS returns a JsonLd.Response whose data union includes BaseData,
                    // BaseCollectionData, and BaseCollectionPage. We only care about the
                    // `url` field which is present on BaseData (Primitives.Object). Cast
                    // to a minimal shape rather than accessing through the full union type.
                    const data = response?.data;
                    if (!data) return undefined;
                    const urlField = data.url;
                    // Property<string | Link> can be a string, a Link object, or an array.
                    // Short-link responses always return a plain string URL.
                    if (typeof urlField === 'string' && urlField !== url) return urlField;
                    // Fallback: Link object shape with href or @id
                    if (urlField && typeof urlField === 'object' && !Array.isArray(urlField)) {
                        const linkObj = urlField;
                        const id = linkObj['@id'] ?? linkObj['href'];
                        if (typeof id === 'string' && id !== url) return id;
                    }
                } catch  {
                // Swallow errors — callers handle undefined
                }
                return undefined;
            },
            getStartingToolbarItems: (0, $cc2f82b3700a9ffb$export$bb790f15a666b7f0)(options, api),
            getEndingToolbarItems: (0, $cc2f82b3700a9ffb$export$d5ca70670b9f6b9)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $cc2f82b3700a9ffb$export$4850df084251d287)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    const quickInsertArray = [];
                    if (!options.allowDatasource) return quickInsertArray;
                    quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssue),
                        description: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssueDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'jira'
                        ],
                        featured: true,
                        ...(0, $iDrrr.fg)('jim-lower-ranking-in-jira-macro-search') && {
                            priority: 500
                        },
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDatasourceJiraIssue), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)('jira')(tr);
                            return tr;
                        }
                    });
                    if ((0, $k3XQC.canRenderDatasource)((0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsGeneralAvailability),
                        description: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'assets'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDatasourceAssetsObjects), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)('assets')(tr);
                            return tr;
                        }
                    });
                    if ((0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)((0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearch),
                        description: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearchDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'confluence'
                        ],
                        featured: true,
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDatasourceConfluenceSearch), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)('confluence-search')(tr);
                            return tr;
                        }
                    });
                    return quickInsertArray;
                }
            }
        }
    };
};
module.exports["cardPlugin"] = $d58cf3f7a16e5010$export$2a6748328f902e16;

});

parcelRegister("gjFO5", function(module, exports) {
var $3657d91fd05ab098$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $3657d91fd05ab098$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});
module.exports["LAYOUT_TYPE"] = $3657d91fd05ab098$export$9710eda883ce7be2;
module.exports["SMART_LINK_TYPE"] = $3657d91fd05ab098$export$804a928ffc86c02c;

});

parcelRegister("f7XUl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9f1Yt = parcelRequire("9f1Yt");

const $704a7a694f09cf02$export$2a29ca11e08dc129 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    const Provider = cardContext.Provider;
    let t1;
    if ($[0] !== Provider || $[1] !== cardContext.value || $[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Provider, {
            value: cardContext.value
        }, children);
        $[0] = Provider;
        $[1] = cardContext.value;
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Provider, {
        value: cardContext.value
    }, children);
};
module.exports["EditorSmartCardProvider"] = $704a7a694f09cf02$export$2a29ca11e08dc129;

});

parcelRegister("10uVA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9f1Yt = parcelRequire("9f1Yt");

const $a975770660f37109$export$797e3658f090919c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    if (!cardContext?.value) return null;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["EditorSmartCardProviderValueGuard"] = $a975770660f37109$export$797e3658f090919c;

});

parcelRegister("1A89X", function(module, exports) {

var $5aU9U = parcelRequire("5aU9U");


var $eOaGc = parcelRequire("eOaGc");


var $aPdNQ = parcelRequire("aPdNQ");

class $7e4c18d2699116f4$export$8cfd0a0bfa522949 extends (0, $5aU9U.Step) {
    apply(doc) {
        const target = doc.nodeAt(this.pos);
        if (!target) return (0, $eOaGc.StepResult).fail('No node at given position');
        if (target.isText) return (0, $eOaGc.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        const newNode = target.type.create(attrs, (0, $aPdNQ.Fragment).empty, target.marks);
        const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $eOaGc.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        const target = doc.nodeAt(this.pos);
        return new $7e4c18d2699116f4$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        const result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $7e4c18d2699116f4$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $7e4c18d2699116f4$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
    constructor(pos, attrs){
        super();
        this.pos = void 0;
        this.attrs = void 0;
        this.pos = pos;
        this.attrs = attrs;
    }
}
(0, $5aU9U.Step).jsonID('setAttrs', $7e4c18d2699116f4$export$8cfd0a0bfa522949);
module.exports["SetAttrsStep"] = $7e4c18d2699116f4$export$8cfd0a0bfa522949;

});

parcelRegister("89gPK", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $5ad357f2123c826c$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
module.exports["calcColumnsFromPx"] = $5ad357f2123c826c$export$10912f14d8d54640;

});

parcelRegister("b8ZJI", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $89gPK = parcelRequire("89gPK");


var $e3qgT = parcelRequire("e3qgT");


var $yNGEI = parcelRequire("yNGEI");


var $34CLe = parcelRequire("34CLe");


const $4f7a300912d0ecb6$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $4f7a300912d0ecb6$export$adfc02948d64a4f2 = (layout)=>$4f7a300912d0ecb6$var$validWidthModes.indexOf(layout) > -1;
const $4f7a300912d0ecb6$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil((0, $yNGEI.calcPxFromPct)(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $4f7a300912d0ecb6$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $4f7a300912d0ecb6$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $4f7a300912d0ecb6$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7Y8M5.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7Y8M5.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ((0, $34CLe.wrappedLayouts).indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return calculatedPctWidth;
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && (0, $34CLe.wrappedLayouts).indexOf(layout) !== -1) // when layout is wrap-left, wrap-right, align-start, align-end
    // but no pctWidth is defined
    return Math.min((0, $yNGEI.calcPxFromPct)(0.5, lineLength || width), origWidth);
    return origWidth;
};
const $4f7a300912d0ecb6$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = (0, $yNGEI.calcPxFromPct)(gridWidth / 100, lineLength);
    const columnSpan = Math.round((0, $89gPK.calcColumnsFromPx)(pxWidth, lineLength, gridSize));
    const alignedWidth = (0, $e3qgT.calcPxFromColumns)(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};
module.exports["calcMediaPxWidth"] = $4f7a300912d0ecb6$export$5e51fc02b9ada5af;

});

parcelRegister("76kDm", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $d7bd499ffb775b71$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
module.exports["calcPctFromPx"] = $d7bd499ffb775b71$export$55ddb36b3404ec6d;

});

parcelRegister("bfl0n", function(module, exports) {
const $037ce7e6baaea8b0$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
module.exports["handleSides"] = $037ce7e6baaea8b0$export$8ee741c8b9b43371;

});

parcelRegister("fb9eF", function(module, exports) {
const $d4d7391d9317696f$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};
module.exports["imageAlignmentMap"] = $d4d7391d9317696f$export$9aaf3d5fbdfcf5c5;

});

parcelRegister("3GQSw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $5X6fy = parcelRequire("5X6fy");


var $9to0k = parcelRequire("9to0k");


var $7Y8M5 = parcelRequire("7Y8M5");


var $krYZG = parcelRequire("krYZG");


var $l3s1y = parcelRequire("l3s1y");


var $8dGm2 = parcelRequire("8dGm2");


var $bfl0n = parcelRequire("bfl0n");


var $h5qPS = parcelRequire("h5qPS");

const $8fc8e2ef5831c0bb$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $krYZG.ACTION_SUBJECT).EMBEDS : (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $krYZG.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    };
};
const $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $8fc8e2ef5831c0bb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $bfl0n.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $7Y8M5.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $l3s1y.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        const nonZeroWidth = width || '100%'; // In SSR width could be 0 initially
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9to0k.Resizable), {
            ref: this.resizable,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            size: {
                width: nonZeroWidth,
                // just content itself (no paddings)
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = {
            isResizing: false
        };
        this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints, onResizeStart: onResizeStart } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            if (onResizeStart) onResizeStart();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(layout), newHighlights);
            });
        };
        this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        };
        this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $h5qPS.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($8fc8e2ef5831c0bb$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $8dGm2.gridTypeForLayout)(layout), []);
            });
        };
    }
}
module.exports["default"] = $8fc8e2ef5831c0bb$export$2e2bcd8739ae039;

});

parcelRegister("9to0k", function(module, exports) {
"use strict";
var $6e597142fca2a0bf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6e597142fca2a0bf$var$__assign = module.exports && module.exports.__assign || function() {
    $6e597142fca2a0bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e597142fca2a0bf$var$__assign.apply(this, arguments);
};
var $6e597142fca2a0bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $6e597142fca2a0bf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6e597142fca2a0bf$var$React = $6e597142fca2a0bf$var$__importStar((parcelRequire("cozmU")));

var $9aSOx = parcelRequire("9aSOx");


var $6e597142fca2a0bf$var$fast_memoize_1 = $6e597142fca2a0bf$var$__importDefault((parcelRequire("9HfYc")));
var $6e597142fca2a0bf$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $6e597142fca2a0bf$var$clamp = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $6e597142fca2a0bf$var$snap = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $6e597142fca2a0bf$var$hasDirection = $6e597142fca2a0bf$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $6e597142fca2a0bf$var$findClosestSnap = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $6e597142fca2a0bf$var$endsWith = $6e597142fca2a0bf$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $6e597142fca2a0bf$var$getStringSize = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'px')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, '%')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vh')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vw')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vmax')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $6e597142fca2a0bf$var$calculateNewMax = $6e597142fca2a0bf$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $6e597142fca2a0bf$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $6e597142fca2a0bf$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $6e597142fca2a0bf$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $6e597142fca2a0bf$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $6e597142fca2a0bf$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $6e597142fca2a0bf$var$baseClassName = '__resizable_base__';
var $6e597142fca2a0bf$var$Resizable = /** @class */ function(_super) {
    $6e597142fca2a0bf$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $6e597142fca2a0bf$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($6e597142fca2a0bf$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $6e597142fca2a0bf$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($6e597142fca2a0bf$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $6e597142fca2a0bf$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $6e597142fca2a0bf$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $6e597142fca2a0bf$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($6e597142fca2a0bf$var$baseClassName);
        else element.className += $6e597142fca2a0bf$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($6e597142fca2a0bf$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($6e597142fca2a0bf$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($6e597142fca2a0bf$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($6e597142fca2a0bf$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $6e597142fca2a0bf$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $6e597142fca2a0bf$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $6e597142fca2a0bf$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $6e597142fca2a0bf$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $6e597142fca2a0bf$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $6e597142fca2a0bf$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $6e597142fca2a0bf$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $6e597142fca2a0bf$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $6e597142fca2a0bf$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($6e597142fca2a0bf$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($6e597142fca2a0bf$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($6e597142fca2a0bf$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($6e597142fca2a0bf$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($6e597142fca2a0bf$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($6e597142fca2a0bf$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $6e597142fca2a0bf$var$React.createElement($9aSOx.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $6e597142fca2a0bf$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($6e597142fca2a0bf$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $6e597142fca2a0bf$var$React.createElement("div", $6e597142fca2a0bf$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $6e597142fca2a0bf$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $6e597142fca2a0bf$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($6e597142fca2a0bf$var$React.PureComponent);
module.exports.Resizable = $6e597142fca2a0bf$var$Resizable;

});

parcelRegister("9HfYc", function(module, exports) {
//
// Main
//
function $70f4847fca63d9bd$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $70f4847fca63d9bd$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $70f4847fca63d9bd$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $70f4847fca63d9bd$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $70f4847fca63d9bd$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $70f4847fca63d9bd$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $70f4847fca63d9bd$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $70f4847fca63d9bd$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $70f4847fca63d9bd$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $70f4847fca63d9bd$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $70f4847fca63d9bd$var$monadic : $70f4847fca63d9bd$var$variadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $70f4847fca63d9bd$var$strategyVariadic(fn, options) {
    var strategy = $70f4847fca63d9bd$var$variadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $70f4847fca63d9bd$var$strategyMonadic(fn, options) {
    var strategy = $70f4847fca63d9bd$var$monadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $70f4847fca63d9bd$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $70f4847fca63d9bd$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $70f4847fca63d9bd$var$cacheDefault = {
    create: function create() {
        return new $70f4847fca63d9bd$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $70f4847fca63d9bd$var$memoize;
module.exports.strategies = {
    variadic: $70f4847fca63d9bd$var$strategyVariadic,
    monadic: $70f4847fca63d9bd$var$strategyMonadic
};

});

parcelRegister("h5qPS", function(module, exports) {
const $3866694567b9f2f6$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? // extreme last case if there are no points somehow
    target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
module.exports["snapTo"] = $3866694567b9f2f6$export$ce5a040a76868800;

});

parcelRegister("jU5kz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $hZR9z = parcelRequire("hZR9z");


var $6aEgq = parcelRequire("6aEgq");


var $4ezc2 = parcelRequire("4ezc2");


var $bH62g = parcelRequire("bH62g");


var $f922E = parcelRequire("f922E");


var $2PKI8 = parcelRequire("2PKI8");


var $4mxZP = parcelRequire("4mxZP");


var $f4MCV = parcelRequire("f4MCV");


var $iUhs4 = parcelRequire("iUhs4");


var $9V98o = parcelRequire("9V98o");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $5I4Vo = parcelRequire("5I4Vo");


var $ldqjS = parcelRequire("ldqjS");


var $2xhuI = parcelRequire("2xhuI");

var $2BvhC = parcelRequire("2BvhC");


var $6keIx = parcelRequire("6keIx");


var $dAzds = parcelRequire("dAzds");

var $gtLXJ = parcelRequire("gtLXJ");

var $8qft0 = parcelRequire("8qft0");

const $a9d84f7bb61ac6b4$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6aEgq))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon"
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hZR9z))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon"
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ezc2))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon"
            })
    }
];
const $a9d84f7bb61ac6b4$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bH62g))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignRight)
    }
];
const $a9d84f7bb61ac6b4$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4MCV))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon"
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUhs4))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon"
            })
    }
];
const $a9d84f7bb61ac6b4$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9V98o)))
    }
];
const $a9d84f7bb61ac6b4$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $2BvhC.toolbarMessages).wrapLeft,
    center: (0, $2xhuI.default).alignImageCenter,
    'wrap-right': (0, $2BvhC.toolbarMessages).wrapRight,
    wide: (0, $2xhuI.default).layoutWide,
    'full-width': (0, $2xhuI.default).layoutFullWidth,
    'align-end': (0, $2xhuI.default).alignImageRight,
    'align-start': (0, $2xhuI.default).alignImageLeft
};
const $a9d84f7bb61ac6b4$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $a9d84f7bb61ac6b4$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $a9d84f7bb61ac6b4$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? // with extended experience, change alignment does not change media single width
        {
            ...node.attrs,
            layout: layout
        } : (0, $dAzds.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $5I4Vo.insideTable)(state) || (0, $gtLXJ.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).SELECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $a9d84f7bb61ac6b4$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $8qft0.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[value]),
            selected: $a9d84f7bb61ac6b4$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $a9d84f7bb61ac6b4$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $a9d84f7bb61ac6b4$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[value]),
            selected: $a9d84f7bb61ac6b4$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $a9d84f7bb61ac6b4$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                    children: (0, $ldqjS.tooltip)(layoutOption.keyboardShortcut)
                })
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $bjg0G.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        ...(0, $ieeJu.expValEquals)('editor_enable_image_alignment_in_expand', 'isEnabled', true) ? [] : [
            nodes.expand,
            nodes.nestedExpand
        ],
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $a9d84f7bb61ac6b4$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || !selection.node || !nodeType || $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$a9d84f7bb61ac6b4$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$a9d84f7bb61ac6b4$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $a9d84f7bb61ac6b4$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || !selection.node || !nodeType || $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$a9d84f7bb61ac6b4$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$a9d84f7bb61ac6b4$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$a9d84f7bb61ac6b4$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $a9d84f7bb61ac6b4$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $a9d84f7bb61ac6b4$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $a9d84f7bb61ac6b4$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $8qft0.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $a9d84f7bb61ac6b4$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $a9d84f7bb61ac6b4$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a9d84f7bb61ac6b4$export$2e2bcd8739ae039 = $a9d84f7bb61ac6b4$var$buildLayoutButtons;
module.exports["alignmentIcons"] = $a9d84f7bb61ac6b4$export$45400139bf999022;
module.exports["wrappingIcons"] = $a9d84f7bb61ac6b4$export$88511ca1ca567d46;
module.exports["layoutToMessages"] = $a9d84f7bb61ac6b4$export$b978ceeb25a89f87;
module.exports["buildLayoutDropdown"] = $a9d84f7bb61ac6b4$export$31e29507a90f6f72;
module.exports["default"] = $a9d84f7bb61ac6b4$export$2e2bcd8739ae039;

});

parcelRegister("kVd8s", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $5aU9U = parcelRequire("5aU9U");


var $eOaGc = parcelRequire("eOaGc");

const $616ba2be6cd111db$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $616ba2be6cd111db$export$c1b7e6427b2a2113 extends (0, $5aU9U.Step) {
    invert() {
        return new $616ba2be6cd111db$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $616ba2be6cd111db$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    constructor(pos, prev, next){
        super();
        this.prev = void 0;
        this.next = void 0;
        this.pos = void 0;
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $5aU9U.Step).jsonID($616ba2be6cd111db$export$3f33e36adb7672cc, $616ba2be6cd111db$export$c1b7e6427b2a2113);
module.exports["TableSortStep"] = $616ba2be6cd111db$export$c1b7e6427b2a2113;

});

parcelRegister("brzQy", function(module, exports) {

var $73Kv0 = parcelRequire("73Kv0");

function $b5456d47f1a39227$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
module.exports["getLinkMetadataFromTransaction"] = $b5456d47f1a39227$export$3aba02526a1e2e78;

});

parcelRegister("ju0ww", function(module, exports) {

let $e2f139a22bf117fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e2f139a22bf117fb$var$load("7hrcy"),
    $e2f139a22bf117fb$var$load("c3RBb"),
    $e2f139a22bf117fb$var$load("Lm7SH"),
    $e2f139a22bf117fb$var$load("axcf5")
]).then(()=>parcelRequire('aWop1'));

});

parcelRegister("3gmKQ", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $hVgcP = parcelRequire("hVgcP");


var $ixHGM = parcelRequire("ixHGM");


var $20WsY = parcelRequire("20WsY");


var $kpCD8 = parcelRequire("kpCD8");


var $iDrrr = parcelRequire("iDrrr");


var $krYZG = parcelRequire("krYZG");
var $b9b39f75b7ac85cf$export$bbbdd76b3dbe0ab9 = /*#__PURE__*/ function(GAP_CURSOR_POSITION) {
    GAP_CURSOR_POSITION["LEFT"] = "left";
    GAP_CURSOR_POSITION["RIGHT"] = "right";
    return GAP_CURSOR_POSITION;
}({});
var $b9b39f75b7ac85cf$export$b9401faa25e39d87 = /*#__PURE__*/ function(TARGET_SELECTION_SOURCE) {
    TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
    TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
    return TARGET_SELECTION_SOURCE;
}({});



var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $3ztIq = parcelRequire("3ztIq");





var $liXVw = parcelRequire("liXVw");

var $gWBVp = parcelRequire("gWBVp");


var $2lPWP = parcelRequire("2lPWP");


var $aPdNQ = parcelRequire("aPdNQ");











var $ieeJu = parcelRequire("ieeJu");





var $dpfrn = parcelRequire("dpfrn");








var $cI8RZ = parcelRequire("cI8RZ");




const $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('extensionPlugin');


function $004bdf518602b49b$export$2e2bcd8739ae039(pluginState, action) {
    switch(action.type){
        case 'UPDATE_STATE':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
}


const $7d5ef977555345d3$var$factory = (0, $cI8RZ.pluginFactory)((0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1), (0, $004bdf518602b49b$export$2e2bcd8739ae039), {
    mapping (tr, state) {
        const { positions: previousPositions } = state;
        if (!previousPositions) return state;
        const positions = {
            ...previousPositions
        };
        // eslint-disable-next-line guard-for-in
        for(const key in positions)positions[key] = tr.mapping.map(positions[key]);
        return {
            ...state,
            positions: positions
        };
    }
});
const $7d5ef977555345d3$export$656c7661095efe2e = $7d5ef977555345d3$var$factory.createPluginState;
const $7d5ef977555345d3$export$8d4021544bdece00 = $7d5ef977555345d3$var$factory.createCommand;
const $7d5ef977555345d3$export$f05434c51e3762e = $7d5ef977555345d3$var$factory.getPluginState;






var $jfFbl = parcelRequire("jfFbl");


var $btvbC = parcelRequire("btvbC");

var $2l49p = parcelRequire("2l49p");








var $cRgxl = parcelRequire("cRgxl");

const $167f96829d9c9919$export$cdb701fa2b3c99df = (state, searchParent = false)=>{
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    return (0, $bjg0G.findSelectedNodeOfType)(nodeTypes)(state.selection) || searchParent && (0, $bjg0G.findParentNodeOfType)(nodeTypes)(state.selection) || undefined;
};
const $167f96829d9c9919$export$b003700b6d25caa7 = (state, localId)=>{
    const selectedExtension = $167f96829d9c9919$export$cdb701fa2b3c99df(state, true);
    if (!localId) return selectedExtension;
    if (selectedExtension && selectedExtension.node.attrs.localId === localId) return selectedExtension;
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    let matched;
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.includes(node.type) && node.attrs.localId === localId) matched = {
            node: node,
            pos: pos
        };
    });
    return matched;
};
const $167f96829d9c9919$export$f1c79f28529bfc9a = (schema, domAtPos, selectedExtensionNode)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const selectedExtensionDomNode = (0, $bjg0G.findDomRefAtPos)(selectedExtensionNode.pos, domAtPos);
    const isContentExtension = selectedExtensionNode.node.type !== schema.nodes.bodiedExtension;
    return(// Content extension can be nested in bodied-extension, the following check is necessary for that case
    (isContentExtension // Search down
     ? selectedExtensionDomNode.querySelector('.extension-container') // Try searching up and then down
     : (0, $btvbC.closestElement)(selectedExtensionDomNode, '.extension-container') || selectedExtensionDomNode.querySelector('.extension-container')) || selectedExtensionDomNode);
};
const $167f96829d9c9919$export$cd9967958db163fc = (newNode)=>newNode.marks?.find((mark)=>mark.type.name === 'dataConsumer');
const $167f96829d9c9919$export$1004a88e790d2d21 = (ids, state)=>{
    return (0, $2l49p.findNodePosByLocalIds)(state, ids, {
        includeDocNode: true
    }).map(({ node: node })=>node.type.name);
};
const $167f96829d9c9919$export$bb057d1dfc5c8b1b = (state, localId)=>{
    const nodes = (0, $2l49p.findNodePosByLocalIds)(state, [
        localId
    ]);
    return nodes.length >= 1 ? nodes[0] : undefined;
};
/**
 * Converts a ProseMirror node to its text representation.
 * Handles text nodes with marks (links) and inline nodes (status, mention, emoji).
 * Returns the content for this node, with a trailing separator for text blocks.
 */ const $167f96829d9c9919$var$convertNodeToText = (node, mentionSet, parent, locale)=>{
    if (node.isInline) {
        const schema = node.type.schema;
        let finalText = '';
        if (node.isText) {
            finalText = node.text || '';
            if (node.marks.length > 0) {
                for (const mark of node.marks)// if it's link, include the href in the text
                if (mark.type === schema.marks.link) {
                    const href = mark.attrs.href;
                    const text = node.text || '';
                    // If the text differs from the href, include both
                    if (text && text !== href) finalText = `${text} ${href}`;
                    else finalText = href;
                }
            }
        } else switch(node.type){
            case schema.nodes.status:
                finalText = node.attrs.text || '';
                break;
            case schema.nodes.mention:
                mentionSet.add(node.attrs.id);
                finalText = `@${node.attrs.id}`;
                break;
            case schema.nodes.emoji:
                finalText = node.attrs.shortName || '';
                break;
            case schema.nodes.date:
                const timestamp = new Date(Number(node.attrs.timestamp));
                finalText = !isNaN(timestamp.getTime()) ? timestamp.toLocaleDateString(locale ?? 'en-US') : String(node.attrs.timestamp);
                break;
            default:
                finalText = node.textContent;
                break;
        }
        if (parent && parent.isTextblock && node === parent.lastChild && parent.childCount > 0) finalText += '\n\n';
        return finalText;
    }
    return '';
};
/**
 * Resolves mention IDs to their display names and replaces them in the text.
 * Returns the text with resolved mentions, or the original text if the provider is unavailable.
 */ const $167f96829d9c9919$var$resolveMentionsInText = async (text, mentionSet, api)=>{
    const mentionProvider = api?.mention?.sharedState?.currentState()?.mentionProvider;
    if (!mentionProvider || !(0, $cRgxl.isResolvingMentionProvider)(mentionProvider)) return text;
    let resolvedText = text;
    for (const id of mentionSet){
        const mention = await mentionProvider.resolveMentionName(id);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        resolvedText = resolvedText.replace(`@${id}`, `@${mention.name}` || "@\u2026");
    }
    return resolvedText;
};
const $167f96829d9c9919$export$9defe25170de6263 = async ({ locale: locale, schema: schema, unsupportedContent: unsupportedContent, api: api })=>{
    try {
        if (!unsupportedContent) throw new Error('No nested content found');
        if (unsupportedContent.type !== 'doc') unsupportedContent = {
            version: 1,
            type: 'doc',
            content: [
                unsupportedContent
            ]
        };
        const transformer = new (0, $2lPWP.JSONTransformer)(schema);
        const pmNode = transformer.parse(unsupportedContent);
        let text = '';
        const mentionSet = new Set();
        pmNode.nodesBetween(0, pmNode.content.size, (node, _pos, parent)=>{
            text += $167f96829d9c9919$var$convertNodeToText(node, mentionSet, parent, locale);
        });
        // Trim leading/trailing whitespace from the collected text
        text = text.trim();
        text = await $167f96829d9c9919$var$resolveMentionsInText(text, mentionSet, api);
        (0, $jfFbl.copyToClipboard)(text);
    } catch (error) {
        throw error instanceof Error ? error : new Error('Failed to copy content');
    }
};
const $167f96829d9c9919$export$67e8f2a5d4f25de0 = ({ error: error, extensionApi: extensionApi, state: state })=>{
    const nodeWithPos = $167f96829d9c9919$export$cdb701fa2b3c99df(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    extensionApi?.analytics?.actions.fireAnalyticsEvent({
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        action: (0, $krYZG.ACTION).COPY_FAILED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: node.type.name,
        attributes: {
            extensionKey: extensionKey,
            extensionType: extensionType,
            errorMessage: error.message,
            errorStack: error.stack
        }
    });
};


function $3d915853de2ecd5c$export$4971331372cec95a(state) {
    return (0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: state
    });
}
function $3d915853de2ecd5c$export$845f8c516a847983(processParametersBefore, processParametersAfter, applyChangeToContextPanel) {
    return (0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: true,
            processParametersBefore: processParametersBefore,
            processParametersAfter: processParametersAfter
        }
    }, applyChangeToContextPanel);
}
const $3d915853de2ecd5c$export$81748740fe20ba64 = (applyChangeToContextPanel)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: false,
            processParametersBefore: undefined,
            processParametersAfter: undefined
        }
    }, applyChangeToContextPanel);
const $3d915853de2ecd5c$export$265d048971b3d878 = (applyChangeToContextPanel)=>(resolve, reject)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
            type: 'UPDATE_STATE',
            data: {
                autoSaveResolve: resolve,
                autoSaveReject: reject
            }
        }, applyChangeToContextPanel);
const $3d915853de2ecd5c$export$612be0ec35a64e3b = (layout, analyticsApi)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            layout: layout
        }
    }, (tr, state)=>{
        const selectedExtension = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
        if (selectedExtension) {
            const trWithNewNodeMarkup = tr.setNodeMarkup(selectedExtension.pos, undefined, {
                ...selectedExtension.node.attrs,
                layout: layout
            });
            trWithNewNodeMarkup.setMeta('scrollIntoView', false);
            if (analyticsApi) analyticsApi.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    extensionType: selectedExtension.node.attrs.extensionType,
                    extensionKey: selectedExtension.node.attrs.extensionKey,
                    localId: selectedExtension.node.attrs.localId,
                    layout: layout,
                    selection: tr.selection.toJSON(),
                    targetSelectionSource: (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION
                }
            })(tr);
            return trWithNewNodeMarkup;
        }
        return tr;
    });
const $3d915853de2ecd5c$export$366c74c25333cf63 = (editorAnalyticsAPI, inputMethod)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        if ((0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state)) return $3d915853de2ecd5c$export$8bdb85550181fac8(state, tr, editorAnalyticsAPI, inputMethod);
        else return $3d915853de2ecd5c$export$a5879ac679bfa06d(state, tr, editorAnalyticsAPI, inputMethod);
    });
const $3d915853de2ecd5c$export$fa79c3ccfdddfece = (sourceNode)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $dpfrn.removeConnectedNodes)(state, sourceNode) : tr;
    });
const $3d915853de2ecd5c$export$8bdb85550181fac8 = (state, tr, analyticsApi, inputMethod)=>{
    if (state.selection instanceof (0, $kCECX.NodeSelection)) {
        const node = state.selection.node;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $bjg0G.removeSelectedNode)(tr);
};
const $3d915853de2ecd5c$export$a5879ac679bfa06d = (state, tr, analyticsApi, inputMethod)=>{
    let nodeType = state.schema.nodes.bodiedExtension;
    const maybeMBENode = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.multiBodiedExtension)(state.selection);
    if (maybeMBENode) {
        nodeType = state.schema.nodes.multiBodiedExtension;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: maybeMBENode.node.attrs.extensionType,
                extensionKey: maybeMBENode.node.attrs.extensionKey,
                localId: maybeMBENode.node.attrs.localId,
                currentFramesCount: maybeMBENode.node.content.childCount,
                inputMethod: inputMethod
            }
        })(tr);
    }
    const bodiedExtensionNode = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
    if (bodiedExtensionNode) {
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: bodiedExtensionNode.node.attrs.extensionType,
                extensionKey: bodiedExtensionNode.node.attrs.extensionKey,
                localId: bodiedExtensionNode.node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $bjg0G.removeParentNodeOfType)(nodeType)(tr);
};



var $9Rq82 = parcelRequire("9Rq82");





var $8tXCb = parcelRequire("8tXCb");


var $YvadP = parcelRequire("YvadP");











const $61358629666c9a4d$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('macroPlugin');


const $783fd49d73f6388e$export$4ec44b2939e261e2 = (editorAnalyticsAPI)=>(macroProvider, macroNode, isEditing)=>async (view)=>{
            if (!macroProvider) return false;
            // opens MacroBrowser for editing "macroNode" if passed in
            const newMacro = await macroProvider.openMacroBrowser(macroNode);
            if (newMacro && macroNode) {
                const { state: state, dispatch: dispatch } = view;
                const currentLayout = macroNode && macroNode.attrs.layout || 'default';
                const node = $783fd49d73f6388e$export$87074dfcaea41da3(newMacro, state, {
                    layout: currentLayout
                });
                if (!node) return false;
                const { selection: selection, schema: schema } = state;
                const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const updateSelectionsByNodeType = (nodeType)=>{
                    // `isEditing` is `false` when we are inserting from insert-block toolbar
                    tr = isEditing ? (0, $bjg0G.replaceParentNodeOfType)(nodeType, node)(tr) : (0, $bjg0G.safeInsert)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, state.selection.anchor));
                };
                const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
                let targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION;
                let { tr: tr } = state;
                const isBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                    bodiedExtension
                ])(selection);
                const isMultiBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                    multiBodiedExtension
                ])(selection);
                // When it's a bodiedExtension but not selected
                if (macroNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
                else if (macroNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
                else if ((0, $bjg0G.findSelectedNodeOfType)([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ])(selection)) {
                    tr = (0, $bjg0G.replaceSelectedNode)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
                } else if (extensionState.element) {
                    const pos = view.posAtDOM(extensionState.element, -1);
                    if (pos > -1) {
                        tr = tr.replaceWith(pos, pos + macroNode.nodeSize, node);
                        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos)));
                        targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).HTML_ELEMENT;
                    }
                }
                // Only scroll if we have anything to update, best to avoid surprise scroll
                if (dispatch && tr.docChanged) {
                    const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = macroNode.attrs;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).UPDATED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                        actionSubjectId: macroNode.type.name,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                            // This error was introduced after upgrading to TypeScript 5
                            inputMethod: isEditing ? (0, $krYZG.INPUT_METHOD).MACRO_BROWSER : (0, $krYZG.INPUT_METHOD).TOOLBAR,
                            extensionType: extensionType,
                            extensionKey: extensionKey,
                            layout: layout,
                            localId: localId,
                            selection: tr.selection.toJSON(),
                            targetSelectionSource: targetSelectionSource
                        }
                    })(tr);
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            return false;
        };
const $783fd49d73f6388e$export$87074dfcaea41da3 = (macro, state, optionalAttrs)=>{
    if (!macro || !state) return null;
    const { schema: schema } = state;
    const { type: type, attrs: attrs } = (0, $YvadP.getValidNode)(macro, schema);
    let node = null;
    if (type === 'extension') node = schema.nodes.extension.create({
        ...attrs,
        ...optionalAttrs
    });
    else if (type === 'bodiedExtension') node = schema.nodes.bodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    else if (type === 'inlineExtension') node = schema.nodes.inlineExtension.create(attrs);
    else if (type === 'multiBodiedExtension') node = schema.nodes.multiBodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    return node && (0, $8tXCb.normaliseNestedLayout)(state, node);
};
const $783fd49d73f6388e$export$774dc72aee79b8eb = (state, text)=>{
    const macroPluginState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(state);
    const macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) return null;
    const macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) return null;
    // decides which kind of macro to render (inline|bodied|bodyless)
    return $783fd49d73f6388e$export$87074dfcaea41da3(macroAttributes, state);
};
const $783fd49d73f6388e$export$e45aff648def0591 = (provider)=>async (view)=>{
        let resolvedProvider;
        try {
            resolvedProvider = await provider;
            (0, (/*@__PURE__*/$parcel$interopDefault($9Rq82)))(resolvedProvider && resolvedProvider.openMacroBrowser, `MacroProvider promise did not resolve to a valid instance of MacroProvider - ${resolvedProvider}`);
        } catch (err) {
            resolvedProvider = null;
        }
        view.dispatch(view.state.tr.setMeta((0, $61358629666c9a4d$export$18d4026d1ea86bb1), {
            macroProvider: resolvedProvider
        }));
        return true;
    };




const $92573c06ef675309$export$5c24840493a9fa44 = ({ view: view, macroProvider: macroProvider, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return ()=>{
        if (!view) throw new Error(`Missing view. Can't update without EditorView`);
        if (!macroProvider) throw new Error(`Missing macroProvider. Can't use the macro browser for updates`);
        const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
        if (!nodeWithPos) throw new Error(`Missing nodeWithPos. Can't determine position of node`);
        (0, $783fd49d73f6388e$export$4ec44b2939e261e2)(editorAnalyticsAPI)(macroProvider, nodeWithPos.node, true)(view);
    };
};
const $92573c06ef675309$var$extensionAPICallPayload = (functionName)=>({
        action: (0, $krYZG.ACTION).INVOKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_API,
        attributes: {
            functionName: functionName
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
const $92573c06ef675309$export$5c70dcf0377b6800 = (options)=>{
    const { editorView: { state: { schema: schema } }, editorAnalyticsAPI: editorAnalyticsAPI } = options;
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $3ztIq.validator)(nodes, marks, {
        allowPrivateAttributes: true,
        stage0: (0, $iDrrr.fg)('platform_editor_adf_validator_stage0')
    });
    /**
	 * Finds the node and its position by `localId`. Throws if the node could not be found.
	 *
	 * @returns {NodeWithPos}
	 */ const ensureNodePosByLocalId = (localId, { opName: opName })=>{
        // Be extra cautious since 3rd party devs can use regular JS without type safety
        if (typeof localId !== 'string' || localId === '') throw new Error(`${opName}(): Invalid localId '${localId}'.`);
        // Find the node + position matching the given ID
        const { editorView: { state: state } } = options;
        const nodePos = (0, $167f96829d9c9919$export$bb057d1dfc5c8b1b)(state, localId);
        if (!nodePos) throw new Error(`${opName}(): Could not find node with ID '${localId}'.`);
        return nodePos;
    };
    const doc = {
        insertAfter: (localId, adf, opt)=>{
            try {
                validate(adf);
            } catch (e) {
                throw new Error(`insertAfter(): Invalid ADF given.`);
            }
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'insertAfter'
            });
            const { editorView: editorView } = options;
            const { dispatch: dispatch, state: state } = editorView;
            // Validate the given ADF
            const { tr: tr, schema: schema } = state;
            const nodeType = schema.nodes[adf.type];
            if (!nodeType) throw new Error(`insertAfter(): Invalid ADF type '${adf.type}'.`);
            const fragment = (0, $aPdNQ.Fragment).fromJSON(schema, adf.content);
            const marks = (adf.marks || []).map((markEntity)=>(0, $aPdNQ.Mark).fromJSON(schema, markEntity));
            const newNode = nodeType?.createChecked(adf.attrs, fragment, marks);
            if (!newNode) throw new Error('insertAfter(): Could not create a node for given ADFEntity.');
            const insertPosition = nodePos.pos + nodePos.node.nodeSize;
            tr.insert(insertPosition, newNode);
            // Validate if the document is valid at this point
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAfter(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('insertAfter');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            // Analytics - tracking node types added
            const nodesAdded = [
                newNode
            ];
            newNode.descendants((node)=>{
                nodesAdded.push(node);
                return true;
            });
            nodesAdded.forEach((node)=>{
                const { extensionKey: extensionKey, extensionType: extensionType } = node.attrs;
                const dataConsumerMark = (0, $167f96829d9c9919$export$cd9967958db163fc)(node);
                const stringIds = dataConsumerMark?.attrs.sources.map((sourceId)=>sourceId) || [];
                const hasReferentiality = !!dataConsumerMark;
                const nodeTypesReferenced = hasReferentiality ? (0, $167f96829d9c9919$export$1004a88e790d2d21)(stringIds, state) : undefined;
                // fire off analytics for this ADF
                const payload = {
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    attributes: {
                        nodeType: node.type.name,
                        inputMethod: (0, $krYZG.INPUT_METHOD).EXTENSION_API,
                        hasReferentiality: hasReferentiality,
                        nodeTypesReferenced: nodeTypesReferenced,
                        layout: node.attrs.layout,
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            });
            if (opt) {
                if (opt.allowSelectionToNewNode) tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(insertPosition)));
                else if (opt.allowSelectionNearNewNode) tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(insertPosition)));
            }
            dispatch(tr);
        },
        insertAtSelection: (adf)=>{
            if (!(0, $iDrrr.fg)('platform_forge_inline_bodied_macro')) return;
            try {
                validate(adf);
            } catch  {
                throw new Error(`insertAtSelection(): Invalid ADF given.`);
            }
            const { dispatch: dispatch, state: state } = options.editorView;
            const newNode = state.schema.nodeFromJSON(adf);
            const tr = state.tr.replaceSelectionWith(newNode).scrollIntoView();
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAtSelection(): The given ADFEntity cannot replace the current selection.\n${err}`);
            }
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('insertAtSelection');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            dispatch(tr);
        },
        scrollTo: (localId)=>{
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'scrollTo'
            });
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('scrollTo');
            const { editorView: { dispatch: dispatch, state: state } } = options;
            let { tr: tr } = state;
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            tr = (0, $bjg0G.setTextSelection)(nodePos.pos)(tr);
            let useScrollIntoView = true;
            if (nodePos.node.type.name === 'table' && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const tableDOM = options.editorView.nodeDOM(nodePos.pos);
                if (tableDOM instanceof HTMLElement) {
                    tableDOM.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                    useScrollIntoView = false;
                }
            }
            if (useScrollIntoView) tr.scrollIntoView();
            dispatch(tr);
        },
        update: (localId, mutationCallback, opts)=>{
            const { node: node, pos: pos } = ensureNodePosByLocalId(localId, {
                opName: 'update'
            });
            const { editorView: { dispatch: dispatch, state: state } } = options;
            const { tr: tr, schema: schema } = state;
            const changedValues = mutationCallback({
                ...(0, $iDrrr.fg)('platform_forge_inline_bodied_macro') ? {
                    type: node.type.name
                } : {},
                content: (0, $gWBVp.nodeToJSON)(node).content,
                attrs: node.attrs,
                marks: node.marks.map((pmMark)=>({
                        type: pmMark.type.name,
                        attrs: pmMark.attrs
                    }))
            });
            const ensureValidMark = (mark)=>{
                if (typeof mark !== 'object' || Array.isArray(mark)) throw new Error(`update(): Invalid mark given.`);
                const { parent: parent } = state.doc.resolve(pos);
                // Ensure that the given mark is present in the schema
                const markType = schema.marks[mark.type];
                if (!markType) throw new Error(`update(): Invalid ADF mark type '${mark.type}'.`);
                if (!parent.type.allowsMarkType(markType)) throw new Error(`update(): Parent of type '${parent.type.name}' does not allow marks of type '${mark.type}'.`);
                return {
                    mark: markType,
                    attrs: mark.attrs
                };
            };
            const newMarks = changedValues.hasOwnProperty('marks') ? changedValues.marks?.map(ensureValidMark).map(({ mark: mark, attrs: attrs })=>mark.create(attrs)) : node.marks;
            const newContent = changedValues.hasOwnProperty('content') ? (0, $aPdNQ.Fragment).fromJSON(schema, changedValues.content) : node.content;
            let newType = node.type;
            if (changedValues.hasOwnProperty('type') && changedValues.type !== node.type.name && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro')) newType = changedValues.type ? schema.nodes[changedValues.type] : undefined;
            if (!newType) throw new Error(`update(): Invalid ADF node type '${changedValues.type}'.`);
            let newAttrs = changedValues.hasOwnProperty('attrs') ? changedValues.attrs : node.attrs;
            if (node.type.name === 'multiBodiedExtension') newAttrs = {
                ...node.attrs,
                ...changedValues.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    ...changedValues.attrs?.parameters,
                    macroParams: {
                        ...node.attrs.parameters?.macroParams,
                        ...changedValues.attrs?.parameters?.macroParams
                    }
                }
            };
            // Validate if the new attributes, content and marks result in a valid node and adf.
            try {
                const newNode = newType.createChecked(newAttrs, newContent, newMarks);
                const newNodeAdf = new (0, $2lPWP.JSONTransformer)().encodeNode(newNode);
                validate(newNodeAdf);
                if (newType === node.type) tr.replaceWith(pos, pos + node.nodeSize, newNode);
                else {
                    tr.replaceRangeWith(pos, pos + node.nodeSize, newNode);
                    if (node.isBlock && newNode.isInline) (0, $liXVw.autoJoinTr)(tr, [
                        'paragraph'
                    ]);
                    tr.doc.check();
                }
                // Keep selection if content does not change
                if (newType === node.type && newContent === node.content) tr.setSelection((0, $kCECX.Selection).fromJSON(tr.doc, state.selection.toJSON()));
            } catch (err) {
                throw new Error(`update(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('update');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            if (typeof opts?.addToHistory === 'boolean') tr.setMeta('addToHistory', opts.addToHistory);
            if (typeof opts?.scrollIntoView === 'boolean') tr.setMeta('scrollIntoView', opts.scrollIntoView);
            dispatch(tr);
        }
    };
    return {
        editInContextPanel: (transformBefore, transformAfter)=>{
            const { editorView: editorView } = options;
            (0, $3d915853de2ecd5c$export$845f8c516a847983)(transformBefore, transformAfter, options.applyChange)(editorView.state, editorView.dispatch, editorView);
        },
        _editInLegacyMacroBrowser: ()=>{
            const { editorView: editorView } = options;
            let editInLegacy = options.editInLegacyMacroBrowser;
            if (!editInLegacy) {
                const macroState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(editorView.state);
                editInLegacy = $92573c06ef675309$export$5c24840493a9fa44({
                    view: options.editorView,
                    macroProvider: macroState?.macroProvider || undefined,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
            }
            editInLegacy();
        },
        getNodeWithPosByLocalId: (localId)=>{
            return ensureNodePosByLocalId(localId, {
                opName: 'getNodeWithPosByLocalId'
            });
        },
        doc: doc
    };
};




const $5313dd79acf665fc$export$5e06148a47ef53c2 = (type, schema, attrs, content, marks)=>{
    switch(type){
        case 'extension':
            return schema.nodes.extension.createChecked(attrs, content, marks);
        case 'inlineExtension':
            return schema.nodes.inlineExtension.createChecked(attrs, content, marks);
        case 'bodiedExtension':
            return schema.nodes.bodiedExtension.create(attrs, content, marks);
        case 'multiBodiedExtension':
            return schema.nodes.multiBodiedExtension.create(attrs, content, marks);
    }
};
const $5313dd79acf665fc$export$60b0a40d996019c8 = (editorAnalyticsAPI)=>(type, newAttrs, content, marks, shouldScrollIntoView)=>(_state, _dispatch, view)=>{
            if (!view) throw Error('EditorView is required to perform node update!');
            // NOTE: `state` and `dispatch` are stale at this point so we need to grab
            // the latest one from `view` @see HOT-93986
            const { state: state, dispatch: dispatch } = view;
            const newNode = $5313dd79acf665fc$export$5e06148a47ef53c2(type, state.schema, newAttrs, content, marks);
            if (!newNode) return false;
            const { selection: selection, schema: schema } = state;
            const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
            const isBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                bodiedExtension
            ])(selection);
            const isMultiBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                multiBodiedExtension
            ])(selection);
            const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
            const updateSelectionsByNodeType = (nodeType)=>{
                // Bodied/MultiBodied extensions can trigger an update when the cursor is inside which means that there is no node selected.
                // To work around that we replace the parent and create a text selection instead of new node selection
                tr = (0, $bjg0G.replaceParentNodeOfType)(nodeType, newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, state.selection.anchor));
            };
            let targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION;
            let action = (0, $krYZG.ACTION).UPDATED;
            let { tr: tr } = state;
            // When it's a bodiedExtension but not selected
            if (newNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
            else if (newNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
            else if ((0, $bjg0G.findSelectedNodeOfType)([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ])(selection)) {
                tr = (0, $bjg0G.replaceSelectedNode)(newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
            } else if (extensionState.element) {
                const pos = view.posAtDOM(extensionState.element, -1);
                if (pos > -1) {
                    tr = tr.replaceWith(pos, pos + (content.size || 0) + 1, newNode);
                    tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos)));
                    targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).HTML_ELEMENT;
                } else action = (0, $krYZG.ACTION).ERRORED;
            }
            // Only scroll if we have anything to update, best to avoid surprise scroll
            if (dispatch && tr.docChanged) {
                const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = newNode.attrs;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: action,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                    actionSubjectId: newNode.type.name,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                        // This error was introduced after upgrading to TypeScript 5
                        inputMethod: (0, $krYZG.INPUT_METHOD).CONFIG_PANEL,
                        extensionType: extensionType,
                        extensionKey: extensionKey,
                        layout: layout,
                        localId: localId,
                        selection: tr.selection.toJSON(),
                        targetSelectionSource: targetSelectionSource
                    }
                })(tr);
                dispatch(shouldScrollIntoView ? tr.scrollIntoView() : tr);
            }
            return true;
        };
const $5313dd79acf665fc$var$updateExtensionParams = (editorAnalyticsAPI)=>(updateExtension, node, actions)=>async (state, dispatch, view)=>{
            const { attrs: attrs, type: type, content: content, marks: marks } = node.node;
            if (!state.schema.nodes[type.name]) return false;
            const { parameters: parameters } = attrs;
            try {
                const newParameters = await updateExtension(parameters, actions);
                if (newParameters) {
                    const newAttrs = {
                        ...attrs,
                        parameters: {
                            ...parameters,
                            ...newParameters
                        }
                    };
                    if (type.name === 'multiBodiedExtension') newAttrs.parameters.macroParams = {
                        ...parameters.macroParams,
                        ...newParameters?.macroParams
                    };
                    return $5313dd79acf665fc$export$60b0a40d996019c8(editorAnalyticsAPI)(type.name, newAttrs, content, marks, true)(state, dispatch, view);
                }
            } catch  {}
            return true;
        };
const $5313dd79acf665fc$export$f45ebaf24963f4bb = (macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)=>(state, dispatch, view)=>{
        if (!view) return false;
        const { localId: localId } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        const nodeWithPos = (0, $167f96829d9c9919$export$b003700b6d25caa7)(state, localId);
        if (!nodeWithPos) return false;
        const editInLegacyMacroBrowser = (0, $92573c06ef675309$export$5c24840493a9fa44)({
            view: view,
            macroProvider: macroProvider || undefined,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
        if (updateExtension) updateExtension.then((updateMethod)=>{
            if (updateMethod && view) {
                const actions = (0, $92573c06ef675309$export$5c70dcf0377b6800)({
                    editorView: view,
                    editInLegacyMacroBrowser: editInLegacyMacroBrowser,
                    applyChange: applyChangeToContextPanel,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
                $5313dd79acf665fc$var$updateExtensionParams(editorAnalyticsAPI)(updateMethod, nodeWithPos, actions)(state, dispatch, view);
                return;
            }
            if (!updateMethod && macroProvider) {
                editInLegacyMacroBrowser();
                return;
            }
        });
        else {
            if (!macroProvider) return false;
            editInLegacyMacroBrowser();
        }
        return true;
    };
const $5313dd79acf665fc$export$1efb7858e16078f5 = ({ editorViewRef: editorViewRef, editorAnalyticsAPI: editorAnalyticsAPI, applyChangeToContextPanel: applyChangeToContextPanel })=>()=>{
        const { current: view } = editorViewRef;
        if (!view) return false;
        const { updateExtension: updateExtension } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(view.state);
        return $5313dd79acf665fc$export$f45ebaf24963f4bb(null, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(view.state, view.dispatch, view);
    };
const $5313dd79acf665fc$export$f151d046c10e64b5 = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('extension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
const $5313dd79acf665fc$export$8ee156b55126996c = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('bodiedExtension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};





var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");



function $d40259b0c24668cb$export$2e2bcd8739ae039(applyChange) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.escape).common, (state, dispatch)=>{
        const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        if (!extensionState.showContextPanel) return false;
        return (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
    }, list);
    return (0, $44cyU.keymap)(list);
}








const $bf6f7e4036588680$export$ae829ec7b2625219 = (dispatch, providerFactory)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>({
                    macroProvider: null
                }),
            apply (tr, state) {
                const meta = tr.getMeta((0, $61358629666c9a4d$export$18d4026d1ea86bb1));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    dispatch((0, $61358629666c9a4d$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                return state;
            }
        },
        key: (0, $61358629666c9a4d$export$18d4026d1ea86bb1),
        view: (view)=>{
            const handleProvider = (_name, provider)=>provider && (0, $783fd49d73f6388e$export$e45aff648def0591)(provider)(view);
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) providerFactory.subscribe('macroProvider', handleProvider);
            return {
                destroy () {
                    providerFactory.unsubscribe('macroProvider', handleProvider);
                }
            };
        }
    });



var $1sE44 = parcelRequire("1sE44");





var $lp7sw = parcelRequire("lp7sw");

var $4EksL = parcelRequire("4EksL");

var $1tdnq = parcelRequire("1tdnq");

var $iscRo = parcelRequire("iscRo");








var $4o0zT = parcelRequire("4o0zT");


const $17c52fed0a81d13d$export$f01d446fba239e5a = (manifests)=>{
    const transforms = [];
    for (const manifest of manifests){
        for (const nodeModule of Object.values(manifest.modules.nodes ?? {}))if (nodeModule.blockTransform) transforms.push(nodeModule.blockTransform);
    }
    return transforms;
};





var $cd8tA = parcelRequire("cd8tA");



const $e273459f17684478$var$maybeGetExtensionModuleNode = async (view, extensionProvider)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
    if (!nodeWithPos) throw new Error('There is no selection');
    const { extensionType: extensionType, extensionKey: extensionKey } = nodeWithPos.node.attrs;
    const extensionModuleNode = await (0, $cd8tA.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
    const newNodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
    if (newNodeWithPos && newNodeWithPos.node.attrs.extensionType === extensionType && newNodeWithPos.node.attrs.extensionKey === extensionKey && newNodeWithPos.pos === nodeWithPos.pos && extensionModuleNode) return extensionModuleNode;
};
const $e273459f17684478$export$1e25f457f2ade11e = async (view, extensionProvider)=>{
    try {
        const extensionModuleNode = await $e273459f17684478$var$maybeGetExtensionModuleNode(view, extensionProvider);
        const updateMethod = extensionModuleNode?.update;
        (0, $3d915853de2ecd5c$export$4971331372cec95a)({
            showEditButton: !!updateMethod,
            showCopyButton: !extensionModuleNode?.hideCopyButton,
            updateExtension: updateMethod && Promise.resolve(updateMethod) || undefined
        })(view.state, view.dispatch);
        return updateMethod;
    } catch  {
    // this exception is not important for this case, fail silently
    }
};



const $584598053f9859f0$var$shouldShowEditButton = (extensionHandler, extensionProvider)=>{
    const usesLegacyMacroBrowser = !extensionHandler && !extensionProvider || typeof extensionHandler === 'function';
    const usesModernUpdateMethod = typeof extensionHandler === 'object' && typeof extensionHandler.update === 'function';
    if (usesLegacyMacroBrowser || usesModernUpdateMethod) return true;
    return false;
};
const $584598053f9859f0$var$getUpdateExtensionPromise = async (view, extensionHandler, extensionProvider)=>{
    if (extensionHandler && typeof extensionHandler === 'object') // Old API with the `update` function
    return extensionHandler.update;
    else if (extensionProvider) {
        // New API with or without the `update` function, we don't know at this point
        const updateMethod = await (0, $e273459f17684478$export$1e25f457f2ade11e)(view, extensionProvider);
        if (updateMethod) return updateMethod;
    }
    throw new Error('No update method available');
};
const $584598053f9859f0$export$21b8c38408ff6d69 = (view, api)=>async (name, provider)=>{
        if (name === 'extensionProvider' && provider) try {
            const extensionProvider = await provider;
            (0, $3d915853de2ecd5c$export$4971331372cec95a)({
                extensionProvider: extensionProvider
            })(view.state, view.dispatch);
            await (0, $e273459f17684478$export$1e25f457f2ade11e)(view, extensionProvider);
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_menu_transform_extensions')) try {
                const manifests = await extensionProvider.getExtensions();
                api?.blockMenu?.actions.registerBlockMenuTransforms((0, $17c52fed0a81d13d$export$f01d446fba239e5a)(manifests));
            } catch  {
            // Transform registration remains unavailable when manifests cannot be loaded.
            }
        } catch  {
            (0, $3d915853de2ecd5c$export$4971331372cec95a)({
                extensionProvider: undefined
            })(view.state, view.dispatch);
        }
    };
const $584598053f9859f0$export$3c1d0d79a942e731 = ({ view: view, prevState: prevState, domAtPos: domAtPos, extensionHandlers: extensionHandlers, applyChange: applyChange })=>{
    const { state: state, dispatch: dispatch } = view;
    const { element: element, localId: localId, extensionProvider: extensionProvider, showContextPanel: showContextPanel, showEditButton: showEditButton } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
    // This fetches the selected extension node, either by keyboard selection or click for all types of extensions
    const selectedExtension = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    if (!selectedExtension) {
        if (showContextPanel) (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
        return;
    }
    const { node: node } = selectedExtension;
    const newElement = (0, $167f96829d9c9919$export$f1c79f28529bfc9a)(state.schema, domAtPos, selectedExtension);
    // In some cases, showEditButton can be stale and the edit button doesn't show - @see ED-15285
    // To be safe, we update the showEditButton state here
    const shouldUpdateEditButton = !showEditButton && extensionProvider && element === newElement && !(0, $167f96829d9c9919$export$cdb701fa2b3c99df)(prevState, true);
    const isNewNodeSelected = node.attrs.localId ? localId !== node.attrs.localId : // This is the current assumption and it's wrong but we are keeping it
    // as fallback in case we need to turn off `allowLocalIdGeneration`
    element !== newElement;
    if (isNewNodeSelected || shouldUpdateEditButton) {
        if (showContextPanel) {
            (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
            return;
        }
        const { extensionType: extensionType } = node.attrs;
        const extensionHandler = extensionHandlers[extensionType];
        // showEditButton might change async based on results from extension providers
        const showEditButton = $584598053f9859f0$var$shouldShowEditButton(extensionHandler, extensionProvider);
        const updateExtension = $584598053f9859f0$var$getUpdateExtensionPromise(view, extensionHandler, extensionProvider).catch(()=>{
        // do nothing;
        });
        (0, $3d915853de2ecd5c$export$4971331372cec95a)({
            localId: node.attrs.localId,
            showContextPanel: false,
            element: newElement,
            showEditButton: showEditButton,
            // Default to showing synchronously; the manifest-driven value (if any)
            // is resolved asynchronously via updateEditButton for provider-based
            // extensions.
            showCopyButton: true,
            updateExtension: updateExtension
        })(state, dispatch);
    } else if (element !== newElement) (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        element: newElement
    })(state, dispatch);
    return true;
};
const $584598053f9859f0$export$ae829ec7b2625219 = (dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, pluginInjectionApi, useLongPressSelection = false, options = {}, featureFlags, __rendererExtensionOptions, intl)=>{
    const state = (0, $7d5ef977555345d3$export$656c7661095efe2e)(dispatch, {
        showEditButton: false,
        showCopyButton: true,
        showContextPanel: false
    });
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight,
        allowAIGeneratedContentMotion: options.allowAIGeneratedContentMotion
    };
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: featureFlags?.macroInteractionUpdates ?? false
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    return new (0, $kpCD8.SafePlugin)({
        state: state,
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const extensionProviderHandler = $584598053f9859f0$export$21b8c38408ff6d69(editorView, pluginInjectionApi);
            providerFactory.subscribe('extensionProvider', extensionProviderHandler);
            return {
                update: (view, prevState)=>{
                    $584598053f9859f0$export$3c1d0d79a942e731({
                        view: view,
                        prevState: prevState,
                        domAtPos: domAtPos,
                        extensionHandlers: extensionHandlers,
                        applyChange: pluginInjectionApi?.contextPanel?.actions.applyChange
                    });
                },
                destroy: ()=>{
                    providerFactory.unsubscribe('extensionProvider', extensionProviderHandler);
                }
            };
        },
        key: (0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1),
        props: {
            handleDOMEvents: {
                /**
         * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty.
         * This code is to handle the case where the selection starts inside or on the node and the user is trying to shift + arrow.
         * For other part of the solution see code in: packages/editor/editor-core/src/plugins/selection/pm-plugins/events/keydown.ts
         */ keydown: (view, event)=>{
                    if (event instanceof KeyboardEvent && event.shiftKey && [
                        'ArrowUp',
                        'ArrowDown',
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { bodiedExtension: bodiedExtension } = schema.nodes;
                        if (selection instanceof (0, $kCECX.TextSelection) || selection instanceof (0, $kCECX.NodeSelection)) {
                            const maybeBodiedExtension = selection instanceof (0, $kCECX.TextSelection) ? (0, $bjg0G.findParentNodeOfTypeClosestToPos)($head, bodiedExtension) : (0, $bjg0G.findSelectedNodeOfType)(bodiedExtension)(selection);
                            if (maybeBodiedExtension) {
                                const end = maybeBodiedExtension.pos + maybeBodiedExtension.node.nodeSize;
                                if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' && (0, $iscRo.isSelectionAtStartOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = end + 1;
                                    // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
                                    const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                                    const head = maybeBodiedExtension.pos + headOffset;
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, Math.max(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                                if (event.key === 'ArrowDown' || event.key === 'ArrowRight' && (0, $1tdnq.isSelectionAtEndOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = maybeBodiedExtension.pos - 1;
                                    const head = end + 1;
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, Math.min(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                            }
                        }
                    }
                    // Handle non shift key case for MBE
                    if (event instanceof KeyboardEvent && !event.shiftKey && event.key === 'ArrowLeft') {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame, paragraph: paragraph } = schema.nodes;
                        if (selection instanceof (0, $4EksL.GapCursorSelection) || selection instanceof (0, $kCECX.TextSelection) && $head.parent.type === paragraph) {
                            const maybeMultiBodiedExtension = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($head, multiBodiedExtension);
                            if (maybeMultiBodiedExtension) {
                                /* In case of gap cursor, we need to decrement the position by 1 as we need to check the node at previous position
                 * In case of text selection, we need to decrement the position by 2 as we need to jump back twice, once from text node and then its parent paragraph node
                 */ const previousPositionDecrement = selection instanceof (0, $4EksL.GapCursorSelection) ? 1 : 2;
                                if (tr.doc.nodeAt($head.pos - previousPositionDecrement)?.type === extensionFrame) {
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, tr.doc.resolve($head.pos - previousPositionDecrement).start($head.depth - previousPositionDecrement));
                                    view.dispatch(tr.setSelection(newSelection));
                                }
                            }
                        }
                    }
                    return false;
                }
            },
            nodeViews: {
                // WARNING: referentiality-plugin also creates these nodeviews
                extension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl),
                // WARNING: referentiality-plugin also creates these nodeviews
                bodiedExtension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers, intl),
                // WARNING: referentiality-plugin also creates these nodeviews
                inlineExtension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl),
                multiBodiedExtension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl)
            },
            createSelectionBetween: function(view, anchor, head) {
                const { schema: schema, doc: doc } = view.state;
                const { multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const isAnchorInMBE = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(anchor, multiBodiedExtension);
                const isHeadInMBE = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(head, multiBodiedExtension);
                if (isAnchorInMBE !== undefined && isHeadInMBE === undefined) {
                    // Anchor is in MBE, where user started selecting within MBE and then moved outside
                    const newSelection = (0, $kCECX.TextSelection).create(doc, isAnchorInMBE.pos < head.pos ? isAnchorInMBE.pos : isAnchorInMBE.pos + isAnchorInMBE.node.nodeSize, // isAnchorInMBE.pos < head.pos represents downwards selection
                    head.pos);
                    return newSelection;
                }
                if (isAnchorInMBE === undefined && isHeadInMBE !== undefined) {
                    // Head is in MBE, where user started selecting outside MBE and then moved inside
                    const newSelection = (0, $kCECX.TextSelection).create(doc, anchor.pos, isHeadInMBE.pos < anchor.pos ? isHeadInMBE.pos : isHeadInMBE.pos + isHeadInMBE.node.nodeSize // isHeadInMBE.pos < anchor.pos represents upwards selection
                    );
                    return newSelection;
                }
                return null;
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ], (target)=>!target.closest('.extension-non-editable-area') && (!target.closest('.extension-content') || !!target.closest('.extension-container')), // It's to enable nested extensions selection
            {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};




var $04Oo7 = parcelRequire("04Oo7");


var $8Dx7s = parcelRequire("8Dx7s");

const $b098027f4699dcb1$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $b098027f4699dcb1$export$1a85854d3d541a64 = ()=>{
    return {
        ...(0, $04Oo7.bodiedExtension),
        toDOM: (node)=>{
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId,
                style: (0, $8Dx7s.convertToInlineCss)({
                    position: 'relative',
                    marginTop: "var(--ds-space-300, 24px)"
                })
            };
            const title = node.attrs && node.attrs.extensionTitle || node.attrs && node.attrs.macroMetadata && node.attrs.macroMetadata.title || node.attrs.extensionKey;
            return [
                'div',
                attrs,
                [
                    'span',
                    {
                        // Styles based on `packages/editor/editor-common/src/extensibility/Extension/Lozenge/ExtensionLabel.tsx`
                        style: (0, $8Dx7s.convertToInlineCss)({
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            fontSize: '14px',
                            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                            color: "var(--ds-text-subtle, #505258)",
                            borderTopLeftRadius: "var(--ds-radius-small, 4px)",
                            borderTopRightRadius: "var(--ds-radius-small, 4px)",
                            lineHeight: 1,
                            position: 'absolute',
                            top: '-19px'
                        }),
                        // If we put this below inside the span then we serialise the label (which causes the label to be
                        // be copied to the clipboard causing copy-paste issues).
                        // So instead we use a pseudo-element to add the title to this class
                        'data-bodied-extension-label': $b098027f4699dcb1$var$capitalizeFirstLetter(title),
                        class: 'bodied-extension-to-dom-label'
                    }
                ],
                [
                    'div',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: "var(--ds-space-200, 16px)",
                            marginLeft: "var(--ds-space-negative-150, -12px)",
                            marginRight: "var(--ds-space-negative-150, -12px)",
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            borderRadius: "var(--ds-radius-small, 4px)"
                        })
                    },
                    0
                ]
            ];
        }
    };
};



var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");





var $2sp5n = parcelRequire("2sp5n");

var $3nm9z = parcelRequire("3nm9z");


var $2xhuI = parcelRequire("2xhuI");


var $2aFJ8 = parcelRequire("2aFJ8");


var $g6uqx = parcelRequire("g6uqx");




var $eQeCt = parcelRequire("eQeCt");


var $jaFVy = parcelRequire("jaFVy");





var $6RqDx = parcelRequire("6RqDx");


var $4mxZP = parcelRequire("4mxZP");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $9V98o = parcelRequire("9V98o");












// non-bodied extensions nested inside panels, blockquotes and lists do not support layouts
const $7d58a2ee0cc4b964$var$isNestedNBM = (state, selectedExtNode)=>{
    const { schema: { nodes: nodes }, selection: selection } = state;
    const { extension: extension, panel: panel, blockquote: blockquote, listItem: listItem, panel_c1: panel_c1 } = nodes;
    if (!selectedExtNode) return false;
    const parentNodeTypes = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1,
        blockquote,
        listItem
    ] : [
        panel,
        blockquote,
        listItem
    ];
    return selectedExtNode.node.type === extension && (0, $bjg0G.hasParentNodeOfType)(parentNodeTypes.filter(Boolean))(selection);
};
const $7d58a2ee0cc4b964$var$isLayoutSupported = (state, selectedExtNode)=>{
    const { schema: { nodes: { bodiedExtension: bodiedExtension, extension: extension, layoutSection: layoutSection, table: table, expand: expand, multiBodiedExtension: multiBodiedExtension } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    // Skip agent-managed-block extension until it supports the layout controls in its custom node
    const extensionKey = selectedExtNode.node.attrs.extensionKey;
    if ((0, $2sp5n.AGENT_MANAGED_EXTENSION_KEY) === extensionKey) return false;
    const isMultiBodiedExtension = selectedExtNode.node.type === multiBodiedExtension;
    const isNonEmbeddedBodiedExtension = selectedExtNode.node.type === bodiedExtension && !(0, $bjg0G.hasParentNodeOfType)([
        multiBodiedExtension
    ].filter(Boolean))(selection);
    const isNonEmbeddedExtension = selectedExtNode.node.type === extension && !(0, $bjg0G.hasParentNodeOfType)([
        bodiedExtension,
        table,
        expand,
        multiBodiedExtension
    ].filter(Boolean))(selection);
    // if selection belongs to layout supported extension category
    // and not inside a layoutSection
    return !!((isMultiBodiedExtension || isNonEmbeddedBodiedExtension || isNonEmbeddedExtension) && !(0, $bjg0G.hasParentNodeOfType)([
        layoutSection
    ])(selection));
};
const $7d58a2ee0cc4b964$var$breakoutButtonListOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (nodeWithPos && breakoutEnabled && $7d58a2ee0cc4b964$var$isLayoutSupported(state, nodeWithPos) && !$7d58a2ee0cc4b964$var$isNestedNBM(state, nodeWithPos)) {
        const { layout: layout } = nodeWithPos.node.attrs;
        return [
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))), {
                        label: formatMessage((0, $2xhuI.default).layoutFixedWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
                selected: layout === 'default',
                title: formatMessage((0, $2xhuI.default).layoutFixedWidth),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))), {
                        label: formatMessage((0, $2xhuI.default).layoutWide),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
                selected: layout === 'wide',
                title: formatMessage((0, $2xhuI.default).layoutWide),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9V98o))), {
                        label: formatMessage((0, $2xhuI.default).layoutFullWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($9V98o))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
                selected: layout === 'full-width',
                title: formatMessage((0, $2xhuI.default).layoutFullWidth),
                tabIndex: null
            }
        ];
    }
    return [];
};
const $7d58a2ee0cc4b964$var$breakoutDropdownOptions = (state, formatMessage, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (!nodeWithPos || !breakoutEnabled || !$7d58a2ee0cc4b964$var$isLayoutSupported(state, nodeWithPos) || $7d58a2ee0cc4b964$var$isNestedNBM(state, nodeWithPos)) return [];
    const { layout: layout } = nodeWithPos.node.attrs;
    let title = '';
    let IconComponent;
    switch(layout){
        case 'wide':
            title = formatMessage((0, $2xhuI.default).layoutStateWide);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP)));
            break;
        case 'full-width':
            title = formatMessage((0, $2xhuI.default).layoutStateFullWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($9V98o)));
            break;
        case 'default':
        default:
            title = formatMessage((0, $2xhuI.default).layoutStateFixedWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6RqDx)));
            break;
    }
    const options = [
        {
            id: 'editor.extensions.width.default',
            title: formatMessage((0, $2xhuI.default).layoutFixedWidth),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
            selected: layout === 'default',
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutFixedWidth)
            })
        },
        {
            id: 'editor.extensions.width.wide',
            title: formatMessage((0, $2xhuI.default).layoutWide),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
            selected: layout === 'wide',
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutWide)
            })
        },
        {
            id: 'editor.extensions.width.full-width',
            title: formatMessage((0, $2xhuI.default).layoutFullWidth),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
            selected: layout === 'full-width',
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9V98o))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutFullWidth)
            })
        }
    ];
    return [
        {
            id: 'extensions-width-options-toolbar-item',
            testId: 'extensions-width-options-toolbar-dropdown',
            type: 'dropdown',
            options: options,
            title: title,
            iconBefore: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)(IconComponent, {
                    color: "currentColor",
                    spacing: "spacious",
                    label: title
                })
        }
    ];
};
const $7d58a2ee0cc4b964$var$breakoutOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, api)=>{
    return (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? $7d58a2ee0cc4b964$var$breakoutDropdownOptions(state, formatMessage, breakoutEnabled, editorAnalyticsAPI) : $7d58a2ee0cc4b964$var$breakoutButtonListOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI);
};
const $7d58a2ee0cc4b964$var$editButton = (formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, isDisabled = false, api)=>{
    if (!extensionState.showEditButton) return [];
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const editButtonItems = [
        {
            id: 'editor.extension.edit',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            testId: 'extension-toolbar-edit-button',
            // Taking the latest `updateExtension` from plugin state to avoid race condition @see ED-8501
            onClick: (state, dispatch, view)=>{
                const macroState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(state);
                const { updateExtension: updateExtension } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
                (0, $5313dd79acf665fc$export$f45ebaf24963f4bb)(macroState && macroState.macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(state, dispatch, view);
                return true;
            },
            title: formatMessage((0, $3nm9z.messages).edit),
            tabIndex: null,
            focusEditoronEnter: true,
            disabled: isDisabled,
            isRadioButton: (0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? false : undefined
        }
    ];
    if (toolbarFlagsEnabled) editButtonItems.push({
        type: 'separator',
        fullHeight: true
    });
    return editButtonItems;
};
/**
 * Calculates the position for the toolbar when dealing with nested extensions
 * @param editorView
 * @param nextPos
 * @param state
 * @param extensionNode
 * @example
 */ const $7d58a2ee0cc4b964$var$calculateToolbarPosition = (editorView, nextPos, state, extensionNode)=>{
    const { state: { schema: schema, selection: selection } } = editorView;
    const possibleMbeParent = (0, $bjg0G.findParentNodeOfType)(schema.nodes.extensionFrame)(selection);
    // We only want to use calculated position in case of a bodiedExtension present inside an MBE node
    const isBodiedExtensionInsideMBE = possibleMbeParent && extensionNode?.node.type.name === 'bodiedExtension';
    let scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
    if (!extensionNode) return nextPos;
    const isInsideEditableExtensionArea = !!editorView.dom.closest('.extension-editable-area');
    if (!isBodiedExtensionInsideMBE && !isInsideEditableExtensionArea) return nextPos;
    if (isInsideEditableExtensionArea && scrollWrapper.parentElement) // The editable extension area may have its own scroll wrapper, so we want to keep searching up the tree for the page level scroll wrapper.
    scrollWrapper = scrollWrapper.parentElement.closest('.fabric-editor-popup-scroll-parent') || scrollWrapper;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const nestedBodiedExtensionDomElement = editorView.nodeDOM(extensionNode.pos);
    const nestedBodiedExtensionRect = nestedBodiedExtensionDomElement?.getBoundingClientRect();
    const wrapperBounds = scrollWrapper.getBoundingClientRect();
    const toolbarTopPos = nestedBodiedExtensionRect.bottom - wrapperBounds.top + scrollWrapper.scrollTop + (0, $2aFJ8.BODIED_EXT_MBE_MARGIN_TOP);
    return {
        top: toolbarTopPos,
        left: nextPos.left
    };
};
const $7d58a2ee0cc4b964$export$7652656d91146fb9 = ({ formatMessage: formatMessage, extensionApi: extensionApi, extensionProvider: extensionProvider, getUnsupportedContent: getUnsupportedContent, state: state, locale: locale })=>{
    if (!extensionProvider) return;
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    const extensionParams = {
        type: node.type.name,
        extensionKey: extensionKey,
        extensionType: extensionType,
        parameters: node.attrs.parameters,
        content: node.content,
        localId: node.attrs.localId
    };
    const adf = getUnsupportedContent?.(extensionParams);
    if (!adf) return;
    // this command copies the text content of the unsupported content extension to the clipboard
    return (editorState)=>{
        extensionApi?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).COPY_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
            attributes: {
                extensionDynamicType: node.type.name,
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey
            }
        });
        (0, $167f96829d9c9919$export$9defe25170de6263)({
            locale: locale,
            unsupportedContent: adf,
            schema: state.schema,
            api: extensionApi
        }).then(()=>{
            extensionApi?.copyButton?.actions.afterCopy(formatMessage((0, $2xhuI.default).copiedToClipboard));
        }).catch((error)=>{
            (0, $167f96829d9c9919$export$67e8f2a5d4f25de0)({
                error: error,
                extensionApi: extensionApi,
                state: editorState
            });
        });
        return true;
    };
};
const $7d58a2ee0cc4b964$export$86ce8f8241c20a3 = ({ breakoutEnabled: breakoutEnabled = true, copyEnabled: copyEnabled = true, deleteEnabled: deleteEnabled = true, extensionApi: extensionApi, getUnsupportedContent: getUnsupportedContent })=>(state, intl)=>{
        const { formatMessage: formatMessage, locale: locale } = intl;
        const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        if (!extensionState || extensionState.showContextPanel || !extensionState.element) return;
        const { extensionProvider: extensionProvider } = extensionState;
        const hoverDecoration = extensionApi?.decorations?.actions.hoverDecoration;
        const applyChangeToContextPanel = extensionApi?.contextPanel?.actions.applyChange;
        const editorAnalyticsAPI = extensionApi?.analytics?.actions;
        const nodeType = [
            state.schema.nodes.extension,
            state.schema.nodes.inlineExtension,
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.multiBodiedExtension
        ];
        const editButtonItems = $7d58a2ee0cc4b964$var$editButton(formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, (0, $jaFVy.isOfflineMode)(extensionApi?.connectivity?.sharedState?.currentState()?.mode), extensionApi);
        const breakoutItems = $7d58a2ee0cc4b964$var$breakoutOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, extensionApi);
        const extensionObj = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
        // If this is a native-embed extension, skip providing a toolbar config to allow
        // the native-embed plugin to provide a custom toolbar config.
        if (extensionObj?.node.attrs.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && extensionObj?.node.attrs.extensionKey.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) return;
        // Check if we need to show confirm dialog for delete button
        let confirmDialog;
        if ((0, $dpfrn.isReferencedSource)(state, extensionObj?.node)) confirmDialog = ()=>{
            const localSourceName = formatMessage((0, $3nm9z.messages).unnamedSource);
            return {
                title: formatMessage((0, $3nm9z.messages).deleteElementTitle),
                okButtonLabel: formatMessage((0, $3nm9z.messages).confirmDeleteLinkedModalOKButton),
                message: formatMessage((0, $3nm9z.messages).confirmDeleteLinkedModalMessage, {
                    nodeName: (0, $eQeCt.getNodeName)(state, extensionObj?.node) || localSourceName
                }),
                isReferentialityDialog: true,
                getChildrenInfo: ()=>(0, $dpfrn.getChildrenInfo)(state, extensionObj?.node),
                checkboxLabel: formatMessage((0, $3nm9z.messages).confirmModalCheckboxLabel),
                onConfirm: (isChecked = false)=>$7d58a2ee0cc4b964$var$clickWithCheckboxHandler(isChecked, extensionObj?.node)
            };
        };
        // Hide the copy button when the host disables it for every extension
        // (`copyEnabled`), when the extension's manifest node opts out via
        // `hideCopyButton` (e.g. redactions), or for the legacy content macro.
        //
        // The host check is deliberately evaluated before the gate, so the gate is
        // only read — and so only exposed — for hosts that opted in. Reading it
        // unconditionally would report an exposure on every extension toolbar in
        // every product, drowning the rollout metric in traffic it cannot affect.
        const shouldHideCopyButton = !copyEnabled && (0, $iDrrr.fg)('platform_editor_extension_hide_toolbar_actions') || !extensionState.showCopyButton && (0, $iDrrr.fg)('platform_editor_extension_hide_copy_button') || extensionObj?.node.attrs.extensionType === 'com.atlassian.confluence.migration' && extensionObj?.node.attrs.extensionKey === 'legacy-content';
        const shouldHideDeleteButton = !deleteEnabled && (0, $iDrrr.fg)('platform_editor_extension_hide_toolbar_actions');
        // With both trailing actions gone the toolbar ends after the breakout
        // options, so the divider that used to introduce them would be an orphan.
        const hasTrailingActions = !shouldHideCopyButton || !shouldHideDeleteButton;
        return {
            title: 'Extension floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getDomRef: ()=>extensionState.element.parentElement || undefined,
            nodeType: nodeType,
            onPositionCalculated: (editorView, nextPos)=>$7d58a2ee0cc4b964$var$calculateToolbarPosition(editorView, nextPos, state, extensionObj),
            items: [
                ...editButtonItems,
                ...breakoutItems,
                {
                    type: 'separator',
                    hidden: editButtonItems.length === 0 && breakoutItems.length === 0 || !hasTrailingActions
                },
                {
                    type: 'extensions-placeholder',
                    separator: 'end'
                },
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onClick: $7d58a2ee0cc4b964$export$7652656d91146fb9({
                                formatMessage: formatMessage,
                                extensionApi: extensionApi,
                                extensionProvider: extensionProvider,
                                getUnsupportedContent: getUnsupportedContent,
                                state: state,
                                locale: locale
                            })
                        }
                    ],
                    ...shouldHideCopyButton && {
                        hidden: shouldHideCopyButton
                    }
                },
                // Hide this separator when either neighbour is hidden, otherwise it
                // renders as an orphaned divider before or after the delete button.
                {
                    type: 'separator',
                    hidden: shouldHideCopyButton || shouldHideDeleteButton
                },
                {
                    ...shouldHideDeleteButton && {
                        hidden: true
                    },
                    id: 'editor.extension.delete',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    appearance: 'danger',
                    onClick: (0, $3d915853de2ecd5c$export$366c74c25333cf63)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    focusEditoronEnter: true,
                    title: formatMessage((0, $2xhuI.default).remove),
                    tabIndex: null,
                    confirmDialog: confirmDialog
                }
            ],
            scrollable: true
        };
    };
const $7d58a2ee0cc4b964$var$clickWithCheckboxHandler = (isChecked, node)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) (0, $3d915853de2ecd5c$export$366c74c25333cf63)()(state, dispatch);
        else (0, $3d915853de2ecd5c$export$fa79c3ccfdddfece)(node)(state, dispatch);
        return true;
    };



var $2nOF5 = parcelRequire("2nOF5");


var $1A89X = parcelRequire("1A89X");





var $6MtNT = parcelRequire("6MtNT");




const $f28c64404a6658d7$var$pluginKey = new (0, $kCECX.PluginKey)('extensionUniqueIdPlugin');
const $f28c64404a6658d7$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            const selectionBookmark = tr.selection.getBookmark();
            let modified = false;
            const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = newState.schema.nodes;
            const extensionTypes = new Set([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ]);
            const idsObserved = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                const isAddingExtension = transaction.steps.some((step)=>(0, $6MtNT.stepAddsOneOf)(step, extensionTypes) || // There are instances where the localId will be reset to null on publish due to extension
                    // not existing in the Storage format (eg. Legacy Content Extensions) or not having a localId
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    step instanceof (0, $1A89X.SetAttrsStep) && // @ts-expect-error Bad ProseMirror step types
                    step.attrs?.localId === null);
                if (isAddingExtension) // Can't simply look at changed nodes, as we could be adding an extension
                newState.doc.descendants((node, pos)=>{
                    const localId = node.attrs.localId;
                    // Dealing with an extension - make sure it's a unique ID
                    if (!!node.type && extensionTypes.has(node.type)) {
                        if (localId && !idsObserved.has(localId)) idsObserved.add(localId);
                        else if (!localId || idsObserved.has(localId)) {
                            modified = true;
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                localId: (0, $2nOF5.uuid).generate()
                            });
                        }
                        /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ if ([
                            multiBodiedExtension,
                            bodiedExtension
                        ].includes(node.type)) return true;
                        return false;
                    }
                    /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                });
            });
            if (modified) // We want to restore to the original selection but w/o applying the mapping
            // @see https://github.com/ProseMirror/prosemirror/issues/645
            return tr.setSelection(selectionBookmark.resolve(tr.doc));
            return;
        },
        key: $f28c64404a6658d7$var$pluginKey
    });



var $fJUEv = parcelRequire("fJUEv");




parcelRequire("cozmU");











var $8HW7o = parcelRequire("8HW7o");








parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");





var $eRn3r = parcelRequire("eRn3r");


var $fjZlw = parcelRequire("fjZlw");


const $6a7a68fea06620b8$var$loadConfigPanel = ()=>(parcelRequire("4odIu")).then((module)=>module.default);

const $6a7a68fea06620b8$var$ConfigPanelLazy = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("4odIu")).then((module)=>module.default));
const $6a7a68fea06620b8$var$ConfigPanelLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "KzLW6",
    name: "ConfigPanelLoadable",
    loader: $6a7a68fea06620b8$var$loadConfigPanel,
    loading: (0, $fjZlw.default)
});
const $6a7a68fea06620b8$var$_default_1 = (props)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fjZlw.default), {}),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($6a7a68fea06620b8$var$ConfigPanelLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $8aG6j.jsx)($6a7a68fea06620b8$var$ConfigPanelLoadable, {
        ...props
    });
$6a7a68fea06620b8$var$_default_1.preload = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $6a7a68fea06620b8$var$ConfigPanelLazy.preload() : $6a7a68fea06620b8$var$ConfigPanelLoadable.preload();
var $6a7a68fea06620b8$export$2e2bcd8739ae039 = $6a7a68fea06620b8$var$_default_1;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");





var $chu6R = parcelRequire("chu6R");


var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");

function $4d99bbf49073cd12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4d99bbf49073cd12$var$noop = ()=>{};
const $4d99bbf49073cd12$var$saveIndicatorWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $4d99bbf49073cd12$var$saveIndicatorContentStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'fixed',
    width: '256px',
    bottom: "var(--ds-space-250, 20px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    /* E300 */ boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    borderRadius: "var(--ds-radius-xxlarge, 16px)"
});
const $4d99bbf49073cd12$var$saveIndicatorTextStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.075'
});
const $4d99bbf49073cd12$export$7ceebdb305e167df = ({ children: children, duration: duration, visible: visible = true })=>{
    const [saving, setSaving] = (0, $cozmU.useState)(false);
    const shown = (0, $cozmU.useRef)(false);
    const onSaveStarted = (0, $cozmU.useCallback)(()=>{
        if (!shown.current) {
            setSaving(true);
            shown.current = true;
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (saving) {
            const handleId = setTimeout(()=>{
                setSaving(false);
            }, duration);
            return ()=>clearTimeout(handleId);
        }
    }, [
        saving,
        duration
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, children({
        onSaveStarted: onSaveStarted,
        onSaveEnded: $4d99bbf49073cd12$var$noop
    })), visible && saving && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $4d99bbf49073cd12$var$saveIndicatorWrapperStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $4d99bbf49073cd12$var$saveIndicatorContentStyles,
        "data-testid": "save-indicator-content"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: "Saving",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $4d99bbf49073cd12$var$saveIndicatorTextStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $3nm9z.messages).saveIndicator))))));
};


const $fc213d5917462889$var$areParametersEqual = (firstParameters, secondParameters)=>{
    if (typeof firstParameters === 'object' && typeof secondParameters === 'object' && firstParameters !== null && secondParameters !== null) {
        const firstKeys = Object.keys(firstParameters);
        const secondKeys = Object.keys(secondParameters);
        return firstKeys.length === secondKeys.length && firstKeys.every((key)=>firstParameters[key] === secondParameters[key]);
    }
    return firstParameters === secondParameters;
};
const $fc213d5917462889$export$3c0bb68e76442a1e = (selectionToDuplicate, doc)=>{
    if (selectionToDuplicate instanceof (0, $kCECX.NodeSelection)) return (0, $kCECX.NodeSelection).create(doc, selectionToDuplicate.from);
    else if (selectionToDuplicate instanceof (0, $kCECX.TextSelection)) return (0, $kCECX.TextSelection).create(doc, selectionToDuplicate.from, selectionToDuplicate.to);
    else if (selectionToDuplicate instanceof (0, $4EksL.GapCursorSelection)) return new (0, $4EksL.GapCursorSelection)(doc.resolve(selectionToDuplicate.from), selectionToDuplicate.side);
    else if (selectionToDuplicate instanceof (0, $8HW7o.CellSelection)) return new (0, $8HW7o.CellSelection)(doc.resolve(selectionToDuplicate.$anchorCell.pos), doc.resolve(selectionToDuplicate.$headCell.pos));
};
const $fc213d5917462889$export$7c8c60c0acb92731 = (getEditorView)=>(api, featureFlags)=>(state)=>{
            const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
            const applyChange = api?.contextPanel?.actions.applyChange;
            // Adding checks to bail out early
            if (!nodeWithPos) return;
            const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
            const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersBefore: processParametersBefore, processParametersAfter: processParametersAfter } = extensionState;
            if (extensionState && showContextPanel && extensionProvider && processParametersAfter) {
                const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
                const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
                const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4d99bbf49073cd12$export$7ceebdb305e167df), {
                    duration: 5000,
                    visible: true,
                    children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                        const editorView = getEditorView?.();
                        if (!editorView) return null;
                        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a7a68fea06620b8$export$2e2bcd8739ae039), {
                            api: api,
                            showHeader: true,
                            closeOnEsc: true,
                            extensionType: extensionType,
                            extensionKey: extKey,
                            nodeKey: nodeKey,
                            extensionParameters: parameters,
                            parameters: configParams,
                            extensionProvider: extensionProvider,
                            autoSaveTrigger: autoSaveResolve,
                            autoSaveReject: autoSaveReject,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onChange: async (updatedParameters)=>{
                                await $fc213d5917462889$export$2f221d4ebb46923c(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                                onSaveEnded();
                                if (autoSaveResolve) autoSaveResolve();
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onCancel: async ()=>{
                                try {
                                    await new Promise((resolve, reject)=>{
                                        (0, $3d915853de2ecd5c$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
                                    });
                                } catch (e) {
                                    // Even if the save failed, we should proceed with closing the panel
                                    // eslint-disable-next-line no-console
                                    console.error(`Autosave failed with error`, e);
                                }
                                (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
                            },
                            featureFlags: featureFlags
                        });
                    }
                });
            }
        };
async function $fc213d5917462889$export$2f221d4ebb46923c(editorView, updatedParameters = {}, oldParameters = {}, nodeWithPos, onSaving) {
    // WARNING: editorView.state stales quickly, do not unpack
    const { processParametersAfter: processParametersAfter, processParametersBefore: processParametersBefore } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    if (!processParametersAfter) return;
    const unwrappedOldParameters = processParametersBefore ? processParametersBefore(oldParameters) : oldParameters;
    if ($fc213d5917462889$var$areParametersEqual(unwrappedOldParameters, updatedParameters)) return;
    if (onSaving) onSaving();
    const key = Date.now();
    const { positions: previousPositions } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    await (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        positions: {
            ...previousPositions,
            [key]: nodeWithPos.pos
        }
    })(editorView.state, editorView.dispatch);
    // WARNING: after this, editorView.state may have changed
    const newParameters = await processParametersAfter(updatedParameters);
    const { positions: positions } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    if (!positions) return;
    if (!(key in positions)) return;
    const { node: node } = nodeWithPos;
    const newNode = (0, $5313dd79acf665fc$export$5e06148a47ef53c2)(nodeWithPos.node.toJSON().type, editorView.state.schema, {
        ...node.attrs,
        parameters: {
            ...oldParameters,
            ...newParameters
        }
    }, node.content, node.marks);
    if (!newNode) return;
    const positionUpdated = positions[key];
    const transaction = editorView.state.tr.replaceWith(positionUpdated, positionUpdated + newNode.nodeSize, newNode);
    // Ensure we preserve the selection, tr.replaceWith causes it to be lost in some cases
    // when replacing the node
    const { selection: prevSelection } = editorView.state;
    if (!prevSelection.eq(transaction.selection)) {
        const selection = $fc213d5917462889$export$3c0bb68e76442a1e(prevSelection, transaction.doc);
        if (selection) transaction.setSelection(selection);
    }
    const positionsLess = {
        ...(0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state).positions
    };
    delete positionsLess[key];
    await (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        positions: positionsLess
    })(editorView.state, editorView.dispatch);
    editorView.dispatch(transaction);
}












var $3k5Tv = parcelRequire("3k5Tv");


var $iMnC5 = parcelRequire("iMnC5");











parcelRequire("cozmU");




var $kA6Zo = parcelRequire("kA6Zo");






parcelRequire("cozmU");


var $jND0n = parcelRequire("jND0n");

function $76989ca55049fc51$export$7dd73e517d9d8a3(WrappedComponent) {
    return function WithExtensionManifest(props) {
        const { extensionKey: extensionKey, extensionProvider: extensionProvider, extensionType: extensionType, ...restProps } = props;
        const [extensionManifest] = (0, $jND0n.useStateFromPromise)(()=>extensionProvider.getExtension(extensionType, extensionKey), [
            extensionProvider,
            extensionType,
            extensionKey
        ]);
        return extensionManifest ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
            extensionManifest: extensionManifest,
            ...restProps
        }) : null;
    };
}


const $923147737bfc3fc6$var$itemBodyStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    margin: 'space.200',
    flexGrow: 3
});
const $923147737bfc3fc6$var$itemTextStyles = (0, $buxP3.xcss)({
    maxWidth: '100%',
    whiteSpace: 'initial'
});
const $923147737bfc3fc6$var$summaryStyles = (0, $buxP3.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
function $923147737bfc3fc6$var$HeaderAfterIconElement({ extensionManifest: extensionManifest }) {
    const title = extensionManifest.title;
    const summary = extensionManifest.summary;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        xcss: $923147737bfc3fc6$var$itemBodyStyles,
        children: summary ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
            xcss: $923147737bfc3fc6$var$itemTextStyles,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    id: "context-panel-title",
                    "data-testid": "context-panel-title",
                    children: title
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
                    xcss: $923147737bfc3fc6$var$summaryStyles,
                    children: summary
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kA6Zo.Flex), {
            direction: "column",
            alignItems: "center",
            testId: "context-panel-title",
            children: title
        })
    });
}
const $923147737bfc3fc6$var$_default_1 = (0, $76989ca55049fc51$export$7dd73e517d9d8a3)($923147737bfc3fc6$var$HeaderAfterIconElement);
var $923147737bfc3fc6$export$2e2bcd8739ae039 = $923147737bfc3fc6$var$_default_1;














const $1ae0de3813cee7fd$var$iconWidth = '40px';
const $1ae0de3813cee7fd$var$itemIconStyles = (0, $buxP3.xcss)({
    width: $1ae0de3813cee7fd$var$iconWidth,
    height: $1ae0de3813cee7fd$var$iconWidth,
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
function $1ae0de3813cee7fd$var$HeaderIcon({ extensionManifest: extensionManifest }) {
    const icon = extensionManifest.icons['48'];
    const title = extensionManifest.title;
    const ResolvedIcon = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, $cozmU.lazy)(()=>icon().then((Cmp)=>{
                if ('default' in Cmp) return Cmp;
                return {
                    default: Cmp
                };
            }));
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        xcss: $1ae0de3813cee7fd$var$itemIconStyles,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedIcon, {
                label: title
            })
        })
    });
}
const $1ae0de3813cee7fd$var$_default_1 = (0, $76989ca55049fc51$export$7dd73e517d9d8a3)($1ae0de3813cee7fd$var$HeaderIcon);
var $1ae0de3813cee7fd$export$2e2bcd8739ae039 = $1ae0de3813cee7fd$var$_default_1;




const $32d059b94ccba6f8$var$selector = (states)=>{
    return {
        showContextPanel: states.extensionState?.showContextPanel,
        extensionProvider: states.extensionState?.extensionProvider,
        processParametersAfter: states.extensionState?.processParametersAfter
    };
};
function $32d059b94ccba6f8$export$781dfcd068e3a2e0({ editorView: editorView, configPanelId: configPanelId, api: api }) {
    const editorState = editorView.state;
    const { showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersAfter: processParametersAfter } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'extension'
    ], $32d059b94ccba6f8$var$selector);
    (0, $cozmU.useEffect)(()=>{
        const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(editorState, true);
        // Adding checks to bail out early
        if (!nodeWithPos) {
            $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
            return;
        }
        if (showContextPanel && extensionProvider && processParametersAfter) $32d059b94ccba6f8$export$e4eb3d5da2de4919({
            api: api,
            configPanelId: configPanelId,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        else $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
    }, [
        api,
        configPanelId,
        editorState,
        editorView,
        showContextPanel,
        extensionProvider,
        processParametersAfter
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
        };
    }, [
        api,
        configPanelId
    ]);
}
function $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api) {
    const closePanelById = api?.contextPanel?.actions?.closePanelById;
    if (closePanelById) closePanelById(configPanelId);
}
function $32d059b94ccba6f8$export$e4eb3d5da2de4919({ api: api, configPanelId: configPanelId, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos }) {
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    if (showContextPanel) {
        const nodeAttrs = nodeWithPos?.node.attrs;
        const extensionType = nodeAttrs?.extensionType;
        const extensionKey = nodeAttrs?.extensionKey;
        /**
     * Loading extension manifest fails when using
     * 	extensionKey directly from nodeAttrs.
     * Always get extensionKey from getExtensionKeyAndNodeKey to load
     * 	extension manifest successfully.
     */ const [extKey, _] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const HeadeIconWrapper = ()=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1ae0de3813cee7fd$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const HeaderAfterIconElementWrapper = ()=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $923147737bfc3fc6$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const BodyComponent = $32d059b94ccba6f8$export$768c11fa806367e7({
            api: api,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        showContextPanel({
            id: configPanelId,
            headerComponentElements: {
                HeaderIcon: HeadeIconWrapper,
                HeaderAfterIconElement: HeaderAfterIconElementWrapper
            },
            BodyComponent: BodyComponent,
            closeOptions: {
                canClosePanel: async ()=>{
                    // When navigating away from the editor, the editorView is destroyed.
                    if (editorView.isDestroyed) return true;
                    const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
                    /**
           * 	If context panel is open, then first update extension plugin state.
           * 	Updating extension plugin state will trigger useEffect in useConfigPanelPluginHook,
           * 		which will call hideConfigPanel.
           */ if (extensionState?.showContextPanel) {
                        await $32d059b94ccba6f8$export$237eef05f48e1226({
                            api: api,
                            editorView: editorView
                        });
                        return false;
                    }
                    // Return true if extension plugin state has been updated and hideConfigPanel has been called.
                    return true;
                }
            }
        }, 'push', (0, $fJUEv.CONFIG_PANEL_WIDTH));
    }
}
async function $32d059b94ccba6f8$export$237eef05f48e1226({ api: api, editorView: editorView }) {
    const applyChange = api?.contextPanel?.actions.applyChange;
    // Even if the save failed, we should proceed with closing the panel
    (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
    try {
        await new Promise((resolve, reject)=>{
            (0, $3d915853de2ecd5c$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
        });
    } catch (e) {
        // Even if the save failed, we should proceed with closing the panel
        // eslint-disable-next-line no-console
        console.error(`Autosave failed with error`, e);
    }
}
const $32d059b94ccba6f8$export$768c11fa806367e7 = ({ api: api, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorState = editorView.state;
    const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorState);
    const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, processParametersBefore: processParametersBefore } = extensionState;
    const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
    const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
    return ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            padding: "space.200",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4d99bbf49073cd12$export$7ceebdb305e167df), {
                duration: 5000,
                visible: true,
                children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a7a68fea06620b8$export$2e2bcd8739ae039), {
                        api: api,
                        showHeader: true,
                        closeOnEsc: true,
                        extensionType: extensionType,
                        extensionKey: extKey,
                        nodeKey: nodeKey,
                        extensionParameters: parameters,
                        parameters: configParams,
                        extensionProvider: extensionProvider,
                        autoSaveTrigger: autoSaveResolve,
                        autoSaveReject: autoSaveReject,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: async (updatedParameters)=>{
                            await (0, $fc213d5917462889$export$2f221d4ebb46923c)(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                            onSaveEnded();
                            if (autoSaveResolve) autoSaveResolve();
                        },
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onCancel: ()=>$32d059b94ccba6f8$export$237eef05f48e1226({
                                api: api,
                                editorView: editorView
                            }),
                        featureFlags: featureFlags,
                        // Remove below prop when cleaning platform_editor_ai_object_sidebar_injection FG
                        // Becuase it will always be true
                        usingObjectSidebarPanel: true
                    });
                }
            })
        });
};


const $bd6dbeefb66a82f7$export$feb99ebbc74a9193 = ({ config: options = {}, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const configPanelId = `${(0, $fJUEv.CONFIG_PANEL_ID)}-${(0, $03RpJ.default)()}`;
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    //Note: This is a hack to get the editor view reference in the plugin. Copied from table plugin.
    //This is needed to get the current selection in the editor
    const editorViewRef = {
        current: null
    };
    const extensionLoadingHandlers = {};
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    return {
        name: 'extension',
        nodes () {
            const extensionNodes = [
                {
                    name: 'extension',
                    node: (0, $hVgcP.extension)
                },
                {
                    name: 'bodiedExtension',
                    node: (0, $b098027f4699dcb1$export$1a85854d3d541a64)()
                },
                {
                    name: 'inlineExtension',
                    node: (0, $20WsY.inlineExtension)
                },
                {
                    name: 'extensionFrame',
                    node: (0, $ixHGM.extensionFrame)
                },
                {
                    name: 'multiBodiedExtension',
                    node: (0, $ixHGM.multiBodiedExtension)
                }
            ];
            return extensionNodes;
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1).getState(state);
            return {
                showContextPanel: pluginState?.showContextPanel,
                extensionProvider: pluginState?.extensionProvider,
                processParametersAfter: pluginState?.processParametersAfter
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'extension',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const extensionHandlers = options.extensionHandlers || {};
                        return (0, $584598053f9859f0$export$ae829ec7b2625219)(dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
                            appearance: options.appearance,
                            getExtensionHeight: options.getExtensionHeight,
                            allowAIGeneratedContentMotion: options.allowAIGeneratedContentMotion
                        }, featureFlags, options?.__rendererExtensionOptions, getIntl());
                    }
                },
                {
                    name: 'extensionKeymap',
                    plugin: ()=>(0, $d40259b0c24668cb$export$2e2bcd8739ae039)(api?.contextPanel?.actions.applyChange)
                },
                {
                    name: 'extensionUniqueId',
                    plugin: ()=>(0, $f28c64404a6658d7$export$ae829ec7b2625219)()
                },
                {
                    name: 'extensionEditorViewRef',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                },
                {
                    name: 'macro',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>(0, $bf6f7e4036588680$export$ae829ec7b2625219)(dispatch, providerFactory)
                }
            ];
        },
        actions: {
            api: ()=>{
                return (0, $92573c06ef675309$export$5c70dcf0377b6800)({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorView: editorViewRef.current,
                    applyChange: api?.contextPanel?.actions.applyChange,
                    editorAnalyticsAPI: api?.analytics?.actions
                });
            },
            getExtensionLoadingHandlers: ()=>extensionLoadingHandlers,
            insertMacroFromMacroBrowser: (0, $783fd49d73f6388e$export$4ec44b2939e261e2)(api?.analytics?.actions),
            insertOrReplaceExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5313dd79acf665fc$export$f151d046c10e64b5)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            insertOrReplaceBodiedExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5313dd79acf665fc$export$8ee156b55126996c)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            editSelectedExtension: (0, $5313dd79acf665fc$export$1efb7858e16078f5)({
                editorViewRef: editorViewRef,
                editorAnalyticsAPI: api?.analytics?.actions,
                applyChangeToContextPanel: api?.contextPanel?.actions.applyChange
            }),
            registerExtensionLoadingHandler: ({ extensionType: extensionType, handler: handler })=>{
                extensionLoadingHandlers[extensionType] = handler;
                return ()=>{
                    if (extensionLoadingHandlers[extensionType] === handler) delete extensionLoadingHandlers[extensionType];
                };
            },
            runMacroAutoConvert: $783fd49d73f6388e$export$774dc72aee79b8eb,
            forceAutoSave: $3d915853de2ecd5c$export$265d048971b3d878
        },
        pluginsOptions: {
            floatingToolbar: (0, $7d58a2ee0cc4b964$export$86ce8f8241c20a3)({
                breakoutEnabled: options.breakoutEnabled,
                copyEnabled: options.copyEnabled,
                deleteEnabled: options.deleteEnabled,
                extensionApi: api,
                getUnsupportedContent: options.getUnsupportedContent
            }),
            contextPanel: // if showContextPanel action is not available, or platform_editor_ai_object_sidebar_injection feature flag is off
            // 	then keep using old context panel.
            !showContextPanel || !(0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? (0, $fc213d5917462889$export$7c8c60c0acb92731)(()=>editorViewRef.current ?? undefined)(api, featureFlags) : undefined
        },
        usePluginHook: showContextPanel && (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? ({ editorView: editorView })=>{
            (0, $32d059b94ccba6f8$export$781dfcd068e3a2e0)({
                api: api,
                configPanelId: configPanelId,
                editorView: editorView
            });
        } : undefined
    };
};
module.exports["extensionPlugin"] = $bd6dbeefb66a82f7$export$feb99ebbc74a9193;

});

parcelRegister("fJUEv", function(module, exports) {
// Allowlist of { macroKey: parameterName[] } for analytics logging
const $2549d8cb406fc6f5$export$2a99ab8c82908148 = {
    children: [
        'all',
        'first',
        'depth',
        'style',
        'excerptType',
        'sort',
        'reverse'
    ],
    'recently-updated': [
        'width',
        'types',
        'max',
        'theme',
        'showProfilePic',
        'hideHeading'
    ],
    excerpt: [
        'hidden'
    ]
};
const $2549d8cb406fc6f5$export$d17c9f402b8c93c8 = [
    'enum',
    'number',
    'boolean'
];
const $2549d8cb406fc6f5$export$57e7dbe0bbfe09b5 = 320;
const $2549d8cb406fc6f5$export$cb69418acbe13bc2 = 'extensions-panel';
module.exports["ALLOWED_LOGGED_MACRO_PARAMS"] = $2549d8cb406fc6f5$export$2a99ab8c82908148;
module.exports["ALLOWED_PARAM_TYPES"] = $2549d8cb406fc6f5$export$d17c9f402b8c93c8;
module.exports["CONFIG_PANEL_WIDTH"] = $2549d8cb406fc6f5$export$57e7dbe0bbfe09b5;
module.exports["CONFIG_PANEL_ID"] = $2549d8cb406fc6f5$export$cb69418acbe13bc2;

});

parcelRegister("fjZlw", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3nm9z = parcelRequire("3nm9z");


var $1VhsF = parcelRequire("1VhsF");


var $lfoFx = parcelRequire("lfoFx");

function $1b8a019e594923bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b8a019e594923bc$var$spinnerWrapperStyles = {
    name: "kcqyy5",
    styles: "display:flex;justify-content:center;margin-top:var(--ds-space-800, 64px)"
};
const $1b8a019e594923bc$var$errorWrapperStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $1b8a019e594923bc$var$LoadingStateWithErrorHandling = (0, $kSwu1.injectIntl)((props)=>{
    if (props.error) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1b8a019e594923bc$var$errorWrapperStyles,
        "data-testid": "ConfigPanelLoadingError"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1VhsF.default), {
        appearance: "error"
    }, props.intl.formatMessage((0, $3nm9z.messages).panelLoadingError)));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1b8a019e594923bc$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfoFx.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
});
const $1b8a019e594923bc$var$LoadingState = (props)=>$1b8a019e594923bc$var$LoadingStateWithErrorHandling(props);
var $1b8a019e594923bc$export$2e2bcd8739ae039 = $1b8a019e594923bc$var$LoadingState;
module.exports["default"] = $1b8a019e594923bc$export$2e2bcd8739ae039;

});

parcelRegister("4odIu", function(module, exports) {

let $33240b27c454a7b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $33240b27c454a7b0$var$load("3vH95"),
    $33240b27c454a7b0$var$load("fnO1K"),
    $33240b27c454a7b0$var$load("6wr18"),
    $33240b27c454a7b0$var$load("eUsnQ"),
    $33240b27c454a7b0$var$load("6C7Vr"),
    $33240b27c454a7b0$var$load("Wowvf"),
    $33240b27c454a7b0$var$load("iWnyc"),
    $33240b27c454a7b0$var$load("hhss7"),
    $33240b27c454a7b0$var$load("7EorR"),
    $33240b27c454a7b0$var$load("ffEVr"),
    $33240b27c454a7b0$var$load("8GyM5")
]).then(()=>parcelRequire('jqjhk'));

});

parcelRegister("jND0n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");




const $aef92eb44b339a57$var$safeError = (message)=>{
    // eslint-disable-next-line no-console
    console.error(message);
};
const $aef92eb44b339a57$var$createAbortController = ()=>{
    if (typeof AbortController === 'undefined') $aef92eb44b339a57$var$safeError('Missing AbortController');
    return new AbortController();
};
function $aef92eb44b339a57$export$daf4e774a28efe06(callback, deps) {
    const abortController = (0, $cozmU.useMemo)(()=>$aef92eb44b339a57$var$createAbortController(), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const abort = (0, $cozmU.useCallback)(()=>abortController.abort(), [
        abortController
    ]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $cozmU.useCallback)(callback, deps);
    (0, $cozmU.useEffect)(()=>{
        const teardown = fn(abortController.signal);
        return ()=>{
            if (typeof teardown === 'function') teardown();
            abort();
        };
    }, [
        abortController,
        abort,
        fn,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...deps
    ]);
}


function $b16dcb6878bf018c$export$4960a9d54b2095bb(callback, deps, initialValue) {
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $cozmU.useCallback)(callback, deps);
    const [value, setValue] = (0, $cozmU.useState)(initialValue);
    (0, $aef92eb44b339a57$export$daf4e774a28efe06)((signal)=>{
        Promise.resolve(fn()).then((result)=>{
            if (signal.aborted) return;
            setValue(result);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ...deps
    ]);
    return [
        value,
        setValue
    ];
}
module.exports["useStateFromPromise"] = $b16dcb6878bf018c$export$4960a9d54b2095bb;

});

parcelRegister("iVGec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $7D1yr = parcelRequire("7D1yr");


var $5X6fy = parcelRequire("5X6fy");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");

const $bfb9b1580f9516c1$export$bc90872e265d166e = 12;
// Matches the existing `.gridParent` 12px left + 12px right gutter expansion.
const $bfb9b1580f9516c1$var$GRID_GUTTER_WIDTH = 24;
const $bfb9b1580f9516c1$var$key = new (0, $kCECX.PluginKey)('gridPlugin');
const $bfb9b1580f9516c1$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($bfb9b1580f9516c1$var$key, props);
        dispatch(tr);
        return true;
    };
const $bfb9b1580f9516c1$var$sides = [
    'left',
    'right'
];
const $bfb9b1580f9516c1$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $bfb9b1580f9516c1$export$bc90872e265d166e && maxHighlight >= $bfb9b1580f9516c1$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $bfb9b1580f9516c1$export$bc90872e265d166e + size : true);
};
const $bfb9b1580f9516c1$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $7Y8M5.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $bfb9b1580f9516c1$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', $bfb9b1580f9516c1$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }, side));
        gridLines.push(/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $7Y8M5.akEditorBreakoutPadding)) / 2}px`
            }
        }, side + '-bk'));
    });
    return gridLines;
};
const $bfb9b1580f9516c1$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $bfb9b1580f9516c1$export$bc90872e265d166e;
    for(let i = 0; i <= $bfb9b1580f9516c1$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $bfb9b1580f9516c1$export$bc90872e265d166e ? style : undefined
        }, i));
    }
    return gridLines;
};
const $bfb9b1580f9516c1$var$GridLegacy = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, overlayWidth: overlayWidth, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    const gridLines = [
        ...$bfb9b1580f9516c1$var$lineLengthGridLines(highlight),
        ...$bfb9b1580f9516c1$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none',
                width: overlayWidth === undefined ? undefined : `${overlayWidth}px`
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $bfb9b1580f9516c1$var$GridNext = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, overlayWidth: overlayWidth, visible: visible })=>{
    const editorMaxWidth = (0, $7Y8M5.akEditorDefaultLayoutWidth);
    const gridLines = [
        ...$bfb9b1580f9516c1$var$lineLengthGridLines(highlight),
        ...$bfb9b1580f9516c1$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none',
                width: overlayWidth === undefined ? undefined : `${overlayWidth}px`
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $bfb9b1580f9516c1$var$ThemedGridLegacy = (0, $7D1yr.b)($bfb9b1580f9516c1$var$GridLegacy);
const $bfb9b1580f9516c1$var$ThemedGrid = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_core_static_css', 'isEnabled', true), $bfb9b1580f9516c1$var$GridNext, $bfb9b1580f9516c1$var$ThemedGridLegacy);
const $bfb9b1580f9516c1$var$selector = (states)=>{
    return {
        lineLength: states.widthState?.lineLength,
        width: states.widthState?.width,
        visible: states.gridState?.visible,
        gridType: states.gridState?.gridType,
        highlight: states.gridState?.highlight
    };
};
const $bfb9b1580f9516c1$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { lineLength: lineLength, width: width, visible: visible, gridType: gridType, highlight: highlight } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width',
        'grid'
    ], $bfb9b1580f9516c1$var$selector);
    const overlayWidth = (0, $ieeJu.expValEquals)('platform_editor_external_embed_grid_fix', 'isEnabled', true) ? (lineLength || width || (0, $7Y8M5.akEditorFullPageMaxWidth)) + $bfb9b1580f9516c1$var$GRID_GUTTER_WIDTH : undefined;
    if (!visible || !highlight) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($bfb9b1580f9516c1$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: width ?? (0, $7Y8M5.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: visible,
        gridType: gridType ?? 'full',
        highlight: highlight,
        overlayWidth: overlayWidth
    });
};
const $bfb9b1580f9516c1$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $bfb9b1580f9516c1$var$gridPMPlugin = new (0, $kpCD8.SafePlugin)({
    key: $bfb9b1580f9516c1$var$key,
    state: {
        init () {
            return $bfb9b1580f9516c1$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($bfb9b1580f9516c1$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $bfb9b1580f9516c1$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $bfb9b1580f9516c1$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $bfb9b1580f9516c1$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$bfb9b1580f9516c1$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($bfb9b1580f9516c1$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    };
};
module.exports["gridPlugin"] = $bfb9b1580f9516c1$export$c090e341e8f725a9;

});

parcelRegister("gxKDp", function(module, exports) {

var $hade9 = parcelRequire("hade9");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");


var $bI2nS = parcelRequire("bI2nS");

const $ddec03442dd66a9a$export$b5524c7a5a82630a = {
    url: {
        title: (0, $bI2nS.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9)))
    },
    inline: {
        title: (0, $bI2nS.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu)))
    },
    block: {
        title: (0, $bI2nS.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4)))
    },
    embed: {
        title: (0, $bI2nS.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F)))
    }
};
module.exports["appearancePropsMap"] = $ddec03442dd66a9a$export$b5524c7a5a82630a;

});

parcelRegister("yNGEI", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $809138f2c808c2d9$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
}
module.exports["calcPxFromPct"] = $809138f2c808c2d9$export$e70e278a1f662f8d;

});

parcelRegister("9aSOx", function(module, exports) {
"use strict";
var $6adf91262b04985e$var$__assign = module.exports && module.exports.__assign || function() {
    $6adf91262b04985e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6adf91262b04985e$var$__assign.apply(this, arguments);
};
var $6adf91262b04985e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6adf91262b04985e$var$React = $6adf91262b04985e$var$__importStar((parcelRequire("cozmU")));
var $6adf91262b04985e$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $6adf91262b04985e$var$Resizer(props) {
    return $6adf91262b04985e$var$React.createElement("div", {
        className: props.className || '',
        style: $6adf91262b04985e$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $6adf91262b04985e$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $6adf91262b04985e$var$Resizer;

});


$parcel$global.rlb("kD76L")
//# sourceMappingURL=FullPageEditorComponent.c1392979.js.map
